{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "modules": [
    {
      "symbol": "Adder_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Adder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Adder_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Adder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 35123,
      "mass": 3,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Adder_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Adder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 79027,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Adder_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Adder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 186767,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Adder_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Adder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 206963,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Anaconda_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Anaconda",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Anaconda_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Anaconda",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 58787780,
      "mass": 30,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Anaconda_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Anaconda",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 132272505,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Anaconda_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Anaconda",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 312604021,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Anaconda_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Anaconda",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 346406995,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Grade1",
      "category": "standard",
      "name": "Mk II Ablative Lightweight Alloys",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Grade1_Default",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Grade2",
      "category": "standard",
      "name": "Mk II Ablative Reinforced Alloys",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Grade3",
      "category": "standard",
      "name": "Mk II Ablative Military Grade Composite",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Mirrored",
      "category": "standard",
      "name": "Mk II Ablative Mirrored Surface Composite",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "AnacondaMkII_Armour_Reactive",
      "category": "standard",
      "name": "Mk II Ablative Reactive Surface Composite",
      "ship": "Anaconda Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Asp_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Asp Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Asp Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2664461,
      "mass": 21,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Asp Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 5995038,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Asp Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 14168274,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Asp Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 15700339,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Scout_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Asp Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Scout_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Asp Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1584461,
      "mass": 21,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Scout_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Asp Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 3565038,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Scout_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Asp Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 8425374,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Asp_Scout_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Asp Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 9336439,
      "mass": 42,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "BelugaLiner_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Beluga Liner",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "BelugaLiner_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Beluga Liner",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 33813105,
      "mass": 83,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "BelugaLiner_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Beluga Liner",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 76079487,
      "mass": 165,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "BelugaLiner_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Beluga Liner",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 179801189,
      "mass": 165,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "BelugaLiner_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Beluga Liner",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 199243724,
      "mass": 165,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIII_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Cobra MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIII_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Cobra MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 139887,
      "mass": 14,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIII_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Cobra MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 341746,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIII_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Cobra MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 734407,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIII_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Cobra MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 824285,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIV_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Cobra MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIV_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Cobra MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 305887,
      "mass": 14,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIV_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Cobra MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 688246,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIV_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Cobra MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1605907,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkIV_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Cobra MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1802440,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkV_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Cobra MkV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkV_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Cobra MkV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 795784,
      "mass": 14,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkV_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Cobra MkV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1790514,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkV_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Cobra MkV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 4177866,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "CobraMkV_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Cobra MkV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 4689157,
      "mass": 27,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Corsair_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Corsair",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Corsair_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Corsair",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 31721900,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Corsair_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Corsair",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 71374270,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Corsair_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Corsair",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 166539970,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Corsair_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Corsair",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 186921290,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Cutter_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Imperial Cutter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Cutter_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Imperial Cutter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 83587780,
      "mass": 30,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Cutter_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Imperial Cutter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 188072505,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Cutter_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Imperial Cutter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 444478021,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Cutter_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Imperial Cutter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 492540995,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBack_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Diamondback Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBack_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Diamondback Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 225731,
      "mass": 13,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBack_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Diamondback Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 507896,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBack_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Diamondback Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1185090,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBack_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Diamondback Scout",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1330123,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBackXL_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Diamondback Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBackXL_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Diamondback Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 757904,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBackXL_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Diamondback Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1705284,
      "mass": 47,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBackXL_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Diamondback Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 3978996,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "DiamondBackXL_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Diamondback Explorer",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 4465949,
      "mass": 47,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Dolphin_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Dolphin",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Dolphin_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Dolphin",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 534929,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Dolphin_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Dolphin",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1203590,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Dolphin_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Dolphin",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2808378,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Dolphin_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Dolphin",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 3152070,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Eagle_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Eagle_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 26880,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Eagle_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 90048,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Eagle_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 140089,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Eagle_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 150393,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Courier_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Imperial Courier",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Courier_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Imperial Courier",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1017172,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Courier_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Imperial Courier",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2288637,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Courier_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Imperial Courier",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 5408814,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Courier_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Imperial Courier",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 5993688,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Eagle_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Imperial Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Eagle_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Imperial Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 66495,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Eagle_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Imperial Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 222758,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Eagle_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Imperial Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 346549,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Eagle_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Imperial Eagle",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 372039,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Trader_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Imperial Clipper",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Trader_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Imperial Clipper",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 8918344,
      "mass": 30,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Trader_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Imperial Clipper",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 20066274,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Trader_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Imperial Clipper",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 47423294,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Empire_Trader_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Imperial Clipper",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 52551342,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Grade1",
      "category": "standard",
      "name": "Mk II Ablative Lightweight Alloys",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 9743070,
      "mass": 15,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Grade1_Default",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Grade2",
      "category": "standard",
      "name": "Mk II Ablative Reinforced Alloys",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 77944520,
      "mass": 30,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Grade3",
      "category": "standard",
      "name": "Mk II Ablative Military Grade Composite",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 175375160,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Mirrored",
      "category": "standard",
      "name": "Mk II Ablative Mirrored Surface Composite",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 414469960,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Explorer_NX_Armour_Reactive",
      "category": "standard",
      "name": "Mk II Ablative Reactive Surface Composite",
      "ship": "Caspian Explorer",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 459288060,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Corvette_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Federal Corvette",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Corvette_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Federal Corvette",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 75187780,
      "mass": 30,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Corvette_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Federal Corvette",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 169172505,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Corvette_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Federal Corvette",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 399811021,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Corvette_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Federal Corvette",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 443043995,
      "mass": 60,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Federal Dropship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Federal Dropship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 5725682,
      "mass": 44,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Federal Dropship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 12882784,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Federal Dropship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 30446314,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Federal Dropship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 33738581,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_MkII_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Federal Assault Ship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_MkII_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Federal Assault Ship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 7925682,
      "mass": 44,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_MkII_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Federal Assault Ship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 17832784,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_MkII_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Federal Assault Ship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 42144814,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Dropship_MkII_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Federal Assault Ship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 46702081,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Gunship_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Federal Gunship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Gunship_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Federal Gunship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 14325682,
      "mass": 44,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Gunship_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Federal Gunship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 32232784,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Gunship_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Federal Gunship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 76176814,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Federation_Gunship_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Federal Gunship",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 84414081,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "FerDeLance_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Fer-de-Lance",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "FerDeLance_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Fer-de-Lance",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 20626816,
      "mass": 19,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "FerDeLance_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Fer-de-Lance",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 46410336,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "FerDeLance_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Fer-de-Lance",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 109683094,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "FerDeLance_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Fer-de-Lance",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 121543513,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hauler_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Hauler",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hauler_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Hauler",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 42176,
      "mass": 1,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hauler_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Hauler",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 185047,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hauler_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Hauler",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 270295,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hauler_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Hauler",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 282421,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_AdvancedTorpPylon_Fixed_Large",
      "category": "hardpoint",
      "name": "Torpedo Pylon",
      "ship": null,
      "class": 3,
      "rating": "I",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "tp",
      "cost": 157960,
      "mass": 8,
      "power": 0.6,
      "integrity": 64,
      "stats": {
        "ammo": 4,
        "breachdmg": 60,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 4,
        "damage": 120,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 10000,
        "reload": 5,
        "shotspeed": 250,
        "thermload": 55
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_AdvancedTorpPylon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Torpedo Pylon",
      "ship": null,
      "class": 2,
      "rating": "I",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "tp",
      "cost": 44800,
      "mass": 4,
      "power": 0.4,
      "integrity": 51,
      "stats": {
        "ammo": 2,
        "breachdmg": 60,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 1,
        "damage": 120,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 10000,
        "reload": 5,
        "shotspeed": 250,
        "thermload": 50
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_AdvancedTorpPylon_Fixed_Small",
      "category": "hardpoint",
      "name": "Torpedo Pylon",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "tp",
      "cost": 11200,
      "mass": 2,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "ammo": 1,
        "breachdmg": 60,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 1,
        "damage": 120,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 10000,
        "reload": 5,
        "shotspeed": 250,
        "thermload": 45
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_AntiUnknownShutdown_Tiny",
      "category": "utility",
      "name": "Shutdown Field Neutraliser",
      "ship": null,
      "class": 0,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": "sfn",
      "cost": 63000,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 35,
      "stats": {
        "passive": 1,
        "activepower": 0.25,
        "cooldown": 10,
        "duration": 1,
        "range": 3000
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_AntiUnknownShutdown_Tiny_V2",
      "category": "utility",
      "name": "Thargoid Pulse Neutraliser",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sfn",
      "cost": 150000,
      "mass": 3,
      "power": 0.4,
      "integrity": 70,
      "stats": {
        "passive": 1,
        "activepower": 0.33,
        "cooldown": 10,
        "duration": 1,
        "range": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Large",
      "category": "hardpoint",
      "name": "AX Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 1352250,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 128,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 12,
        "damage": 64,
        "distdraw": 0.24,
        "falloff": 10000,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Large_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmre",
      "cost": 1703835,
      "mass": 8,
      "power": 1.72,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 128,
        "breachdmg": 0,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 12,
        "damage": 77,
        "distdraw": 0.24,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 1250,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Medium",
      "category": "hardpoint",
      "name": "AX Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 540900,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 64,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 8,
        "damage": 64,
        "distdraw": 0.14,
        "falloff": 10000,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 2.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Medium_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmre",
      "cost": 681534,
      "mass": 4,
      "power": 1.3,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 64,
        "breachdmg": 0,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 8,
        "damage": 77,
        "distdraw": 0.14,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 1250,
        "thermload": 2.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Turret_Large",
      "category": "hardpoint",
      "name": "AX Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Turreted",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 4056750,
      "mass": 8,
      "power": 1.75,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 128,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 12,
        "damage": 64,
        "distdraw": 0.14,
        "falloff": 10000,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 1.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Turret_Large_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": "Dumbfire",
      "group": "axmre",
      "cost": 5347534,
      "mass": 8,
      "power": 1.85,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 128,
        "breachdmg": 0,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 12,
        "damage": 64,
        "distdraw": 0.14,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 1250,
        "thermload": 1.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Turret_Medium",
      "category": "hardpoint",
      "name": "AX Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Turreted",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 2022700,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 64,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 8,
        "damage": 50,
        "distdraw": 0.08,
        "falloff": 10000,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 1.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Turret_Medium_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": "Dumbfire",
      "group": "axmre",
      "cost": 2666286,
      "mass": 4,
      "power": 1.3,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 64,
        "breachdmg": 0,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 8,
        "damage": 64,
        "distdraw": 0.08,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 1250,
        "thermload": 1.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Fixed_Large",
      "category": "hardpoint",
      "name": "AX Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "axmc",
      "cost": 1181500,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 5.2,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 6.1,
        "distdraw": 0.18,
        "falloff": 2000,
        "fireint": 0.17,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Fixed_Large_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "axmce",
      "cost": 1360322,
      "mass": 8,
      "power": 0.69,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 6.2,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 7.3,
        "distdraw": 0.18,
        "falloff": 2000,
        "fireint": 0.17,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.28
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "AX Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "axmc",
      "cost": 379000,
      "mass": 4,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 2.8,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 3.3,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Fixed_Medium_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "axmce",
      "cost": 455077,
      "mass": 4,
      "power": 0.48,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 3.3,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 3.9,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.18
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Gimbal_Large",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "axmce",
      "cost": 2390460,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 5.2,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 6.3,
        "distdraw": 0.18,
        "falloff": 2000,
        "fireint": 0.17,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.28
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "axmce",
      "cost": 1197644,
      "mass": 4,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 3.1,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 3.7,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.18
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Turret_Large",
      "category": "hardpoint",
      "name": "AX Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "axmc",
      "cost": 3821600,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 0.8,
        "breachmax": 0.5,
        "breachmin": 0.5,
        "clip": 90,
        "damage": 3.3,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.16,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Turret_Large_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "axmce",
      "cost": 4588709,
      "mass": 8,
      "power": 0.69,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 1,
        "breachmax": 0.5,
        "breachmin": 0.5,
        "clip": 90,
        "damage": 3.9,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.16,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Turret_Medium",
      "category": "hardpoint",
      "name": "AX Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "axmc",
      "cost": 1826500,
      "mass": 4,
      "power": 0.5,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 0.4,
        "breachmax": 0.5,
        "breachmin": 0.5,
        "clip": 90,
        "damage": 1.7,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.16,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATMultiCannon_Turret_Medium_V2",
      "category": "hardpoint",
      "name": "Enhanced AX Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "axmce",
      "cost": 2193297,
      "mass": 4,
      "power": 0.52,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 0.5,
        "breachmax": 0.5,
        "breachmin": 0.5,
        "clip": 90,
        "damage": 2,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.16,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATVentDisruptorPylon_Fixed_Large",
      "category": "hardpoint",
      "name": "Guardian Nanite Torpedo Pylon",
      "ship": null,
      "class": 3,
      "rating": "I",
      "mount": "Fixed",
      "guidance": null,
      "group": "ntp",
      "cost": 1627419,
      "mass": 5,
      "power": 0.7,
      "integrity": 80,
      "stats": {
        "ammo": 125,
        "breachdmg": 0,
        "clip": 1,
        "damage": 0,
        "distdraw": 0,
        "fireint": 2,
        "reload": 3,
        "shotspeed": 1000,
        "thermload": 35
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ATVentDisruptorPylon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Guardian Nanite Torpedo Pylon",
      "ship": null,
      "class": 2,
      "rating": "I",
      "mount": "Fixed",
      "guidance": null,
      "group": "ntp",
      "cost": 843170,
      "mass": 3,
      "power": 0.4,
      "integrity": 50,
      "stats": {
        "ammo": 64,
        "breachdmg": 0,
        "clip": 1,
        "damage": 0,
        "distdraw": 0,
        "fireint": 2,
        "reload": 3,
        "shotspeed": 1000,
        "thermload": 35
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Large",
      "category": "hardpoint",
      "name": "Seeker Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 1471030,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "ammo": 36,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "fireint": 3,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Large",
      "category": "mercgear",
      "name": "Lockdown Seeker Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 1471030,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "ammo": 36,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "fireint": 3,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Large",
      "category": "mercgear",
      "name": "Exposing Missiles",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 1471030,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "ammo": 36,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "fireint": 3,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium",
      "category": "hardpoint",
      "name": "Seeker Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 512400,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "eps": 0.07,
        "fireint": 3,
        "hps": 1.08,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium",
      "category": "mercgear",
      "name": "Drag Seeker Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 512400,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "eps": 0.07,
        "fireint": 3,
        "hps": 1.08,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium",
      "category": "mercgear",
      "name": "Lightweight Thermal Seeker Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 512400,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "eps": 0.07,
        "fireint": 3,
        "hps": 1.08,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium",
      "category": "mercgear",
      "name": "Lockdown Seeker Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 512400,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "eps": 0.07,
        "fireint": 3,
        "hps": 1.08,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Small",
      "category": "hardpoint",
      "name": "Seeker Missile Rack",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 72600,
      "mass": 2,
      "power": 0.6,
      "integrity": 40,
      "stats": {
        "ammo": 6,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "fireint": 3,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Huge",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 2396160,
      "mass": 16,
      "power": 2.61,
      "integrity": 80,
      "stats": {
        "breachdmg": 33.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 41.38,
        "distdraw": 8.19,
        "falloff": 600,
        "piercing": 60,
        "range": 3000,
        "thermload": 9.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Huge",
      "category": "mercgear",
      "name": "Overloaded Beam Laser",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 2396160,
      "mass": 16,
      "power": 2.61,
      "integrity": 80,
      "stats": {
        "breachdmg": 33.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 41.38,
        "distdraw": 8.19,
        "falloff": 600,
        "piercing": 60,
        "range": 3000,
        "thermload": 9.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Large",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 1177600,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "breachdmg": 20.6,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 25.78,
        "distdraw": 5.1,
        "falloff": 600,
        "piercing": 50,
        "range": 3000,
        "thermload": 7.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Medium",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 299520,
      "mass": 4,
      "power": 1.01,
      "integrity": 51,
      "stats": {
        "breachdmg": 12.8,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 15.96,
        "distdraw": 3.16,
        "falloff": 600,
        "piercing": 35,
        "range": 3000,
        "thermload": 5.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Small",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 37430,
      "mass": 2,
      "power": 0.62,
      "integrity": 40,
      "stats": {
        "breachdmg": 7.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 9.8,
        "distdraw": 1.94,
        "falloff": 600,
        "piercing": 18,
        "range": 3000,
        "thermload": 3.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Fixed_Small_Heat",
      "category": "hardpoint",
      "name": "Retributor Beam Laser",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "bl",
      "cost": 56150,
      "mass": 2,
      "power": 0.62,
      "integrity": 40,
      "stats": {
        "breachdmg": 3.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 4.9,
        "distdraw": 2.52,
        "falloff": 600,
        "piercing": 18,
        "range": 3000,
        "thermload": 2.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Gimbal_Huge",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Gimballed",
      "guidance": null,
      "group": "bl",
      "cost": 8746160,
      "mass": 16,
      "power": 2.57,
      "integrity": 80,
      "stats": {
        "breachdmg": 26.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 32.68,
        "distdraw": 8.99,
        "falloff": 600,
        "piercing": 60,
        "range": 3000,
        "thermload": 10.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Gimbal_Large",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "bl",
      "cost": 2396160,
      "mass": 8,
      "power": 1.6,
      "integrity": 64,
      "stats": {
        "breachdmg": 16.2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 20.28,
        "distdraw": 5.58,
        "falloff": 600,
        "piercing": 50,
        "range": 3000,
        "thermload": 7.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Gimballed",
      "guidance": null,
      "group": "bl",
      "cost": 500600,
      "mass": 4,
      "power": 1,
      "integrity": 51,
      "stats": {
        "breachdmg": 10,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 12.52,
        "distdraw": 3.44,
        "falloff": 600,
        "piercing": 35,
        "range": 3000,
        "thermload": 5.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Gimbal_Small",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "bl",
      "cost": 74650,
      "mass": 2,
      "power": 0.6,
      "integrity": 40,
      "stats": {
        "breachdmg": 6.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 7.66,
        "distdraw": 2.11,
        "falloff": 600,
        "piercing": 18,
        "range": 3000,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Turret_Large",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "bl",
      "cost": 19399600,
      "mass": 8,
      "power": 1.51,
      "integrity": 64,
      "stats": {
        "breachdmg": 11.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 14.34,
        "distdraw": 3.51,
        "falloff": 600,
        "piercing": 50,
        "range": 3000,
        "thermload": 5.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Turret_Medium",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "bl",
      "cost": 2099900,
      "mass": 4,
      "power": 0.93,
      "integrity": 51,
      "stats": {
        "breachdmg": 7.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 8.82,
        "distdraw": 2.16,
        "falloff": 600,
        "piercing": 35,
        "range": 3000,
        "thermload": 3.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_BeamLaser_Turret_Small",
      "category": "hardpoint",
      "name": "Beam Laser",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "bl",
      "cost": 500000,
      "mass": 2,
      "power": 0.57,
      "integrity": 40,
      "stats": {
        "breachdmg": 4.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 5.4,
        "distdraw": 1.32,
        "falloff": 600,
        "eps": 1.32,
        "hps": 2.4,
        "piercing": 18,
        "range": 3000,
        "thermload": 2.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Fixed_Huge",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "c",
      "cost": 2700800,
      "mass": 16,
      "power": 0.92,
      "integrity": 80,
      "stats": {
        "ammo": 120,
        "breachdmg": 63.2,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 6,
        "damage": 82.1,
        "distdraw": 1.61,
        "falloff": 4500,
        "fireint": 2.63,
        "eps": 0.644,
        "hps": 1.92,
        "piercing": 90,
        "range": 4500,
        "reload": 3,
        "shotspeed": 900,
        "thermload": 4.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Fixed_Huge",
      "category": "mercgear",
      "name": "Force Impact Cannon",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "c",
      "cost": 2700800,
      "mass": 16,
      "power": 0.92,
      "integrity": 80,
      "stats": {
        "ammo": 120,
        "breachdmg": 63.2,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 6,
        "damage": 82.1,
        "distdraw": 1.61,
        "falloff": 4500,
        "fireint": 2.63,
        "eps": 0.644,
        "hps": 1.92,
        "piercing": 90,
        "range": 4500,
        "reload": 3,
        "shotspeed": 900,
        "thermload": 4.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Fixed_Large",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "c",
      "cost": 675200,
      "mass": 8,
      "power": 0.67,
      "integrity": 64,
      "stats": {
        "ammo": 120,
        "breachdmg": 42.3,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 6,
        "damage": 54.94,
        "distdraw": 1.07,
        "falloff": 4000,
        "fireint": 2.38,
        "piercing": 70,
        "range": 4000,
        "reload": 3,
        "shotspeed": 959.232605,
        "thermload": 3.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "c",
      "cost": 168430,
      "mass": 4,
      "power": 0.49,
      "integrity": 51,
      "stats": {
        "ammo": 120,
        "breachdmg": 28,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 6,
        "damage": 36.5,
        "distdraw": 0.7,
        "falloff": 3500,
        "fireint": 2.17,
        "piercing": 50,
        "range": 3500,
        "reload": 3,
        "shotspeed": 1051.051025,
        "thermload": 2.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Fixed_Small",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "c",
      "cost": 21100,
      "mass": 2,
      "power": 0.34,
      "integrity": 40,
      "stats": {
        "ammo": 120,
        "breachdmg": 17.1,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 6,
        "damage": 22.5,
        "distdraw": 0.46,
        "falloff": 3000,
        "fireint": 2,
        "piercing": 35,
        "range": 3000,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Gimbal_Huge",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": "Gimballed",
      "guidance": null,
      "group": "c",
      "cost": 5401600,
      "mass": 16,
      "power": 1.03,
      "integrity": 80,
      "stats": {
        "ammo": 100,
        "breachdmg": 46.7,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 56.58,
        "distdraw": 1.72,
        "falloff": 4500,
        "fireint": 2.5,
        "eps": 0.688,
        "hps": 1.76,
        "piercing": 90,
        "range": 4500,
        "reload": 4,
        "shotspeed": 750,
        "thermload": 4.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Gimbal_Large",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "c",
      "cost": 1350400,
      "mass": 8,
      "power": 0.75,
      "integrity": 64,
      "stats": {
        "ammo": 100,
        "breachdmg": 30.9,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 37.39,
        "distdraw": 1.14,
        "falloff": 4000,
        "fireint": 2.27,
        "eps": 0.456,
        "hps": 1.16,
        "piercing": 70,
        "range": 4000,
        "reload": 4,
        "shotspeed": 800,
        "thermload": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Gimballed",
      "guidance": null,
      "group": "c",
      "cost": 337600,
      "mass": 4,
      "power": 0.54,
      "integrity": 51,
      "stats": {
        "ammo": 100,
        "breachdmg": 20.3,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 24.5,
        "distdraw": 0.75,
        "falloff": 3500,
        "fireint": 2.08,
        "piercing": 50,
        "range": 3500,
        "reload": 4,
        "shotspeed": 875,
        "thermload": 1.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Gimbal_Medium_Burst",
      "category": "hardpoint",
      "name": "Concord Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Gimballed",
      "guidance": null,
      "group": "c",
      "cost": 314620,
      "mass": 4,
      "power": 0.64,
      "integrity": 51,
      "stats": {
        "ammo": 300,
        "breachdmg": 13.9,
        "breachmax": 0.9,
        "breachmin": 0.6,
        "burst": 3,
        "burstrof": 4,
        "clip": 9,
        "damage": 14.63,
        "distdraw": 0.75,
        "falloff": 3500,
        "fireint": 2.26,
        "eps": 0.688,
        "hps": 1.76,
        "piercing": 42,
        "range": 3500,
        "reload": 4,
        "shotspeed": 1300,
        "thermload": 1.92
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Gimbal_Small",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "c",
      "cost": 42200,
      "mass": 2,
      "power": 0.38,
      "integrity": 40,
      "stats": {
        "ammo": 100,
        "breachdmg": 13.2,
        "breachmax": 0.9,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 16,
        "distdraw": 0.48,
        "falloff": 3000,
        "fireint": 1.92,
        "piercing": 35,
        "range": 3000,
        "reload": 4,
        "shotspeed": 1000,
        "thermload": 1.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Turret_Large",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "c",
      "cost": 16204800,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "ammo": 100,
        "breachdmg": 25.14,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 30.4,
        "distdraw": 0.53,
        "falloff": 4000,
        "fireint": 2.72,
        "piercing": 70,
        "range": 4000,
        "reload": 4,
        "shotspeed": 800,
        "thermload": 1.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Turret_Medium",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "c",
      "cost": 4051200,
      "mass": 4,
      "power": 0.45,
      "integrity": 51,
      "stats": {
        "ammo": 100,
        "breachdmg": 16.3,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 19.77,
        "distdraw": 0.34,
        "falloff": 3500,
        "fireint": 2.5,
        "piercing": 50,
        "range": 3500,
        "reload": 4,
        "shotspeed": 875,
        "thermload": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Cannon_Turret_Small",
      "category": "hardpoint",
      "name": "Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "c",
      "cost": 506400,
      "mass": 2,
      "power": 0.32,
      "integrity": 40,
      "stats": {
        "ammo": 100,
        "breachdmg": 10.6,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "clip": 5,
        "damage": 12.75,
        "distdraw": 0.22,
        "falloff": 3000,
        "fireint": 2.31,
        "piercing": 35,
        "range": 3000,
        "reload": 4,
        "shotspeed": 1000,
        "thermload": 0.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CargoScanner_Size0_Class1",
      "category": "utility",
      "name": "Cargo Scanner",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cs",
      "cost": 13544,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 32,
      "stats": {
        "angle": 15,
        "range": 2000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CargoScanner_Size0_Class2",
      "category": "utility",
      "name": "Cargo Scanner",
      "ship": null,
      "class": 0,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "cs",
      "cost": 40633,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 24,
      "stats": {
        "angle": 15,
        "range": 2500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CargoScanner_Size0_Class3",
      "category": "utility",
      "name": "Cargo Scanner",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "cs",
      "cost": 121899,
      "mass": 1.3,
      "power": 0.8,
      "integrity": 40,
      "stats": {
        "angle": 15,
        "range": 3000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CargoScanner_Size0_Class4",
      "category": "utility",
      "name": "Cargo Scanner",
      "ship": null,
      "class": 0,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "cs",
      "cost": 365698,
      "mass": 1.3,
      "power": 1.6,
      "integrity": 56,
      "stats": {
        "angle": 15,
        "range": 3500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CargoScanner_Size0_Class5",
      "category": "utility",
      "name": "Cargo Scanner",
      "ship": null,
      "class": 0,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "cs",
      "cost": 1097095,
      "mass": 1.3,
      "power": 3.2,
      "integrity": 48,
      "stats": {
        "angle": 15,
        "range": 4000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CausticMissile_Fixed_Medium",
      "category": "hardpoint",
      "name": "Enzyme Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "tbem",
      "cost": 480501,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "fireint": 2,
        "damage": 5,
        "distdraw": 0.08,
        "thermload": 1.5,
        "piercing": 60,
        "shotspeed": 750,
        "clip": 8,
        "ammo": 64,
        "reload": 5,
        "breachdmg": 0,
        "breachmin": 0.8,
        "breachmax": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CausticMissile_Fixed_Medium",
      "category": "mercgear",
      "name": "High-Yield Enzyme Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "tbem",
      "cost": 480501,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "fireint": 2,
        "damage": 5,
        "distdraw": 0.08,
        "thermload": 1.5,
        "piercing": 60,
        "shotspeed": 750,
        "clip": 8,
        "ammo": 64,
        "reload": 5,
        "breachdmg": 0,
        "breachmin": 0.8,
        "breachmax": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CausticSinkLauncher_Turret_Tiny",
      "category": "utility",
      "name": "Caustic Sink Launcher",
      "ship": null,
      "class": 0,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "csl",
      "cost": 50000,
      "mass": 1.7,
      "power": 0.6,
      "integrity": 45,
      "stats": {
        "ammo": 5,
        "ammocost": 10,
        "clip": 1,
        "distdraw": 2,
        "eps": 0.4,
        "fireint": 5,
        "passive": 1,
        "reload": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ChaffLauncher_Tiny",
      "category": "utility",
      "name": "Chaff Launcher",
      "ship": null,
      "class": 0,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "ch",
      "cost": 8500,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 20,
      "stats": {
        "ammo": 10,
        "ammocost": 100,
        "clip": 1,
        "distdraw": 4,
        "duration": 20,
        "fireint": 1,
        "passive": 1,
        "reload": 10,
        "thermload": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CloudScanner_Size0_Class1",
      "category": "utility",
      "name": "Frame Shift Wake Scanner",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ws",
      "cost": 13544,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 32,
      "stats": {
        "range": 2000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CloudScanner_Size0_Class2",
      "category": "utility",
      "name": "Frame Shift Wake Scanner",
      "ship": null,
      "class": 0,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ws",
      "cost": 40633,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 24,
      "stats": {
        "range": 2500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CloudScanner_Size0_Class3",
      "category": "utility",
      "name": "Frame Shift Wake Scanner",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ws",
      "cost": 121899,
      "mass": 1.3,
      "power": 0.8,
      "integrity": 40,
      "stats": {
        "range": 3000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CloudScanner_Size0_Class4",
      "category": "utility",
      "name": "Frame Shift Wake Scanner",
      "ship": null,
      "class": 0,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ws",
      "cost": 365698,
      "mass": 1.3,
      "power": 1.6,
      "integrity": 56,
      "stats": {
        "range": 3500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CloudScanner_Size0_Class5",
      "category": "utility",
      "name": "Frame Shift Wake Scanner",
      "ship": null,
      "class": 0,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ws",
      "cost": 1097095,
      "mass": 1.3,
      "power": 3.2,
      "integrity": 48,
      "stats": {
        "range": 4000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CrimeScanner_Size0_Class1",
      "category": "utility",
      "name": "Kill Warrant Scanner",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "kw",
      "cost": 13544,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 32,
      "stats": {
        "range": 2000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CrimeScanner_Size0_Class2",
      "category": "utility",
      "name": "Kill Warrant Scanner",
      "ship": null,
      "class": 0,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "kw",
      "cost": 40633,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 24,
      "stats": {
        "range": 2500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CrimeScanner_Size0_Class3",
      "category": "utility",
      "name": "Kill Warrant Scanner",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "kw",
      "cost": 121899,
      "mass": 1.3,
      "power": 0.8,
      "integrity": 40,
      "stats": {
        "range": 3000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CrimeScanner_Size0_Class4",
      "category": "utility",
      "name": "Kill Warrant Scanner",
      "ship": null,
      "class": 0,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "kw",
      "cost": 365698,
      "mass": 1.3,
      "power": 1.6,
      "integrity": 56,
      "stats": {
        "range": 3500,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_CrimeScanner_Size0_Class5",
      "category": "utility",
      "name": "Kill Warrant Scanner",
      "ship": null,
      "class": 0,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "kw",
      "cost": 1097095,
      "mass": 1.3,
      "power": 3.2,
      "integrity": 48,
      "stats": {
        "range": 4000,
        "scantime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DrunkMissileRack_Fixed_Medium",
      "category": "hardpoint",
      "name": "Pack-Hound Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Swarm",
      "group": "mr",
      "cost": 768600,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 120,
        "breachdmg": 3,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 12,
        "damage": 7.5,
        "distdraw": 0.24,
        "eps": 1.92,
        "fireint": 0.5,
        "hps": 28.8,
        "piercing": 60,
        "reload": 5,
        "roundspershot": 4,
        "shotspeed": 600,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Large",
      "category": "hardpoint",
      "name": "Missile Rack",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "mr",
      "cost": 1021500,
      "mass": 8,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "ammo": 96,
        "breachdmg": 20,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 12,
        "damage": 50,
        "distdraw": 0.24,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Medium",
      "category": "hardpoint",
      "name": "Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "mr",
      "cost": 240400,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 48,
        "breachdmg": 20,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 12,
        "damage": 50,
        "distdraw": 0.24,
        "eps": 0.12,
        "fireint": 2,
        "hps": 1.8,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Medium_Advanced",
      "category": "hardpoint",
      "name": "Advanced Missile Rack",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "amr",
      "cost": 1471030,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 64,
        "breachdmg": 20,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 12,
        "damage": 50,
        "distdraw": 0.24,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Medium_Lasso",
      "category": "hardpoint",
      "name": "Rocket Propelled FSD Disruptor",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "mr",
      "cost": 1951040,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 48,
        "breachdmg": 16,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 12,
        "damage": 40,
        "distdraw": 0.24,
        "fireint": 3,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Small",
      "category": "hardpoint",
      "name": "Missile Rack",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "mr",
      "cost": 32175,
      "mass": 2,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "ammo": 16,
        "breachdmg": 20,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 8,
        "damage": 50,
        "distdraw": 0.24,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_DumbfireMissileRack_Fixed_Small_Advanced",
      "category": "hardpoint",
      "name": "Advanced Missile Rack",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "amr",
      "cost": 32180,
      "mass": 2,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "ammo": 64,
        "breachdmg": 20,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 8,
        "damage": 50,
        "distdraw": 0.24,
        "fireint": 2,
        "piercing": 60,
        "reload": 5,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ElectronicCountermeasure_Tiny",
      "category": "utility",
      "name": "Electronic Countermeasure",
      "ship": null,
      "class": 0,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": "ec",
      "cost": 12500,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 20,
      "stats": {
        "activepower": 4,
        "chargeup": 3,
        "cooldown": 10,
        "range": 3000,
        "reload": 10,
        "thermload": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_FlakMortar_Fixed_Medium",
      "category": "hardpoint",
      "name": "Remote Release Flak Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "rfl",
      "cost": 261800,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 32,
        "breachdmg": 1.7,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 1,
        "damage": 34,
        "distdraw": 0.24,
        "falloff": 100000,
        "fireint": 2,
        "piercing": 60,
        "reload": 2,
        "shotspeed": 550,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_FlakMortar_Turret_Medium",
      "category": "hardpoint",
      "name": "Remote Release Flak Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Turreted",
      "guidance": null,
      "group": "rfl",
      "cost": 1259200,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 32,
        "breachdmg": 1.7,
        "breachmax": 1,
        "breachmin": 1,
        "clip": 1,
        "damage": 34,
        "distdraw": 0.24,
        "falloff": 100000,
        "fireint": 2,
        "piercing": 60,
        "reload": 2,
        "shotspeed": 550,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_FlechetteLauncher_Fixed_Medium",
      "category": "hardpoint",
      "name": "Remote Release Flechette Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "tbrfl",
      "cost": 353761,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "damage": 13,
        "distdraw": 0.24,
        "fireint": 2,
        "thermload": 3.6,
        "piercing": 80,
        "shotspeed": 550,
        "clip": 1,
        "ammo": 72,
        "reload": 2,
        "breachdmg": 6.5,
        "breachmin": 1,
        "breachmax": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_FlechetteLauncher_Turret_Medium",
      "category": "hardpoint",
      "name": "Remote Release Flechette Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Turreted",
      "guidance": null,
      "group": "tbrfl",
      "cost": 1279200,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "damage": 13,
        "distdraw": 0.24,
        "fireint": 2,
        "thermload": 3.6,
        "piercing": 70,
        "shotspeed": 550,
        "clip": 1,
        "ammo": 72,
        "reload": 2,
        "breachdmg": 6.5,
        "breachmin": 1,
        "breachmax": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_GaussCannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Guardian Gauss Cannon",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "ggc",
      "cost": 543801,
      "mass": 4,
      "power": 2.61,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "ammo": 80,
        "breachdmg": 35,
        "breachmax": 0.4,
        "breachmin": 0.2,
        "burst": 1,
        "clip": 1,
        "damage": 38.5,
        "distdraw": 7.2,
        "falloff": 1500,
        "fireint": 0.83,
        "piercing": 140,
        "range": 3000,
        "reload": 1,
        "thermload": 25
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_GaussCannon_Fixed_Small",
      "category": "hardpoint",
      "name": "Guardian Gauss Cannon",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ggc",
      "cost": 167250,
      "mass": 2,
      "power": 1.91,
      "integrity": 40,
      "stats": {
        "experimental": true,
        "ammo": 80,
        "breachdmg": 11,
        "breachmax": 0.4,
        "breachmin": 0.2,
        "clip": 1,
        "damage": 22,
        "distdraw": 3.8,
        "falloff": 1500,
        "fireint": 0.83,
        "piercing": 140,
        "range": 3000,
        "reload": 1,
        "thermload": 15
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Fixed_Large",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "gpc",
      "cost": 1423301,
      "mass": 8,
      "power": 3.1,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "damage": 7,
        "distdraw": 2.42,
        "fireint": 0.2,
        "thermload": 6.2,
        "piercing": 95,
        "range": 3000,
        "shotspeed": 1200,
        "clip": 15,
        "ammo": 200,
        "reload": 3,
        "breachdmg": 1,
        "breachmin": 0.5,
        "breachmax": 0.8,
        "falloff": 1000
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Fixed_Medium",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "gpc",
      "cost": 567761,
      "mass": 4,
      "power": 2.13,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.7,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 5,
        "distdraw": 1.25,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 80,
        "range": 3500,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 5.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Fixed_Small",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "gpc",
      "cost": 176500,
      "mass": 2,
      "power": 1.4,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.4,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 3,
        "distdraw": 0.68,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 65,
        "range": 3000,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 4.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Turret_Large",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "gpc",
      "cost": 5495200,
      "mass": 8,
      "power": 2.53,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.8,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 6,
        "distdraw": 2.6,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 95,
        "range": 3000,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 6.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Turret_Medium",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "gpc",
      "cost": 1659200,
      "mass": 4,
      "power": 2.01,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 1,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 4,
        "distdraw": 1.4,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 80,
        "range": 3500,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 5.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Turret_Small",
      "category": "hardpoint",
      "name": "Guardian Plasma Charger",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "gpc",
      "cost": 484050,
      "mass": 2,
      "power": 1.6,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.3,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 2,
        "distdraw": 0.8,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 65,
        "range": 3000,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Large",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 1461350,
      "mass": 8,
      "power": 1.68,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "damage": 5.2,
        "distdraw": 1.4,
        "fireint": 0.6,
        "thermload": 2.2,
        "piercing": 60,
        "range": 1700,
        "shotspeed": 1133,
        "clip": 5,
        "ammo": 180,
        "roundspershot": 12,
        "reload": 5,
        "breachdmg": 4.2,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 507761,
      "mass": 4,
      "power": 1.21,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "damage": 3.7,
        "distdraw": 0.65,
        "fireint": 0.6,
        "thermload": 1.2,
        "piercing": 45,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 3,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Small",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 151650,
      "mass": 2,
      "power": 0.87,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "damage": 2,
        "distdraw": 0.42,
        "fireint": 0.6,
        "thermload": 0.7,
        "piercing": 30,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 1.6,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Turret_Large",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "gsc",
      "cost": 5865026,
      "mass": 8,
      "power": 1.39,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "damage": 3.4,
        "distdraw": 1.2,
        "fireint": 0.6,
        "thermload": 2,
        "piercing": 60,
        "range": 1700,
        "shotspeed": 1133,
        "clip": 5,
        "ammo": 180,
        "roundspershot": 12,
        "reload": 5,
        "breachdmg": 2.7,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Turret_Medium",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "gsc",
      "cost": 1767001,
      "mass": 4,
      "power": 1.16,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "damage": 2.4,
        "distdraw": 0.57,
        "fireint": 0.6,
        "thermload": 1.1,
        "piercing": 45,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 1.9,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Turret_Small",
      "category": "hardpoint",
      "name": "Guardian Shard Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "gsc",
      "cost": 502000,
      "mass": 2,
      "power": 0.72,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "damage": 1.1,
        "distdraw": 0.36,
        "fireint": 0.6,
        "thermload": 0.6,
        "piercing": 30,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 0.9,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_HeatSinkLauncher_Turret_Tiny",
      "category": "utility",
      "name": "Heat Sink Launcher",
      "ship": null,
      "class": 0,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "hs",
      "cost": 3500,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 20,
      "stats": {
        "ammo": 3,
        "ammocost": 25,
        "clip": 1,
        "distdraw": 2,
        "drain": 100,
        "duration": 10,
        "eps": 0.4,
        "fireint": 5,
        "passive": 1,
        "reload": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Human_Extraction_Fixed_Medium",
      "category": "hardpoint",
      "name": "Sub-Surface Extraction Missile",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "sdm",
      "cost": 822091,
      "mass": 4,
      "power": 1,
      "integrity": 50,
      "stats": {
        "breachdmg": 0.5,
        "breachmax": 0.2,
        "shotspeed": 550,
        "breachmin": 0.1,
        "damage": 5,
        "chargetime": 2,
        "distdraw": 0.21,
        "fireint": 2,
        "ammo": 96,
        "clip": 1,
        "reload": 2,
        "piercing": 25,
        "thermload": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MineLauncher_Fixed_Medium",
      "category": "hardpoint",
      "name": "Mine Launcher",
      "ship": null,
      "class": 2,
      "rating": "I",
      "mount": "Fixed",
      "guidance": null,
      "group": "nl",
      "cost": 294080,
      "mass": 4,
      "power": 0.4,
      "integrity": 51,
      "stats": {
        "ammo": 72,
        "breachdmg": 0,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 3,
        "damage": 44,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 60,
        "reload": 6.6,
        "thermload": 7.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MineLauncher_Fixed_Small",
      "category": "hardpoint",
      "name": "Mine Launcher",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": "Fixed",
      "guidance": null,
      "group": "nl",
      "cost": 24260,
      "mass": 2,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "ammo": 36,
        "breachdmg": 0,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 1,
        "damage": 44,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 60,
        "reload": 2,
        "thermload": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MineLauncher_Fixed_Small_Impulse",
      "category": "hardpoint",
      "name": "Shock Mine Launcher",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": "Fixed",
      "guidance": null,
      "group": "nl",
      "cost": 36390,
      "mass": 2,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "ammo": 36,
        "breachdmg": 0,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 1,
        "damage": 32,
        "distdraw": 0,
        "fireint": 1,
        "piercing": 60,
        "reload": 2,
        "thermload": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_AbrBlstr_Fixed_Small",
      "category": "hardpoint",
      "name": "Abrasion Blaster",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "abl",
      "cost": 9700,
      "mass": 2,
      "power": 0.34,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "shotspeed": 667,
        "breachmin": 0.1,
        "damage": 4,
        "chargetime": 0,
        "distdraw": 2,
        "falloff": 1000,
        "fireint": 0.2,
        "clip": 1,
        "reload": 2,
        "piercing": 18,
        "range": 1000,
        "thermload": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_AbrBlstr_Fixed_Small",
      "category": "mercgear",
      "name": "Far-Reaching Abrasion Blaster",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "abl",
      "cost": 9700,
      "mass": 2,
      "power": 0.34,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "shotspeed": 667,
        "breachmin": 0.1,
        "damage": 4,
        "chargetime": 0,
        "distdraw": 2,
        "falloff": 1000,
        "fireint": 0.2,
        "clip": 1,
        "reload": 2,
        "piercing": 18,
        "range": 1000,
        "thermload": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_AbrBlstr_Turret_Small",
      "category": "hardpoint",
      "name": "Abrasion Blaster",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "abl",
      "cost": 27480,
      "mass": 2,
      "power": 0.47,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "shotspeed": 667,
        "breachmin": 0.1,
        "damage": 4,
        "chargetime": 0,
        "distdraw": 2,
        "falloff": 1000,
        "fireint": 0.2,
        "clip": 1,
        "reload": 2,
        "piercing": 18,
        "range": 1000,
        "thermload": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SeismChrgWarhd_Fixed_Medium",
      "category": "hardpoint",
      "name": "Seismic Charge Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "scl",
      "cost": 153110,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "breachdmg": 3,
        "breachmax": 0,
        "shotspeed": 350,
        "breachmin": 0,
        "damage": 15,
        "chargetime": 2,
        "distdraw": 0.24,
        "falloff": 500,
        "fireint": 1,
        "ammo": 72,
        "clip": 1,
        "piercing": 35,
        "range": 3000,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SeismChrgWarhd_Turret_Medium",
      "category": "hardpoint",
      "name": "Seismic Charge Launcher",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Turreted",
      "guidance": "Seeker",
      "group": "scl",
      "cost": 445570,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "breachdmg": 3,
        "breachmax": 0,
        "shotspeed": 350,
        "breachmin": 0,
        "damage": 15,
        "chargetime": 2,
        "distdraw": 0.24,
        "falloff": 500,
        "fireint": 1,
        "ammo": 72,
        "clip": 1,
        "piercing": 35,
        "range": 3000,
        "thermload": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SubSurfDispMisle_Fixed_Medium",
      "category": "hardpoint",
      "name": "Sub-Surface Displacement Missile",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "sdm",
      "cost": 122170,
      "mass": 4,
      "power": 1.01,
      "integrity": 51,
      "stats": {
        "breachdmg": 0.5,
        "breachmax": 0.2,
        "shotspeed": 550,
        "breachmin": 0.1,
        "damage": 5,
        "chargetime": 2,
        "distdraw": 0.18,
        "falloff": 500,
        "fireint": 2,
        "ammo": 96,
        "clip": 1,
        "reload": 2,
        "piercing": 25,
        "range": 3000,
        "thermload": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SubSurfDispMisle_Fixed_Small",
      "category": "hardpoint",
      "name": "Sub-Surface Displacement Missile",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "sdm",
      "cost": 12600,
      "mass": 2,
      "power": 0.42,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.5,
        "breachmax": 0.2,
        "shotspeed": 550,
        "breachmin": 0.1,
        "damage": 5,
        "chargetime": 2,
        "distdraw": 0.18,
        "falloff": 500,
        "fireint": 2,
        "ammo": 32,
        "clip": 1,
        "reload": 2,
        "piercing": 25,
        "range": 3000,
        "thermload": 2.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SubSurfDispMisle_Turret_Medium",
      "category": "hardpoint",
      "name": "Sub-Surface Displacement Missile",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Turreted",
      "guidance": "Seeker",
      "group": "sdm",
      "cost": 381750,
      "mass": 4,
      "power": 0.93,
      "integrity": 51,
      "stats": {
        "breachdmg": 0.5,
        "breachmax": 0.2,
        "shotspeed": 550,
        "breachmin": 0.1,
        "damage": 5,
        "chargetime": 2,
        "distdraw": 0.24,
        "falloff": 500,
        "fireint": 2,
        "ammo": 96,
        "clip": 1,
        "reload": 2,
        "piercing": 25,
        "range": 3000,
        "thermload": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_SubSurfDispMisle_Turret_Small",
      "category": "hardpoint",
      "name": "Sub-Surface Displacement Missile",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": "Turreted",
      "guidance": "Seeker",
      "group": "sdm",
      "cost": 38750,
      "mass": 2,
      "power": 0.42,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.5,
        "breachmax": 0.2,
        "shotspeed": 550,
        "breachmin": 0.1,
        "damage": 5,
        "chargetime": 2,
        "distdraw": 0.16,
        "falloff": 500,
        "fireint": 2,
        "ammo": 32,
        "clip": 1,
        "reload": 2,
        "piercing": 25,
        "range": 3000,
        "thermload": 2.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Fixed_Medium",
      "category": "hardpoint",
      "name": "Mining Laser",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ml",
      "cost": 22576,
      "mass": 2,
      "power": 0.75,
      "integrity": 51,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 4,
        "distdraw": 3,
        "falloff": 300,
        "piercing": 18,
        "range": 500,
        "thermload": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Fixed_Small",
      "category": "hardpoint",
      "name": "Mining Laser",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ml",
      "cost": 6800,
      "mass": 2,
      "power": 0.5,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.3,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 2,
        "distdraw": 1.5,
        "falloff": 300,
        "piercing": 18,
        "range": 500,
        "thermload": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Fixed_Small",
      "category": "mercgear",
      "name": "Long Range Mining Laser",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ml",
      "cost": 6800,
      "mass": 2,
      "power": 0.5,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.3,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 2,
        "distdraw": 1.5,
        "falloff": 300,
        "piercing": 18,
        "range": 500,
        "thermload": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Fixed_Small_Advanced",
      "category": "hardpoint",
      "name": "Mining Lance",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ml",
      "cost": 13600,
      "mass": 2,
      "power": 0.7,
      "integrity": 40,
      "stats": {
        "breachdmg": 1.2,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 8,
        "distdraw": 1.75,
        "falloff": 400,
        "piercing": 18,
        "range": 2000,
        "thermload": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Turret_Medium",
      "category": "hardpoint",
      "name": "Mining Laser",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "ml",
      "cost": 32576,
      "mass": 2,
      "power": 0.75,
      "integrity": 51,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 4,
        "distdraw": 3,
        "falloff": 300,
        "piercing": 18,
        "range": 500,
        "thermload": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningLaser_Turret_Small",
      "category": "hardpoint",
      "name": "Mining Laser",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "ml",
      "cost": 9400,
      "mass": 2,
      "power": 0.5,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.3,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 2,
        "distdraw": 1.5,
        "falloff": 300,
        "piercing": 18,
        "range": 500,
        "thermload": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MiningToolV2_Fixed_Large",
      "category": "hardpoint",
      "name": "Mining Volley Repeater",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "mvr",
      "cost": 149910,
      "mass": 8,
      "power": 1.5,
      "integrity": 61,
      "stats": {
        "breachdmg": 0.3,
        "breachmax": 0.2,
        "shotspeed": 167,
        "breachmin": 0.1,
        "damage": 0.3,
        "chargetime": 0,
        "distdraw": 2,
        "falloff": 500,
        "fireint": 0.05,
        "burst": 1,
        "burstrof": 0,
        "ammo": 1,
        "clip": 1,
        "reload": 4,
        "piercing": 18,
        "range": 500,
        "thermload": 0.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MkIIPlasmaShockAutocannon_Fixed_Large",
      "category": "hardpoint",
      "name": "Mk II Plasma Shock Accelerator",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "pa",
      "cost": 3051200,
      "mass": 8,
      "power": 1.51,
      "integrity": 64,
      "stats": {
        "ammo": 0,
        "breachdmg": 9.8,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 4,
        "burstrof": 28,
        "clip": 18,
        "damage": 13.9,
        "distdraw": 0.92,
        "falloff": 2500,
        "fireint": 0.406,
        "piercing": 60,
        "range": 3000,
        "reload": 5,
        "shotspeed": 1200,
        "thermload": 1.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MRAScanner_Size0_Class1",
      "category": "utility",
      "name": "Pulse Wave Analyser",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pwa",
      "cost": 13544,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 24,
      "stats": {
        "maxangle": 15,
        "boot": 3,
        "scanrange": 12000,
        "scantime": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MRAScanner_Size0_Class2",
      "category": "utility",
      "name": "Pulse Wave Analyser",
      "ship": null,
      "class": 0,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pwa",
      "cost": 40633,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 24,
      "stats": {
        "maxangle": 15,
        "boot": 3,
        "scanrange": 15000,
        "scantime": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MRAScanner_Size0_Class3",
      "category": "utility",
      "name": "Pulse Wave Analyser",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pwa",
      "cost": 121899,
      "mass": 1.3,
      "power": 0.8,
      "integrity": 40,
      "stats": {
        "maxangle": 15,
        "boot": 3,
        "scanrange": 18000,
        "scantime": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MRAScanner_Size0_Class4",
      "category": "utility",
      "name": "Pulse Wave Analyser",
      "ship": null,
      "class": 0,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pwa",
      "cost": 365698,
      "mass": 1.3,
      "power": 1.6,
      "integrity": 56,
      "stats": {
        "maxangle": 15,
        "boot": 3,
        "scanrange": 21000,
        "scantime": 3.08
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MRAScanner_Size0_Class5",
      "category": "utility",
      "name": "Pulse Wave Analyser",
      "ship": null,
      "class": 0,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pwa",
      "cost": 1097095,
      "mass": 1.3,
      "power": 3.2,
      "integrity": 48,
      "stats": {
        "maxangle": 15,
        "scanrange": 24000,
        "scantime": 3,
        "boot": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Huge",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 1177600,
      "mass": 16,
      "power": 0.73,
      "integrity": 80,
      "stats": {
        "ammo": 2100,
        "breachdmg": 4.2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 4.625,
        "distdraw": 0.24,
        "falloff": 2000,
        "fireint": 0.33,
        "piercing": 68,
        "range": 4000,
        "reload": 4,
        "roundspershot": 2,
        "shotspeed": 1600,
        "thermload": 0.39
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Large",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 140400,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "ammo": 2100,
        "breachdmg": 3.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 3.925,
        "distdraw": 0.18,
        "falloff": 2000,
        "fireint": 0.17,
        "piercing": 54,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.28
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 38000,
      "mass": 4,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "ammo": 2100,
        "breachdmg": 2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 2.19,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 37,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.18
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Medium",
      "category": "mercgear",
      "name": "Rapid Phase Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 38000,
      "mass": 4,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "ammo": 2100,
        "breachdmg": 2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 2.19,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 37,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.18
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Medium_Advanced",
      "category": "hardpoint",
      "name": "Advanced Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "advmc",
      "cost": 38000,
      "mass": 4,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "ammo": 2100,
        "breachdmg": 2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 2.19,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 37,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.18
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Small",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 9500,
      "mass": 2,
      "power": 0.28,
      "integrity": 40,
      "stats": {
        "ammo": 2100,
        "breachdmg": 1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 1.12,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.13,
        "piercing": 22,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.09
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Small_Advanced",
      "category": "hardpoint",
      "name": "Advanced Multi-Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "advmc",
      "cost": 9500,
      "mass": 2,
      "power": 0.28,
      "integrity": 40,
      "stats": {
        "ammo": 2100,
        "breachdmg": 1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 100,
        "damage": 1.12,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.13,
        "piercing": 22,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.09
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Small_Strong",
      "category": "hardpoint",
      "name": "Enforcer Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 13980,
      "mass": 2,
      "power": 0.28,
      "integrity": 40,
      "stats": {
        "ammo": 1000,
        "breachdmg": 2.6,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 60,
        "damage": 2.9,
        "distdraw": 0.12,
        "falloff": 3000,
        "fireint": 0.23,
        "piercing": 30,
        "range": 4500,
        "reload": 4,
        "shotspeed": 1800,
        "thermload": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Gimbal_Huge",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Gimballed",
      "guidance": null,
      "group": "mc",
      "cost": 6377600,
      "mass": 16,
      "power": 1.22,
      "integrity": 80,
      "stats": {
        "ammo": 2100,
        "breachdmg": 3.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 3.46,
        "distdraw": 0.37,
        "falloff": 2000,
        "fireint": 0.297,
        "piercing": 68,
        "range": 4000,
        "reload": 5,
        "roundspershot": 2,
        "shotspeed": 1600,
        "thermload": 0.51
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Gimbal_Large",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "mc",
      "cost": 578436,
      "mass": 8,
      "power": 0.97,
      "integrity": 64,
      "stats": {
        "ammo": 2100,
        "breachdmg": 2.6,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 2.84,
        "distdraw": 0.25,
        "falloff": 2000,
        "fireint": 0.15,
        "piercing": 54,
        "range": 4000,
        "reload": 5,
        "shotspeed": 1600,
        "thermload": 0.34
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Gimballed",
      "guidance": null,
      "group": "mc",
      "cost": 57000,
      "mass": 4,
      "power": 0.64,
      "integrity": 51,
      "stats": {
        "ammo": 2100,
        "breachdmg": 1.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 1.64,
        "distdraw": 0.14,
        "falloff": 2000,
        "fireint": 0.13,
        "piercing": 37,
        "range": 4000,
        "reload": 5,
        "shotspeed": 1600,
        "thermload": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Gimbal_Small",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Gimballed",
      "guidance": null,
      "group": "mc",
      "cost": 14250,
      "mass": 2,
      "power": 0.37,
      "integrity": 40,
      "stats": {
        "ammo": 2100,
        "breachdmg": 0.7,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 0.82,
        "distdraw": 0.07,
        "falloff": 2000,
        "fireint": 0.12,
        "piercing": 22,
        "range": 4000,
        "reload": 5,
        "shotspeed": 1600,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Turret_Large",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "mc",
      "cost": 3794600,
      "mass": 8,
      "power": 0.86,
      "integrity": 64,
      "stats": {
        "ammo": 2100,
        "breachdmg": 2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 2.2,
        "distdraw": 0.16,
        "falloff": 2000,
        "fireint": 0.19,
        "piercing": 54,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Turret_Medium",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "mc",
      "cost": 1292800,
      "mass": 4,
      "power": 0.5,
      "integrity": 51,
      "stats": {
        "ammo": 2100,
        "breachdmg": 1.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 1.17,
        "distdraw": 0.06,
        "falloff": 2000,
        "fireint": 0.16,
        "piercing": 37,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.09
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_MultiCannon_Turret_Small",
      "category": "hardpoint",
      "name": "Multi-Cannon",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Turreted",
      "guidance": null,
      "group": "mc",
      "cost": 81600,
      "mass": 2,
      "power": 0.26,
      "integrity": 40,
      "stats": {
        "ammo": 2100,
        "breachdmg": 0.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 90,
        "damage": 0.56,
        "distdraw": 0.03,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 22,
        "range": 4000,
        "reload": 4,
        "shotspeed": 1600,
        "thermload": 0.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaAccelerator_Fixed_Huge",
      "category": "hardpoint",
      "name": "Plasma Accelerator",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "pa",
      "cost": 13793600,
      "mass": 16,
      "power": 2.63,
      "integrity": 80,
      "stats": {
        "ammo": 100,
        "breachdmg": 102,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 5,
        "damage": 125.2,
        "distdraw": 21.04,
        "falloff": 2000,
        "fireint": 4,
        "piercing": 100,
        "range": 3500,
        "reload": 6,
        "shotspeed": 875,
        "thermload": 29.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaAccelerator_Fixed_Large",
      "category": "hardpoint",
      "name": "Plasma Accelerator",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "pa",
      "cost": 3051200,
      "mass": 8,
      "power": 1.97,
      "integrity": 64,
      "stats": {
        "ammo": 100,
        "breachdmg": 68,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 5,
        "damage": 83.4,
        "distdraw": 13.6,
        "falloff": 2000,
        "fireint": 3.45,
        "piercing": 100,
        "range": 3500,
        "reload": 6,
        "shotspeed": 875,
        "thermload": 21.75
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaAccelerator_Fixed_Large_Advanced",
      "category": "hardpoint",
      "name": "Advanced Plasma Accelerator",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "pa",
      "cost": 4119120,
      "mass": 8,
      "power": 1.97,
      "integrity": 64,
      "stats": {
        "ammo": 300,
        "breachdmg": 30.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 20,
        "damage": 34.5,
        "distdraw": 5.5,
        "falloff": 2000,
        "fireint": 1.25,
        "piercing": 100,
        "range": 3500,
        "reload": 6,
        "shotspeed": 875,
        "thermload": 11
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaAccelerator_Fixed_Medium",
      "category": "hardpoint",
      "name": "Plasma Accelerator",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "pa",
      "cost": 834200,
      "mass": 4,
      "power": 1.43,
      "integrity": 51,
      "stats": {
        "ammo": 100,
        "breachdmg": 44.2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 5,
        "damage": 54.3,
        "distdraw": 8.65,
        "falloff": 2000,
        "fireint": 3.03,
        "piercing": 100,
        "range": 3500,
        "reload": 6,
        "shotspeed": 875,
        "thermload": 15.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaPointDefence_Turret_Tiny",
      "category": "utility",
      "name": "Point Defence",
      "ship": null,
      "class": 0,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "po",
      "cost": 18550,
      "mass": 0.5,
      "power": 0.2,
      "integrity": 30,
      "stats": {
        "ammo": 10000,
        "burst": 4,
        "burstrof": 15,
        "clip": 12,
        "damage": 0.2,
        "fireint": 0.2,
        "jitter": 0.75,
        "passive": 1,
        "range": 2500,
        "reload": 0.4,
        "shotspeed": 1000,
        "thermload": 0.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Fixed_Large",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "tbsc",
      "cost": 1015750,
      "mass": 8,
      "power": 0.89,
      "integrity": 64,
      "stats": {
        "damage": 18.1,
        "distdraw": 0.92,
        "fireint": 0.129,
        "thermload": 2.66,
        "piercing": 60,
        "range": 3000,
        "shotspeed": 1200,
        "roundspershot": 0,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 12.7,
        "breachmin": 0.4,
        "breachmax": 0.8,
        "jitter": 0,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Fixed_Medium",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "tbsc",
      "cost": 367501,
      "mass": 4,
      "power": 0.57,
      "integrity": 51,
      "stats": {
        "damage": 13,
        "distdraw": 0.47,
        "fireint": 0.129,
        "thermload": 1.8,
        "piercing": 40,
        "range": 3000,
        "shotspeed": 1200,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 9.1,
        "breachmin": 0.4,
        "breachmax": 0.6,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Fixed_Small",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "tbsc",
      "cost": 65941,
      "mass": 2,
      "power": 0.41,
      "integrity": 40,
      "stats": {
        "damage": 8.6,
        "distdraw": 0.27,
        "fireint": 0.129,
        "thermload": 1.1,
        "piercing": 25,
        "range": 3000,
        "shotspeed": 1200,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 6,
        "breachmin": 0.4,
        "breachmax": 0.6,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Gimbal_Large",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "tbsc",
      "cost": 2249050,
      "mass": 8,
      "power": 0.89,
      "integrity": 64,
      "stats": {
        "ammo": 880,
        "breachdmg": 10.4,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 16,
        "damage": 14.9,
        "distdraw": 1.07,
        "falloff": 2500,
        "fireint": 0.129,
        "piercing": 60,
        "range": 3000,
        "shotspeed": 1200,
        "thermload": 3.1,
        "reload": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Gimballed",
      "guidance": null,
      "group": "tbsc",
      "cost": 565200,
      "mass": 4,
      "power": 0.61,
      "integrity": 51,
      "stats": {
        "ammo": 880,
        "breachdmg": 7.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 16,
        "damage": 10.2,
        "distdraw": 0.58,
        "falloff": 2500,
        "fireint": 0.129,
        "piercing": 40,
        "range": 3000,
        "reload": 6,
        "shotspeed": 1200,
        "thermload": 2.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Gimbal_Small",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "tbsc",
      "cost": 137501,
      "mass": 2,
      "power": 0.47,
      "integrity": 40,
      "stats": {
        "ammo": 880,
        "breachdmg": 4.8,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 16,
        "damage": 6.9,
        "distdraw": 0.39,
        "fireint": 0.129,
        "falloff": 2500,
        "piercing": 25,
        "range": 3000,
        "shotspeed": 1200,
        "thermload": 1.5,
        "reload": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Turret_Large",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "tbsc",
      "cost": 6050201,
      "mass": 8,
      "power": 0.64,
      "integrity": 64,
      "stats": {
        "damage": 12.26,
        "distdraw": 0.79,
        "fireint": 0.129,
        "thermload": 2.2,
        "piercing": 60,
        "range": 3000,
        "shotspeed": 1200,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 8.6,
        "breachmin": 0.4,
        "breachmax": 0.8,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Turret_Medium",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "tbsc",
      "cost": 1359200,
      "mass": 4,
      "power": 0.5,
      "integrity": 51,
      "stats": {
        "damage": 9,
        "distdraw": 0.39,
        "fireint": 0.129,
        "thermload": 1.2,
        "piercing": 40,
        "range": 3000,
        "shotspeed": 1200,
        "roundspershot": 0,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 6.3,
        "breachmin": 0.4,
        "breachmax": 0.8,
        "jitter": 0,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PlasmaShockCannon_Turret_Small",
      "category": "hardpoint",
      "name": "Shock Cannon",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "tbsc",
      "cost": 364000,
      "mass": 2,
      "power": 0.54,
      "integrity": 40,
      "stats": {
        "damage": 4.5,
        "distdraw": 0.21,
        "fireint": 0.129,
        "thermload": 0.7,
        "piercing": 25,
        "range": 3000,
        "shotspeed": 1200,
        "clip": 16,
        "ammo": 880,
        "reload": 6,
        "breachdmg": 3.1,
        "breachmin": 0.4,
        "breachmax": 0.8,
        "falloff": 2500
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Fixed_Huge",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "pl",
      "cost": 177600,
      "mass": 16,
      "power": 1.33,
      "integrity": 80,
      "stats": {
        "breachdmg": 8.7,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 10.24,
        "distdraw": 1.48,
        "falloff": 500,
        "fireint": 0.38,
        "piercing": 65,
        "range": 3000,
        "thermload": 1.64
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Fixed_Large",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "pl",
      "cost": 70400,
      "mass": 8,
      "power": 0.9,
      "integrity": 64,
      "stats": {
        "breachdmg": 5.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 5.98,
        "distdraw": 0.86,
        "falloff": 500,
        "fireint": 0.33,
        "piercing": 52,
        "range": 3000,
        "thermload": 0.96
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Fixed_Medium",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "pl",
      "cost": 17600,
      "mass": 4,
      "power": 0.6,
      "integrity": 51,
      "stats": {
        "breachdmg": 3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 3.5,
        "distdraw": 0.5,
        "falloff": 500,
        "fireint": 0.29,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.56
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Fixed_Medium_Disruptor",
      "category": "hardpoint",
      "name": "Pulse Disruptor Laser",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "pl",
      "cost": 26400,
      "mass": 4,
      "power": 0.7,
      "integrity": 51,
      "stats": {
        "breachdmg": 2.4,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 2.8,
        "distdraw": 0.9,
        "falloff": 500,
        "fireint": 0.6,
        "piercing": 35,
        "thermload": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Fixed_Small",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "pl",
      "cost": 2200,
      "mass": 2,
      "power": 0.39,
      "integrity": 40,
      "stats": {
        "breachdmg": 1.7,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 2.05,
        "distdraw": 0.3,
        "falloff": 500,
        "fireint": 0.26,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.33
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Gimbal_Huge",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": "Gimballed",
      "guidance": null,
      "group": "pl",
      "cost": 877600,
      "mass": 16,
      "power": 1.37,
      "integrity": 80,
      "stats": {
        "breachdmg": 6.6,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 7.82,
        "distdraw": 1.56,
        "falloff": 500,
        "fireint": 0.36,
        "piercing": 65,
        "range": 3000,
        "thermload": 1.56
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Gimbal_Large",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "pl",
      "cost": 140600,
      "mass": 8,
      "power": 0.92,
      "integrity": 64,
      "stats": {
        "breachdmg": 3.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 4.58,
        "distdraw": 0.92,
        "falloff": 500,
        "fireint": 0.31,
        "piercing": 52,
        "range": 3000,
        "thermload": 0.92
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Gimballed",
      "guidance": null,
      "group": "pl",
      "cost": 35400,
      "mass": 4,
      "power": 0.6,
      "integrity": 51,
      "stats": {
        "breachdmg": 2.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 2.68,
        "distdraw": 0.54,
        "falloff": 500,
        "fireint": 0.28,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.54
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Gimbal_Small",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Gimballed",
      "guidance": null,
      "group": "pl",
      "cost": 6600,
      "mass": 2,
      "power": 0.39,
      "integrity": 40,
      "stats": {
        "breachdmg": 1.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 1.56,
        "distdraw": 0.31,
        "falloff": 500,
        "fireint": 0.25,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.31
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Turret_Large",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 3,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "pl",
      "cost": 400400,
      "mass": 8,
      "power": 0.89,
      "integrity": 64,
      "stats": {
        "breachdmg": 3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 3.5,
        "distdraw": 0.56,
        "falloff": 500,
        "fireint": 0.37,
        "piercing": 52,
        "range": 3000,
        "thermload": 0.56
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Turret_Medium",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "pl",
      "cost": 132800,
      "mass": 4,
      "power": 0.58,
      "integrity": 51,
      "stats": {
        "breachdmg": 1.7,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 2.05,
        "distdraw": 0.33,
        "falloff": 500,
        "fireint": 0.33,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.33
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaser_Turret_Small",
      "category": "hardpoint",
      "name": "Pulse Laser",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Turreted",
      "guidance": null,
      "group": "pl",
      "cost": 26000,
      "mass": 2,
      "power": 0.38,
      "integrity": 40,
      "stats": {
        "breachdmg": 1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "damage": 1.19,
        "distdraw": 0.19,
        "falloff": 500,
        "fireint": 0.3,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.19
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Fixed_Huge",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "ul",
      "cost": 281600,
      "mass": 16,
      "power": 2.58,
      "integrity": 80,
      "stats": {
        "breachdmg": 17.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 3,
        "damage": 20.61,
        "distdraw": 2.98,
        "falloff": 500,
        "fireint": 1.25,
        "piercing": 65,
        "range": 3000,
        "thermload": 4.53
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Fixed_Large",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ul",
      "cost": 140400,
      "mass": 8,
      "power": 1.66,
      "integrity": 64,
      "stats": {
        "breachdmg": 3.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 7,
        "damage": 7.73,
        "distdraw": 1.11,
        "falloff": 500,
        "fireint": 0.83,
        "piercing": 52,
        "range": 3000,
        "thermload": 1.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Fixed_Medium",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "ul",
      "cost": 23000,
      "mass": 4,
      "power": 1.05,
      "integrity": 40,
      "stats": {
        "breachdmg": 3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 11,
        "damage": 3.53,
        "distdraw": 0.5,
        "falloff": 500,
        "fireint": 0.63,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.78
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Fixed_Small",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "ul",
      "cost": 4400,
      "mass": 2,
      "power": 0.65,
      "integrity": 40,
      "stats": {
        "breachdmg": 1.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 15,
        "damage": 1.72,
        "distdraw": 0.25,
        "falloff": 500,
        "fireint": 0.5,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.38
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Fixed_Small_Scatter",
      "category": "hardpoint",
      "name": "Cytoscrambler Burst Laser",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": "Fixed",
      "guidance": null,
      "group": "ul",
      "cost": 8800,
      "mass": 2,
      "power": 0.8,
      "integrity": 40,
      "stats": {
        "breachdmg": 3.1,
        "breachmax": 0,
        "breachmin": 0,
        "burst": 8,
        "burstrof": 20,
        "damage": 3.6,
        "distdraw": 0.31,
        "falloff": 600,
        "fireint": 0.7,
        "jitter": 1.7,
        "piercing": 1,
        "range": 1000,
        "thermload": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Gimbal_Huge",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "ul",
      "cost": 1245600,
      "mass": 16,
      "power": 2.59,
      "integrity": 80,
      "stats": {
        "breachdmg": 10.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 5,
        "damage": 12.09,
        "distdraw": 2.41,
        "falloff": 500,
        "fireint": 1,
        "piercing": 65,
        "range": 3000,
        "thermload": 3.33
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Gimbal_Large",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "ul",
      "cost": 281600,
      "mass": 8,
      "power": 1.65,
      "integrity": 64,
      "stats": {
        "breachdmg": 4.4,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 9,
        "damage": 5.16,
        "distdraw": 1.03,
        "falloff": 500,
        "fireint": 0.71,
        "piercing": 52,
        "range": 3000,
        "thermload": 1.42
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Gimballed",
      "guidance": null,
      "group": "ul",
      "cost": 48500,
      "mass": 4,
      "power": 1.04,
      "integrity": 40,
      "stats": {
        "breachdmg": 2.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 13,
        "damage": 2.45,
        "distdraw": 0.49,
        "falloff": 500,
        "fireint": 0.56,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.67
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Gimbal_Medium",
      "category": "mercgear",
      "name": "Regenerative Burst Laser",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Gimballed",
      "guidance": null,
      "group": "ul",
      "cost": 48500,
      "mass": 4,
      "power": 1.04,
      "integrity": 40,
      "stats": {
        "breachdmg": 2.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 13,
        "damage": 2.45,
        "distdraw": 0.49,
        "falloff": 500,
        "fireint": 0.56,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.67
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Gimbal_Small",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Gimballed",
      "guidance": null,
      "group": "ul",
      "cost": 8600,
      "mass": 2,
      "power": 0.64,
      "integrity": 40,
      "stats": {
        "breachdmg": 1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 17,
        "damage": 1.22,
        "distdraw": 0.24,
        "fireint": 0.45,
        "falloff": 500,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.34
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Turret_Large",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "ul",
      "cost": 800400,
      "mass": 8,
      "power": 1.57,
      "integrity": 64,
      "stats": {
        "breachdmg": 1.8,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "burst": 3,
        "burstrof": 11,
        "damage": 3.53,
        "distdraw": 0.56,
        "falloff": 500,
        "fireint": 0.78,
        "piercing": 52,
        "range": 3000,
        "thermload": 0.78
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Turret_Medium",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": "Turreted",
      "guidance": null,
      "group": "ul",
      "cost": 162800,
      "mass": 4,
      "power": 0.98,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.9,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "burst": 3,
        "burstrof": 15,
        "damage": 1.72,
        "distdraw": 0.28,
        "falloff": 500,
        "fireint": 0.63,
        "piercing": 35,
        "range": 3000,
        "thermload": 0.38
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_PulseLaserBurst_Turret_Small",
      "category": "hardpoint",
      "name": "Burst Laser",
      "ship": null,
      "class": 1,
      "rating": "G",
      "mount": "Turreted",
      "guidance": null,
      "group": "ul",
      "cost": 52800,
      "mass": 2,
      "power": 0.6,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.4,
        "breachmax": 0.8,
        "breachmin": 0.6,
        "burst": 3,
        "burstrof": 19,
        "damage": 0.87,
        "distdraw": 0.14,
        "falloff": 500,
        "fireint": 0.52,
        "piercing": 20,
        "range": 3000,
        "thermload": 0.19
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Railgun_Fixed_Medium",
      "category": "hardpoint",
      "name": "Rail Gun",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "rg",
      "cost": 412800,
      "mass": 4,
      "power": 1.63,
      "integrity": 51,
      "stats": {
        "ammo": 80,
        "breachdmg": 39.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "charge": 1.2,
        "clip": 1,
        "damage": 41.5,
        "distdraw": 5.11,
        "falloff": 1000,
        "fireint": 0.83,
        "piercing": 100,
        "range": 3000,
        "reload": 1,
        "thermload": 20
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Railgun_Fixed_Medium",
      "category": "mercgear",
      "name": "Enduring Feedback Rail Gun",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rg",
      "cost": 412800,
      "mass": 4,
      "power": 1.63,
      "integrity": 51,
      "stats": {
        "ammo": 80,
        "breachdmg": 39.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "charge": 1.2,
        "clip": 1,
        "damage": 41.5,
        "distdraw": 5.11,
        "falloff": 1000,
        "fireint": 0.83,
        "piercing": 100,
        "range": 3000,
        "reload": 1,
        "thermload": 20
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Railgun_Fixed_Medium_Burst",
      "category": "hardpoint",
      "name": "Imperial Hammer Rail Gun",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "rg",
      "cost": 619200,
      "mass": 4,
      "power": 1.63,
      "integrity": 51,
      "stats": {
        "ammo": 240,
        "breachdmg": 14.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "burst": 3,
        "burstrof": 6,
        "charge": 1.2,
        "clip": 3,
        "damage": 31.4,
        "distdraw": 2,
        "falloff": 1000,
        "fireint": 0.001,
        "piercing": 100,
        "range": 3000,
        "reload": 1.2,
        "thermload": 11
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Railgun_Fixed_Small",
      "category": "hardpoint",
      "name": "Rail Gun",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "rg",
      "cost": 51600,
      "mass": 2,
      "power": 1.15,
      "integrity": 40,
      "stats": {
        "ammo": 80,
        "breachdmg": 22.2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "charge": 1.2,
        "clip": 1,
        "damage": 23.25,
        "distdraw": 2.69,
        "falloff": 1000,
        "fireint": 0.63,
        "piercing": 100,
        "range": 3000,
        "reload": 1,
        "thermload": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ShieldBooster_Size0_Class1",
      "category": "utility",
      "name": "Shield Booster",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sb",
      "cost": 10000,
      "mass": 0.5,
      "power": 0.2,
      "integrity": 25,
      "stats": {
        "passive": 1,
        "shieldboost": 0.04,
        "explres": 0,
        "kinres": 0,
        "thermres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ShieldBooster_Size0_Class2",
      "category": "utility",
      "name": "Shield Booster",
      "ship": null,
      "class": 0,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sb",
      "cost": 23000,
      "mass": 1,
      "power": 0.5,
      "integrity": 35,
      "stats": {
        "passive": 1,
        "shieldboost": 0.08,
        "explres": 0,
        "kinres": 0,
        "thermres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ShieldBooster_Size0_Class3",
      "category": "utility",
      "name": "Shield Booster",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sb",
      "cost": 53000,
      "mass": 2,
      "power": 0.7,
      "integrity": 40,
      "stats": {
        "passive": 1,
        "shieldboost": 0.12,
        "explres": 0,
        "kinres": 0,
        "thermres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ShieldBooster_Size0_Class4",
      "category": "utility",
      "name": "Shield Booster",
      "ship": null,
      "class": 0,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sb",
      "cost": 122000,
      "mass": 3,
      "power": 1,
      "integrity": 45,
      "stats": {
        "passive": 1,
        "shieldboost": 0.16,
        "explres": 0,
        "kinres": 0,
        "thermres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_ShieldBooster_Size0_Class5",
      "category": "utility",
      "name": "Shield Booster",
      "ship": null,
      "class": 0,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sb",
      "cost": 281000,
      "mass": 3.5,
      "power": 1.2,
      "integrity": 48,
      "stats": {
        "passive": 1,
        "shieldboost": 0.2,
        "explres": 0,
        "kinres": 0,
        "thermres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Fixed_Large",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "fc",
      "cost": 1167360,
      "mass": 8,
      "power": 1.02,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 3.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 4.57,
        "distdraw": 0.57,
        "falloff": 1800,
        "fireint": 0.22,
        "jitter": 5,
        "piercing": 45,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 1.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Fixed_Large_Range",
      "category": "hardpoint",
      "name": "Pacifier Frag-Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": null,
      "group": "fc",
      "cost": 1751040,
      "mass": 8,
      "power": 1.02,
      "integrity": 64,
      "stats": {
        "ammo": 180,
        "breachdmg": 3.1,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 3.96,
        "distdraw": 0.57,
        "falloff": 2800,
        "fireint": 0.22,
        "jitter": 1.7,
        "piercing": 45,
        "range": 3000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 1000,
        "thermload": 1.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Fixed_Medium",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "fc",
      "cost": 291840,
      "mass": 4,
      "power": 0.74,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 2.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 3,
        "distdraw": 0.37,
        "falloff": 1800,
        "fireint": 0.2,
        "jitter": 5,
        "piercing": 30,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Fixed_Small",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "fc",
      "cost": 36000,
      "mass": 2,
      "power": 0.45,
      "integrity": 40,
      "stats": {
        "ammo": 180,
        "breachdmg": 1.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 1.43,
        "distdraw": 0.21,
        "falloff": 1800,
        "fireint": 0.18,
        "jitter": 5,
        "piercing": 20,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Gimbal_Large",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "fc",
      "cost": 1751040,
      "mass": 8,
      "power": 1.55,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 2.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 3.77,
        "distdraw": 0.81,
        "falloff": 1800,
        "fireint": 0.21,
        "jitter": 5,
        "piercing": 45,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Gimbal_Large",
      "category": "mercgear",
      "name": "Double Screaming Fragment Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "fc",
      "cost": 1751040,
      "mass": 8,
      "power": 1.55,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 2.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 3.77,
        "distdraw": 0.81,
        "falloff": 1800,
        "fireint": 0.21,
        "jitter": 5,
        "piercing": 45,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Gimbal_Medium",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Gimballed",
      "guidance": null,
      "group": "fc",
      "cost": 437760,
      "mass": 4,
      "power": 1.03,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 1.8,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 2.275,
        "distdraw": 0.49,
        "falloff": 1800,
        "fireint": 0.19,
        "jitter": 5,
        "piercing": 30,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Gimbal_Small",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "fc",
      "cost": 54720,
      "mass": 2,
      "power": 0.59,
      "integrity": 40,
      "stats": {
        "ammo": 180,
        "breachdmg": 0.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 1.01,
        "distdraw": 0.26,
        "falloff": 1800,
        "fireint": 0.17,
        "jitter": 5,
        "piercing": 20,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Gimbal_Small",
      "category": "mercgear",
      "name": "Double Screaming Fragment Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "fc",
      "cost": 54720,
      "mass": 2,
      "power": 0.59,
      "integrity": 40,
      "stats": {
        "ammo": 180,
        "breachdmg": 0.9,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 1.01,
        "distdraw": 0.26,
        "falloff": 1800,
        "fireint": 0.17,
        "jitter": 5,
        "piercing": 20,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Turret_Large",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Turreted",
      "guidance": null,
      "group": "fc",
      "cost": 5836800,
      "mass": 8,
      "power": 1.29,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 2.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 2.98,
        "distdraw": 0.37,
        "falloff": 1800,
        "fireint": 0.25,
        "jitter": 5,
        "piercing": 45,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Turret_Medium",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": "Turreted",
      "guidance": null,
      "group": "fc",
      "cost": 1459200,
      "mass": 4,
      "power": 0.79,
      "integrity": 80,
      "stats": {
        "ammo": 180,
        "breachdmg": 1.3,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 1.7,
        "distdraw": 0.21,
        "falloff": 1800,
        "fireint": 0.23,
        "jitter": 5,
        "piercing": 30,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Slugshot_Turret_Small",
      "category": "hardpoint",
      "name": "Fragment Cannon",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": "Turreted",
      "guidance": null,
      "group": "fc",
      "cost": 182400,
      "mass": 2,
      "power": 0.42,
      "integrity": 40,
      "stats": {
        "ammo": 180,
        "breachdmg": 0.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 3,
        "damage": 0.69,
        "distdraw": 0.1,
        "falloff": 1800,
        "fireint": 0.21,
        "jitter": 5,
        "piercing": 20,
        "range": 2000,
        "reload": 5,
        "roundspershot": 12,
        "shotspeed": 667,
        "thermload": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_XenoScanner_Advanced_Tiny",
      "category": "utility",
      "name": "Pulse Wave Xeno Scanner",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "xs",
      "cost": 850000,
      "mass": 3,
      "power": 1,
      "integrity": 100,
      "stats": {
        "range": 1000,
        "boot": 2,
        "scantime": 10,
        "angle": 23
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_XenoScanner_Basic_Tiny",
      "category": "utility",
      "name": "Xeno Scanner",
      "ship": null,
      "class": 0,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "xs",
      "cost": 365698,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 56,
      "stats": {
        "range": 500,
        "boot": 2,
        "scantime": 10,
        "angle": 23
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_XenoScannerMk2_Basic_Tiny",
      "category": "utility",
      "name": "Enhanced Xeno Scanner",
      "ship": null,
      "class": 0,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "xs",
      "cost": 745948,
      "mass": 1.3,
      "power": 0.8,
      "integrity": 56,
      "stats": {
        "range": 2000,
        "boot": 2,
        "scantime": 10,
        "angle": 23
      },
      "preEngineered": null
    },
    {
      "symbol": "Independant_Trader_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Keelback",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Independant_Trader_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Keelback",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1250461,
      "mass": 12,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Independant_Trader_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Keelback",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2813538,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Independant_Trader_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Keelback",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 6649329,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Independant_Trader_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Keelback",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 7368344,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size2_Class1",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 18000,
      "mass": 12,
      "power": 0.25,
      "integrity": 30,
      "stats": {
        "bays": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size2_Class2",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "G",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 21600,
      "mass": 6,
      "power": 0.75,
      "integrity": 30,
      "stats": {
        "bays": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size4_Class1",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 72000,
      "mass": 20,
      "power": 0.4,
      "integrity": 30,
      "stats": {
        "bays": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size4_Class2",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "G",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 86400,
      "mass": 10,
      "power": 1.2,
      "integrity": 30,
      "stats": {
        "bays": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size6_Class1",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 576000,
      "mass": 34,
      "power": 0.6,
      "integrity": 30,
      "stats": {
        "bays": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_BuggyBay_Size6_Class2",
      "category": "internal",
      "name": "Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "G",
      "mount": null,
      "guidance": null,
      "group": "pv",
      "cost": 691200,
      "mass": 17,
      "power": 1.8,
      "integrity": 30,
      "stats": {
        "bays": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size1_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 1000,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 2,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size2_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 3250,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 4,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size2_Class1_free",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size3_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 10563,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 8,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size4_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 34328,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 16,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size5_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 111566,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 32,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size5_Class1",
      "category": "mercgear",
      "name": "Extended Cargo Rack",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 111566,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 32,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size6_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 362591,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 64,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size6_Class1",
      "category": "mercgear",
      "name": "Extended Cargo Rack",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 362591,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 64,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size7_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 1178420,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 128,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CargoRack_Size8_Class1",
      "category": "internal",
      "name": "Cargo Rack",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 3829866,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 256,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CorrosionProofCargoRack_Size1_Class1",
      "category": "internal",
      "name": "Corrosion Resistant Cargo Rack",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 6250,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 1,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CorrosionProofCargoRack_Size1_Class2",
      "category": "internal",
      "name": "Corrosion Resistant Cargo Rack",
      "ship": null,
      "class": 1,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 2,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_CorrosionProofCargoRack_Size4_Class1",
      "category": "internal",
      "name": "Corrosion Resistant Cargo Rack",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 94330,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 16,
        "engineering": false
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DetailedSurfaceScanner_Tiny",
      "category": "internal",
      "name": "Detailed Surface Scanner",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "ss",
      "cost": 250000,
      "mass": 0,
      "power": 0,
      "integrity": null,
      "stats": {
        "proberadius": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DetailedSurfaceScanner_Tiny",
      "category": "mercgear",
      "name": "Long Range Detailed Surface Scanner",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "ss",
      "cost": 250000,
      "mass": 0,
      "power": 0,
      "integrity": null,
      "stats": {
        "proberadius": 0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DockingComputer_Advanced",
      "category": "internal",
      "name": "Advanced Docking Computer",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dc",
      "cost": 13507,
      "mass": null,
      "power": 0.45,
      "integrity": 10,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_DockingComputer_Standard",
      "category": "internal",
      "name": "Standard Docking Computer",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dc",
      "cost": 4500,
      "mass": null,
      "power": 0.39,
      "integrity": 10,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size1_Class1",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 600,
      "mass": 0.5,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.8,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size1_Class2",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 1200,
      "mass": 0.5,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.6,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size1_Class3",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 2400,
      "mass": 1.3,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1,
        "time": 510
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size1_Class4",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 4800,
      "mass": 2,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.4,
        "time": 420
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size1_Class5",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 9600,
      "mass": 2,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.2,
        "time": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size3_Class1",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 5400,
      "mass": 2,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.88,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size3_Class2",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 10800,
      "mass": 2,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.66,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size3_Class3",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 21600,
      "mass": 5,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.1,
        "time": 510
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size3_Class4",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 43200,
      "mass": 8,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.54,
        "time": 420
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size3_Class5",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 86400,
      "mass": 8,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.32,
        "time": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size5_Class1",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 48600,
      "mass": 8,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.04,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size5_Class2",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 97200,
      "mass": 8,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 0.78,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size5_Class3",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 194400,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.3,
        "time": 510
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size5_Class4",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 388800,
      "mass": 32,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.82,
        "time": 420
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size5_Class5",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 777600,
      "mass": 32,
      "power": 0.7,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.56,
        "time": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size7_Class1",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 437400,
      "mass": 32,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.36,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size7_Class2",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 874800,
      "mass": 32,
      "power": 0.55,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.02,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size7_Class3",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 1749600,
      "mass": 80,
      "power": 0.69,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.7,
        "time": 510
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size7_Class4",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 3499200,
      "mass": 128,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 2.38,
        "time": 420
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Collection_Size7_Class5",
      "category": "internal",
      "name": "Collector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "cc",
      "cost": 6998400,
      "mass": 128,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 2.04,
        "time": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Decontamination_Size1_Class1",
      "category": "internal",
      "name": "Decontamination Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dtl",
      "cost": 3600,
      "mass": 1.3,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Decontamination_Size3_Class1",
      "category": "internal",
      "name": "Decontamination Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dtl",
      "cost": 16200,
      "mass": 2,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.88
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Decontamination_Size5_Class1",
      "category": "internal",
      "name": "Decontamination Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dtl",
      "cost": 145800,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Decontamination_Size7_Class1",
      "category": "internal",
      "name": "Decontamination Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "dtl",
      "cost": 1312200,
      "mass": 128,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 2.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size1_Class1",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 600,
      "mass": 1.3,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size1_Class2",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 1200,
      "mass": 0.5,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size1_Class3",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 2400,
      "mass": 1.3,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size1_Class4",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 4800,
      "mass": 2,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size1_Class5",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 9600,
      "mass": 1.3,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size3_Class1",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 5400,
      "mass": 5,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.66
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size3_Class2",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 10800,
      "mass": 2,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.88
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size3_Class3",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 21600,
      "mass": 5,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size3_Class4",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 43200,
      "mass": 8,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size3_Class5",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 86400,
      "mass": 5,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.54
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size5_Class1",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 48600,
      "mass": 20,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 0.78
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size5_Class2",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 97200,
      "mass": 8,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size5_Class3",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 194400,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size5_Class4",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 388800,
      "mass": 32,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.56
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size5_Class5",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 777600,
      "mass": 20,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.82
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size7_Class1",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 437400,
      "mass": 80,
      "power": 0.55,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 1.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size7_Class2",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 874800,
      "mass": 32,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 1.36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size7_Class3",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 1749600,
      "mass": 80,
      "power": 0.69,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 1.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size7_Class4",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 3499200,
      "mass": 128,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 2.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_FuelTransfer_Size7_Class5",
      "category": "internal",
      "name": "Fuel Transfer Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fx",
      "cost": 6998400,
      "mass": 80,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 2.38
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size1_Class1",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 600,
      "mass": 1.3,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size1_Class2",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 1200,
      "mass": 0.5,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size1_Class3",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 2400,
      "mass": 1.3,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size1_Class4",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 4800,
      "mass": 2,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size1_Class5",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 9600,
      "mass": 1.3,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size3_Class1",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 5400,
      "mass": 5,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 3.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size3_Class2",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 10800,
      "mass": 2,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 4.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size3_Class3",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 21600,
      "mass": 5,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 5.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size3_Class4",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 43200,
      "mass": 8,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 6.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size3_Class5",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 86400,
      "mass": 5,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 7.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size5_Class1",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 48600,
      "mass": 20,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 3.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size5_Class2",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 97200,
      "mass": 8,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 5.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size5_Class3",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 194400,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 6.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size5_Class4",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 388800,
      "mass": 32,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 7.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size5_Class5",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 777600,
      "mass": 20,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 9.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size7_Class1",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 437400,
      "mass": 80,
      "power": 0.55,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 5.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size7_Class2",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 874800,
      "mass": 32,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 6.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size7_Class3",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 1749600,
      "mass": 80,
      "power": 0.69,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 8.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size7_Class4",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 3499200,
      "mass": 128,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 10.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Prospector_Size7_Class5",
      "category": "internal",
      "name": "Prospector Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pc",
      "cost": 6998400,
      "mass": 80,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "maximum": 8,
        "range": 11.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Recon_Size1_Class1",
      "category": "internal",
      "name": "Recon Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rcpl",
      "cost": 2600,
      "mass": 1.3,
      "power": 0.18,
      "integrity": 24,
      "stats": {
        "maximum": 1,
        "range": 1.2,
        "hacktime": 22
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Recon_Size3_Class1",
      "category": "internal",
      "name": "Recon Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rcpl",
      "cost": 8200,
      "mass": 2,
      "power": 0.2,
      "integrity": 51,
      "stats": {
        "maximum": 1,
        "range": 1.4,
        "hacktime": 17
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Recon_Size5_Class1",
      "category": "internal",
      "name": "Recon Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rcpl",
      "cost": 75800,
      "mass": 20,
      "power": 0.5,
      "integrity": 96,
      "stats": {
        "maximum": 1,
        "range": 1.7,
        "hacktime": 13
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Recon_Size7_Class1",
      "category": "internal",
      "name": "Recon Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rcpl",
      "cost": 612200,
      "mass": 128,
      "power": 0.97,
      "integrity": 157,
      "stats": {
        "maximum": 1,
        "range": 2,
        "hacktime": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size1_Class1",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 600,
      "mass": 1.3,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size1_Class2",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 1200,
      "mass": 0.5,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 0.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size1_Class3",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 2400,
      "mass": 1.3,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size1_Class4",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 4800,
      "mass": 2,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size1_Class5",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 9600,
      "mass": 1.3,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size3_Class1",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 5400,
      "mass": 5,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.66
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size3_Class2",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 10800,
      "mass": 2,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 0.88
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size3_Class3",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 21600,
      "mass": 5,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size3_Class4",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 43200,
      "mass": 8,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size3_Class5",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 86400,
      "mass": 5,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.54
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size5_Class1",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 48600,
      "mass": 20,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 0.78
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size5_Class2",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 97200,
      "mass": 8,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size5_Class3",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 194400,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size5_Class4",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 388800,
      "mass": 32,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.56
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size5_Class5",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 777600,
      "mass": 20,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 1.82
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size7_Class1",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 437400,
      "mass": 80,
      "power": 0.55,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size7_Class2",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 874800,
      "mass": 32,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size7_Class3",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 1749600,
      "mass": 80,
      "power": 0.69,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size7_Class4",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 3499200,
      "mass": 128,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 2.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_Repair_Size7_Class5",
      "category": "internal",
      "name": "Repair Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rpl",
      "cost": 6998400,
      "mass": 80,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 2.38
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size1_Class1",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 600,
      "mass": 1.3,
      "power": 0.12,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 1.5,
        "time": 42
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size1_Class2",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 1200,
      "mass": 0.5,
      "power": 0.16,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 2,
        "time": 36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size1_Class3",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 2400,
      "mass": 1.3,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 2.5,
        "time": 30
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size1_Class4",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 4800,
      "mass": 2,
      "power": 0.24,
      "integrity": null,
      "stats": {
        "maximum": 2,
        "range": 3,
        "time": 24
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size1_Class5",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 9600,
      "mass": 1.3,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "maximum": 1,
        "range": 3.5,
        "time": 18
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size3_Class1",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 5400,
      "mass": 5,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 1.62,
        "time": 36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size3_Class2",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 10800,
      "mass": 2,
      "power": 0.24,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 2.16,
        "time": 31
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size3_Class3",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 21600,
      "mass": 5,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 2.7,
        "time": 26
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size3_Class4",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 43200,
      "mass": 8,
      "power": 0.36,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 3.24,
        "time": 21
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size3_Class5",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 86400,
      "mass": 5,
      "power": 0.42,
      "integrity": null,
      "stats": {
        "maximum": 3,
        "range": 3.78,
        "time": 16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size5_Class1",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 48600,
      "mass": 20,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 9,
        "range": 1.98,
        "time": 31
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size5_Class2",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 97200,
      "mass": 8,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "maximum": 6,
        "range": 2.64,
        "time": 26
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size5_Class3",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 194400,
      "mass": 20,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 7,
        "range": 3.3,
        "time": 22
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size5_Class4",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 388800,
      "mass": 32,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "maximum": 9,
        "range": 3.96,
        "time": 18
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size5_Class5",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 777600,
      "mass": 20,
      "power": 0.7,
      "integrity": null,
      "stats": {
        "maximum": 6,
        "range": 4.62,
        "time": 13
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size7_Class1",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 437400,
      "mass": 80,
      "power": 0.42,
      "integrity": null,
      "stats": {
        "maximum": 18,
        "range": 2.58,
        "time": 25
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size7_Class2",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 874800,
      "mass": 32,
      "power": 0.56,
      "integrity": null,
      "stats": {
        "maximum": 12,
        "range": 3.44,
        "time": 22
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size7_Class3",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 1749600,
      "mass": 80,
      "power": 0.7,
      "integrity": null,
      "stats": {
        "maximum": 15,
        "range": 4.3,
        "time": 18
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size7_Class4",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 3499200,
      "mass": 128,
      "power": 0.84,
      "integrity": null,
      "stats": {
        "maximum": 18,
        "range": 5.16,
        "time": 14
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_ResourceSiphon_Size7_Class5",
      "category": "internal",
      "name": "Hatch Breaker Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "hb",
      "cost": 6998400,
      "mass": 80,
      "power": 0.98,
      "integrity": null,
      "stats": {
        "maximum": 12,
        "range": 6.02,
        "time": 11
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_DroneControl_UnkVesselResearch",
      "category": "internal",
      "name": "Research Limpet Controller",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rsl",
      "cost": 1749600,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 20,
      "stats": {
        "maximum": 1,
        "range": 2,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1978,
      "mass": 2.5,
      "power": 2,
      "integrity": 46,
      "stats": {
        "maxmass": 72,
        "maxmul": 1.03,
        "minmass": 24,
        "minmul": 0.83,
        "optmass": 48,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class1_free",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 5934,
      "mass": 1,
      "power": 2.25,
      "integrity": 41,
      "stats": {
        "maxmass": 81,
        "maxmul": 1.06,
        "minmass": 27,
        "minmul": 0.86,
        "optmass": 54,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 17803,
      "mass": 2.5,
      "power": 2.5,
      "integrity": 51,
      "stats": {
        "maxmass": 90,
        "maxmul": 1.1,
        "minmass": 30,
        "minmul": 0.9,
        "optmass": 60,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 53408,
      "mass": 4,
      "power": 2.75,
      "integrity": 61,
      "stats": {
        "maxmass": 99,
        "maxmul": 1.13,
        "minmass": 33,
        "minmul": 0.93,
        "optmass": 66,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 160224,
      "mass": 2.5,
      "power": 3,
      "integrity": 56,
      "stats": {
        "maxmass": 108,
        "maxmul": 1.16,
        "minmass": 36,
        "minmul": 0.96,
        "optmass": 72,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size2_Class5_Fast",
      "category": "standard",
      "name": "Enhanced Performance Thrusters",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1610080,
      "mass": 2.5,
      "power": 4,
      "integrity": 40,
      "stats": {
        "maxmass": 120,
        "maxmul": 1.367,
        "maxmulacceleration": 1.2,
        "maxmulrotation": 1.3,
        "maxmulspeed": 1.6,
        "minmass": 50,
        "minmul": 0.9,
        "minmulacceleration": 0.9,
        "minmulrotation": 0.9,
        "minmulspeed": 0.9,
        "optmass": 60,
        "optmul": 1.15,
        "optmulacceleration": 1.1,
        "optmulrotation": 1.1,
        "optmulspeed": 1.25
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 6271,
      "mass": 5,
      "power": 2.48,
      "integrity": 58,
      "stats": {
        "maxmass": 120,
        "maxmul": 1.03,
        "minmass": 40,
        "minmul": 0.83,
        "optmass": 80,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 18812,
      "mass": 2,
      "power": 2.79,
      "integrity": 51,
      "stats": {
        "maxmass": 135,
        "maxmul": 1.06,
        "minmass": 45,
        "minmul": 0.86,
        "optmass": 90,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 56435,
      "mass": 5,
      "power": 3.1,
      "integrity": 64,
      "stats": {
        "maxmass": 150,
        "maxmul": 1.1,
        "minmass": 50,
        "minmul": 0.9,
        "optmass": 100,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 169304,
      "mass": 8,
      "power": 3.41,
      "integrity": 77,
      "stats": {
        "maxmass": 165,
        "maxmul": 1.13,
        "minmass": 55,
        "minmul": 0.93,
        "optmass": 110,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 507912,
      "mass": 5,
      "power": 3.72,
      "integrity": 72,
      "stats": {
        "maxmass": 180,
        "maxmul": 1.16,
        "minmass": 60,
        "minmul": 0.96,
        "optmass": 120,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size3_Class5_Fast",
      "category": "standard",
      "name": "Enhanced Performance Thrusters",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 5103950,
      "mass": 5,
      "power": 5,
      "integrity": 55,
      "stats": {
        "maxmass": 200,
        "maxmul": 1.367,
        "maxmulacceleration": 1.2,
        "maxmulrotation": 1.3,
        "maxmulspeed": 1.6,
        "minmass": 70,
        "minmul": 0.9,
        "minmulacceleration": 0.9,
        "minmulrotation": 0.9,
        "minmulspeed": 0.9,
        "optmass": 90,
        "optmul": 1.15,
        "optmulacceleration": 1.1,
        "optmulrotation": 1.1,
        "optmulspeed": 1.25
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size4_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 19878,
      "mass": 10,
      "power": 3.28,
      "integrity": 72,
      "stats": {
        "maxmass": 420,
        "maxmul": 1.03,
        "minmass": 140,
        "minmul": 0.83,
        "optmass": 280,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size4_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 59633,
      "mass": 4,
      "power": 3.69,
      "integrity": 64,
      "stats": {
        "maxmass": 472.5,
        "maxmul": 1.06,
        "minmass": 157.5,
        "minmul": 0.86,
        "optmass": 315,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size4_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 178898,
      "mass": 10,
      "power": 4.1,
      "integrity": 80,
      "stats": {
        "maxmass": 525,
        "maxmul": 1.1,
        "minmass": 175,
        "minmul": 0.9,
        "optmass": 350,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size4_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 536693,
      "mass": 16,
      "power": 4.51,
      "integrity": 96,
      "stats": {
        "maxmass": 577.5,
        "maxmul": 1.13,
        "minmass": 192.5,
        "minmul": 0.93,
        "optmass": 385,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size4_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1610080,
      "mass": 10,
      "power": 4.92,
      "integrity": 88,
      "stats": {
        "maxmass": 630,
        "maxmul": 1.16,
        "minmass": 210,
        "minmul": 0.96,
        "optmass": 420,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size5_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 63012,
      "mass": 20,
      "power": 4.08,
      "integrity": 86,
      "stats": {
        "maxmass": 840,
        "maxmul": 1.03,
        "minmass": 280,
        "minmul": 0.83,
        "optmass": 560,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size5_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 189035,
      "mass": 8,
      "power": 4.59,
      "integrity": 77,
      "stats": {
        "maxmass": 945,
        "maxmul": 1.06,
        "minmass": 315,
        "minmul": 0.86,
        "optmass": 630,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size5_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 567106,
      "mass": 20,
      "power": 5.1,
      "integrity": 96,
      "stats": {
        "maxmass": 1050,
        "maxmul": 1.1,
        "minmass": 350,
        "minmul": 0.9,
        "optmass": 700,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size5_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1701318,
      "mass": 32,
      "power": 5.61,
      "integrity": 115,
      "stats": {
        "maxmass": 1155,
        "maxmul": 1.13,
        "minmass": 385,
        "minmul": 0.93,
        "optmass": 770,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size5_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 5103953,
      "mass": 20,
      "power": 6.12,
      "integrity": 106,
      "stats": {
        "maxmass": 1260,
        "maxmul": 1.16,
        "minmass": 420,
        "minmul": 0.96,
        "optmass": 840,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size6_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 199747,
      "mass": 40,
      "power": 5.04,
      "integrity": 102,
      "stats": {
        "maxmass": 1440,
        "maxmul": 1.03,
        "minmass": 480,
        "minmul": 0.83,
        "optmass": 960,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size6_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 599242,
      "mass": 16,
      "power": 5.67,
      "integrity": 90,
      "stats": {
        "maxmass": 1620,
        "maxmul": 1.06,
        "minmass": 540,
        "minmul": 0.86,
        "optmass": 1080,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size6_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1797726,
      "mass": 40,
      "power": 6.3,
      "integrity": 113,
      "stats": {
        "maxmass": 1800,
        "maxmul": 1.1,
        "minmass": 600,
        "minmul": 0.9,
        "optmass": 1200,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size6_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 5393177,
      "mass": 64,
      "power": 6.93,
      "integrity": 136,
      "stats": {
        "maxmass": 1980,
        "maxmul": 1.13,
        "minmass": 660,
        "minmul": 0.93,
        "optmass": 1320,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size6_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 16179531,
      "mass": 40,
      "power": 7.56,
      "integrity": 124,
      "stats": {
        "maxmass": 2160,
        "maxmul": 1.16,
        "minmass": 720,
        "minmul": 0.96,
        "optmass": 1440,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 633199,
      "mass": 80,
      "power": 6.08,
      "integrity": 118,
      "stats": {
        "maxmass": 2160,
        "maxmul": 1.03,
        "minmass": 720,
        "minmul": 0.83,
        "optmass": 1440,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 1899597,
      "mass": 32,
      "power": 6.84,
      "integrity": 105,
      "stats": {
        "maxmass": 2430,
        "maxmul": 1.06,
        "minmass": 810,
        "minmul": 0.86,
        "optmass": 1620,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 5698790,
      "mass": 80,
      "power": 7.6,
      "integrity": 131,
      "stats": {
        "maxmass": 2700,
        "maxmul": 1.1,
        "minmass": 900,
        "minmul": 0.9,
        "optmass": 1800,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 17096371,
      "mass": 128,
      "power": 8.36,
      "integrity": 157,
      "stats": {
        "maxmass": 2970,
        "maxmul": 1.13,
        "minmass": 990,
        "minmul": 0.93,
        "optmass": 1980,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 51289112,
      "mass": 80,
      "power": 9.12,
      "integrity": 144,
      "stats": {
        "maxmass": 3240,
        "maxmul": 1.16,
        "minmass": 1080,
        "minmul": 0.96,
        "optmass": 2160,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size7_Class5_GravityOptimised_MkII",
      "category": "standard",
      "name": "Mk II Gravity Optimised Thrusters",
      "ship": "explorer_nx",
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 68368390,
      "mass": 80,
      "power": 9.12,
      "integrity": 144,
      "stats": {
        "maxmass": 3240,
        "maxmul": 1.16,
        "minmass": 1080,
        "minmul": 0.96,
        "optmass": 2160,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size8_Class1",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 2007241,
      "mass": 160,
      "power": 7.2,
      "integrity": 135,
      "stats": {
        "maxmass": 3360,
        "maxmul": 1.03,
        "minmass": 1120,
        "minmul": 0.83,
        "optmass": 2240,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size8_Class2",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 6021722,
      "mass": 64,
      "power": 8.1,
      "integrity": 120,
      "stats": {
        "maxmass": 3780,
        "maxmul": 1.06,
        "minmass": 1260,
        "minmul": 0.86,
        "optmass": 2520,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size8_Class3",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 18065165,
      "mass": 160,
      "power": 9,
      "integrity": 150,
      "stats": {
        "maxmass": 4200,
        "maxmul": 1.1,
        "minmass": 1400,
        "minmul": 0.9,
        "optmass": 2800,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size8_Class4",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 54195495,
      "mass": 256,
      "power": 9.9,
      "integrity": 180,
      "stats": {
        "maxmass": 4620,
        "maxmul": 1.13,
        "minmass": 1540,
        "minmul": 0.93,
        "optmass": 3080,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Engine_Size8_Class5",
      "category": "standard",
      "name": "Thrusters",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "t",
      "cost": 162586486,
      "mass": 160,
      "power": 10.8,
      "integrity": 165,
      "stats": {
        "maxmass": 5040,
        "maxmul": 1.16,
        "minmass": 1680,
        "minmul": 0.96,
        "optmass": 3360,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ExpModuleStabiliser_Size3_Class3",
      "category": "internal",
      "name": "Experimental Weapon Stabiliser",
      "ship": null,
      "class": 3,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": "ews",
      "cost": 2000000,
      "mass": 8,
      "power": 0,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_ExpModuleStabiliser_Size5_Class3",
      "category": "internal",
      "name": "Experimental Weapon Stabiliser",
      "ship": null,
      "class": 5,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": "ews",
      "cost": 4000000,
      "mass": 20,
      "power": 0,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size5_Class1",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fh",
      "cost": 575643,
      "mass": 20,
      "power": 0.25,
      "integrity": 60,
      "stats": {
        "bays": 1,
        "fightercost": 1030,
        "rebuildsperbay": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size5_Class1_Free",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size6_Class1",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fh",
      "cost": 1869340,
      "mass": 40,
      "power": 0.35,
      "integrity": 80,
      "stats": {
        "bays": 2,
        "fightercost": 1030,
        "rebuildsperbay": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size6_Class1_Free",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size7_Class1",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fh",
      "cost": 2369320,
      "mass": 60,
      "power": 0.35,
      "integrity": 120,
      "stats": {
        "bays": 2,
        "fightercost": 1030,
        "rebuildsperbay": 15
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBay_Size7_Class1_Free",
      "category": "internal",
      "name": "Vessel Hangar",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size5_Class1",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size5_Class1_Free",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size6_Class1",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size6_Class1_Free",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size7_Class1",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FighterBayMk2_Size7_Class1_Free",
      "category": "internal",
      "name": "Mk II Vessel Hangar",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size1_Class1",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 12000,
      "mass": 1.3,
      "power": 0.14,
      "integrity": 32,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size1_Class2",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 36000,
      "mass": 0.5,
      "power": 0.18,
      "integrity": 24,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size1_Class3",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 108000,
      "mass": 1.3,
      "power": 0.23,
      "integrity": 40,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size1_Class4",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 324000,
      "mass": 2,
      "power": 0.28,
      "integrity": 56,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size1_Class5",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 972000,
      "mass": 1.3,
      "power": 0.32,
      "integrity": 48,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size2_Class1",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 33600,
      "mass": 2.5,
      "power": 0.17,
      "integrity": 41,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size2_Class2",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 100800,
      "mass": 1,
      "power": 0.22,
      "integrity": 51,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size2_Class3",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 302400,
      "mass": 2.5,
      "power": 0.28,
      "integrity": 51,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size2_Class4",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 907200,
      "mass": 4,
      "power": 0.34,
      "integrity": 71,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size2_Class5",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 2721600,
      "mass": 2.5,
      "power": 0.39,
      "integrity": 61,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size3_Class1",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 94080,
      "mass": 5,
      "power": 0.2,
      "integrity": 51,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size3_Class2",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 282240,
      "mass": 2,
      "power": 0.27,
      "integrity": 38,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size3_Class3",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 846720,
      "mass": 5,
      "power": 0.34,
      "integrity": 64,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 11
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size3_Class4",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 2540160,
      "mass": 8,
      "power": 0.41,
      "integrity": 90,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size3_Class5",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 7620480,
      "mass": 5,
      "power": 0.48,
      "integrity": 77,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 13
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size4_Class1",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 263424,
      "mass": 10,
      "power": 0.25,
      "integrity": 64,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size4_Class2",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 790272,
      "mass": 4,
      "power": 0.33,
      "integrity": 48,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 13
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size4_Class3",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 2370816,
      "mass": 10,
      "power": 0.41,
      "integrity": 80,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 14
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size4_Class4",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 7112448,
      "mass": 16,
      "power": 0.49,
      "integrity": 112,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 15
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FSDInterdictor_Size4_Class5",
      "category": "internal",
      "name": "Frame Shift Drive Interdictor",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fi",
      "cost": 21337344,
      "mass": 10,
      "power": 0.57,
      "integrity": 96,
      "stats": {
        "boot": 15,
        "facinglimit": 50,
        "ranget": 16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size1_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 309,
      "mass": null,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "rate": 18
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size1_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 1285,
      "mass": null,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "rate": 24
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size1_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 5142,
      "mass": null,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "rate": 30
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size1_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 20568,
      "mass": null,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "rate": 36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size1_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 82270,
      "mass": null,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "rate": 42
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size2_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 1068,
      "mass": null,
      "power": 0.17,
      "integrity": null,
      "stats": {
        "rate": 32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size2_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 4451,
      "mass": null,
      "power": 0.22,
      "integrity": null,
      "stats": {
        "rate": 43
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size2_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 17803,
      "mass": null,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "rate": 54
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size2_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 71211,
      "mass": null,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "rate": 65
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size2_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 284844,
      "mass": null,
      "power": 0.39,
      "integrity": null,
      "stats": {
        "rate": 75
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size3_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 3386,
      "mass": null,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "rate": 75
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size3_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 14109,
      "mass": null,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "rate": 100
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size3_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 56435,
      "mass": null,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "rate": 126
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size3_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 225738,
      "mass": null,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "rate": 151
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size3_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 902954,
      "mass": null,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "rate": 176
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size4_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 10734,
      "mass": null,
      "power": 0.25,
      "integrity": null,
      "stats": {
        "rate": 147
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size4_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 44724,
      "mass": null,
      "power": 0.33,
      "integrity": null,
      "stats": {
        "rate": 196
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size4_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 178898,
      "mass": null,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "rate": 245
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size4_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 715591,
      "mass": null,
      "power": 0.49,
      "integrity": null,
      "stats": {
        "rate": 294
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size4_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 2862364,
      "mass": null,
      "power": 0.57,
      "integrity": null,
      "stats": {
        "rate": 342
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size5_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 34026,
      "mass": null,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "rate": 247
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size5_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 141776,
      "mass": null,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "rate": 330
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size5_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 567106,
      "mass": null,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "rate": 412
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size5_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 2268424,
      "mass": null,
      "power": 0.6,
      "integrity": null,
      "stats": {
        "rate": 494
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size5_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 9073694,
      "mass": null,
      "power": 0.7,
      "integrity": null,
      "stats": {
        "rate": 577
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size6_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 107864,
      "mass": null,
      "power": 0.35,
      "integrity": null,
      "stats": {
        "rate": 376
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size6_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 449431,
      "mass": null,
      "power": 0.47,
      "integrity": null,
      "stats": {
        "rate": 502
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size6_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 1797726,
      "mass": null,
      "power": 0.59,
      "integrity": null,
      "stats": {
        "rate": 627
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size6_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 7190903,
      "mass": null,
      "power": 0.71,
      "integrity": null,
      "stats": {
        "rate": 752
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size6_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 28763610,
      "mass": null,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "rate": 878
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size7_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 341927,
      "mass": null,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "rate": 534
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size7_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 1424698,
      "mass": null,
      "power": 0.55,
      "integrity": null,
      "stats": {
        "rate": 712
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size7_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 5698790,
      "mass": null,
      "power": 0.69,
      "integrity": null,
      "stats": {
        "rate": 890
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size7_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 22795161,
      "mass": null,
      "power": 0.83,
      "integrity": null,
      "stats": {
        "rate": 1068
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size7_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 91180644,
      "mass": null,
      "power": 0.97,
      "integrity": null,
      "stats": {
        "rate": 1245
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size8_Class1",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 1083910,
      "mass": null,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "rate": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size8_Class2",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 4516291,
      "mass": null,
      "power": 0.64,
      "integrity": null,
      "stats": {
        "rate": 960
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size8_Class3",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 18065165,
      "mass": null,
      "power": 0.8,
      "integrity": null,
      "stats": {
        "rate": 1200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size8_Class4",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 72260660,
      "mass": null,
      "power": 0.96,
      "integrity": null,
      "stats": {
        "rate": 1440
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelScoop_Size8_Class5",
      "category": "internal",
      "name": "Fuel Scoop",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fs",
      "cost": 289042641,
      "mass": null,
      "power": 1.12,
      "integrity": null,
      "stats": {
        "rate": 1680
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size1_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 1000,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size1_Class3_free",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size2_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 3750,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size3_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 7060,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size4_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 24730,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size5_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 97750,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size6_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 341580,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 64
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size7_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 1780910,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 128
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_FuelTank_Size8_Class3",
      "category": "standard",
      "name": "Fuel Tank",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ft",
      "cost": 5428431,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {
        "fuel": 256
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianFSDBooster_Size1",
      "category": "internal",
      "name": "Guardian FSD Booster",
      "ship": null,
      "class": 1,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "gfsb",
      "cost": 405022,
      "mass": 1.3,
      "power": 0.75,
      "integrity": 32,
      "stats": {
        "jumpboost": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianFSDBooster_Size2",
      "category": "internal",
      "name": "Guardian FSD Booster",
      "ship": null,
      "class": 2,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "gfsb",
      "cost": 810521,
      "mass": 1.3,
      "power": 0.98,
      "integrity": 32,
      "stats": {
        "jumpboost": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianFSDBooster_Size3",
      "category": "internal",
      "name": "Guardian FSD Booster",
      "ship": null,
      "class": 3,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "gfsb",
      "cost": 1620431,
      "mass": 1.3,
      "power": 1.27,
      "integrity": 32,
      "stats": {
        "jumpboost": 7.75
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianFSDBooster_Size4",
      "category": "internal",
      "name": "Guardian FSD Booster",
      "ship": null,
      "class": 4,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "gfsb",
      "cost": 3245013,
      "mass": 1.3,
      "power": 1.65,
      "integrity": 32,
      "stats": {
        "jumpboost": 9.25
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianFSDBooster_Size5",
      "category": "internal",
      "name": "Guardian FSD Booster",
      "ship": null,
      "class": 5,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": "gfsb",
      "cost": 6483101,
      "mass": 1.3,
      "power": 2.14,
      "integrity": 32,
      "stats": {
        "jumpboost": 10.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 10000,
      "mass": 2,
      "power": 0.45,
      "integrity": null,
      "stats": {
        "hullreinforcement": 100,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 30000,
      "mass": 1,
      "power": 0.56,
      "integrity": null,
      "stats": {
        "hullreinforcement": 138,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 24000,
      "mass": 4,
      "power": 0.68,
      "integrity": null,
      "stats": {
        "hullreinforcement": 188,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 72000,
      "mass": 2,
      "power": 0.79,
      "integrity": null,
      "stats": {
        "hullreinforcement": 238,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 57600,
      "mass": 8,
      "power": 0.9,
      "integrity": null,
      "stats": {
        "hullreinforcement": 288,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 172800,
      "mass": 4,
      "power": 1.01,
      "integrity": null,
      "stats": {
        "hullreinforcement": 325,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 138240,
      "mass": 16,
      "power": 1.13,
      "integrity": null,
      "stats": {
        "hullreinforcement": 375,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 414720,
      "mass": 8,
      "power": 1.24,
      "integrity": null,
      "stats": {
        "hullreinforcement": 413,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 331778,
      "mass": 32,
      "power": 1.35,
      "integrity": null,
      "stats": {
        "hullreinforcement": 450,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianHullReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Guardian Hull Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ghrp",
      "cost": 995330,
      "mass": 16,
      "power": 1.46,
      "integrity": null,
      "stats": {
        "hullreinforcement": 488,
        "causres": 0.05,
        "explres": 0,
        "kinres": 0,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 10000,
      "mass": 2,
      "power": 0.27,
      "integrity": 85,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 30000,
      "mass": 1,
      "power": 0.34,
      "integrity": 77,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 24000,
      "mass": 4,
      "power": 0.41,
      "integrity": 127,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 72000,
      "mass": 2,
      "power": 0.47,
      "integrity": 116,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 57600,
      "mass": 8,
      "power": 0.54,
      "integrity": 187,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 172800,
      "mass": 4,
      "power": 0.61,
      "integrity": 171,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 138240,
      "mass": 16,
      "power": 0.68,
      "integrity": 286,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 414720,
      "mass": 8,
      "power": 0.74,
      "integrity": 259,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 331778,
      "mass": 32,
      "power": 0.81,
      "integrity": 424,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianModuleReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Guardian Module Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gmrp",
      "cost": 995330,
      "mass": 16,
      "power": 0.88,
      "integrity": 385,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size1",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 40957,
      "mass": 1.4,
      "power": 0.62,
      "integrity": 56,
      "stats": {
        "engcap": 9,
        "engrate": 0.8,
        "syscap": 10,
        "sysrate": 0.8,
        "wepcap": 10,
        "weprate": 2.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size2",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 111600,
      "mass": 2.6,
      "power": 0.73,
      "integrity": 45,
      "stats": {
        "engcap": 11,
        "engrate": 1,
        "syscap": 11,
        "sysrate": 1,
        "wepcap": 13,
        "weprate": 3.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size3",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 311365,
      "mass": 5.25,
      "power": 0.78,
      "integrity": 56,
      "stats": {
        "engcap": 14,
        "engrate": 1.7,
        "syscap": 14,
        "sysrate": 1.7,
        "wepcap": 13,
        "weprate": 3.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size4",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 868708,
      "mass": 10.5,
      "power": 0.87,
      "integrity": 56,
      "stats": {
        "engcap": 17,
        "engrate": 2.5,
        "syscap": 14,
        "sysrate": 1.7,
        "wepcap": 22,
        "weprate": 4.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size5",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 2423690,
      "mass": 21,
      "power": 0.96,
      "integrity": 56,
      "stats": {
        "engcap": 22,
        "engrate": 3.3,
        "syscap": 22,
        "sysrate": 3.3,
        "wepcap": 29,
        "weprate": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size6",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 6762091,
      "mass": 42,
      "power": 1.07,
      "integrity": 56,
      "stats": {
        "engcap": 26,
        "engrate": 4.2,
        "syscap": 26,
        "sysrate": 4.2,
        "wepcap": 35,
        "weprate": 7.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size7",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 18866235,
      "mass": 84,
      "power": 1.16,
      "integrity": 56,
      "stats": {
        "engcap": 31,
        "engrate": 5.2,
        "syscap": 31,
        "sysrate": 5.2,
        "wepcap": 43,
        "weprate": 8.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerDistributor_Size8",
      "category": "internal",
      "name": "Guardian Hybrid Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 52636793,
      "mass": 168,
      "power": 1.25,
      "integrity": 56,
      "stats": {
        "engcap": 36,
        "engrate": 6.2,
        "syscap": 36,
        "sysrate": 6.2,
        "wepcap": 50,
        "weprate": 10.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size2",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 192165,
      "mass": 1.5,
      "power": null,
      "integrity": 56,
      "stats": {
        "eff": 0.5,
        "pgen": 12.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size3",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 576493,
      "mass": 2.9,
      "power": null,
      "integrity": 70,
      "stats": {
        "eff": 0.5,
        "pgen": 15.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size4",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1729480,
      "mass": 5.9,
      "power": null,
      "integrity": 88,
      "stats": {
        "eff": 0.5,
        "pgen": 20.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size5",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 5188441,
      "mass": 11.7,
      "power": null,
      "integrity": 106,
      "stats": {
        "eff": 0.5,
        "pgen": 26.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size6",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 15565317,
      "mass": 23.4,
      "power": null,
      "integrity": 124,
      "stats": {
        "eff": 0.5,
        "pgen": 33.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size7",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 46695951,
      "mass": 46.8,
      "power": null,
      "integrity": 144,
      "stats": {
        "eff": 0.5,
        "pgen": 39.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianPowerplant_Size8",
      "category": "internal",
      "name": "Guardian Hybrid Power Plant",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 140087850,
      "mass": 93.6,
      "power": null,
      "integrity": 165,
      "stats": {
        "eff": 0.5,
        "pgen": 47.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 10000,
      "mass": 2,
      "power": 0.35,
      "integrity": 36,
      "stats": {
        "shieldaddition": 44
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 30000,
      "mass": 1,
      "power": 0.46,
      "integrity": 36,
      "stats": {
        "shieldaddition": 61
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 24000,
      "mass": 4,
      "power": 0.56,
      "integrity": 36,
      "stats": {
        "shieldaddition": 83
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 72000,
      "mass": 2,
      "power": 0.67,
      "integrity": 36,
      "stats": {
        "shieldaddition": 105
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 57600,
      "mass": 8,
      "power": 0.74,
      "integrity": 36,
      "stats": {
        "shieldaddition": 127
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 172800,
      "mass": 4,
      "power": 0.84,
      "integrity": 36,
      "stats": {
        "shieldaddition": 143
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 138240,
      "mass": 16,
      "power": 0.95,
      "integrity": 36,
      "stats": {
        "shieldaddition": 165
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 414720,
      "mass": 8,
      "power": 1.05,
      "integrity": 36,
      "stats": {
        "shieldaddition": 182
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 331778,
      "mass": 32,
      "power": 1.16,
      "integrity": 36,
      "stats": {
        "shieldaddition": 198
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_GuardianShieldReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Guardian Shield Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "gsrp",
      "cost": 995330,
      "mass": 16,
      "power": 1.26,
      "integrity": 36,
      "stats": {
        "shieldaddition": 215
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 5000,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 80,
        "causres": 0,
        "explres": 0.005,
        "kinres": 0.005,
        "thermres": 0.005
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 15000,
      "mass": 1,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 110,
        "causres": 0,
        "explres": 0.005,
        "kinres": 0.005,
        "thermres": 0.005
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 12000,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 150,
        "causres": 0,
        "explres": 0.01,
        "kinres": 0.01,
        "thermres": 0.01
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 36000,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 190,
        "causres": 0,
        "explres": 0.01,
        "kinres": 0.01,
        "thermres": 0.01
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 28000,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 230,
        "causres": 0,
        "explres": 0.015,
        "kinres": 0.015,
        "thermres": 0.015
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 84000,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 260,
        "causres": 0,
        "explres": 0.015,
        "kinres": 0.015,
        "thermres": 0.015
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 65000,
      "mass": 16,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 300,
        "causres": 0,
        "explres": 0.02,
        "kinres": 0.02,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 195000,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 330,
        "causres": 0,
        "explres": 0.02,
        "kinres": 0.02,
        "thermres": 0.02
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 150000,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 360,
        "causres": 0,
        "explres": 0.025,
        "kinres": 0.025,
        "thermres": 0.025
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_HullReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Hull Reinforcement Package",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "hr",
      "cost": 450000,
      "mass": 16,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 390,
        "causres": 0,
        "explres": 0.025,
        "kinres": 0.025,
        "thermres": 0.025
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 21363,
      "mass": 2.5,
      "power": 0.2,
      "integrity": 51,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2,
        "maxfuel": 0.6,
        "optmass": 60
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 64090,
      "mass": 2.5,
      "power": 0.25,
      "integrity": 57,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2,
        "maxfuel": 0.9,
        "optmass": 90
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 64090,
      "mass": 2.5,
      "power": 0.25,
      "integrity": 57,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2,
        "maxfuel": 0.9,
        "optmass": 90
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 64090,
      "mass": 2.5,
      "power": 0.25,
      "integrity": 57,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2,
        "maxfuel": 0.9,
        "optmass": 90
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 192269,
      "mass": 2.5,
      "power": 0.3,
      "integrity": 64,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2,
        "maxfuel": 1,
        "optmass": 100
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 67722,
      "mass": 5,
      "power": 0.3,
      "integrity": 64,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.15,
        "maxfuel": 1.2,
        "optmass": 100
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 203165,
      "mass": 2,
      "power": 0.38,
      "integrity": 70,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.15,
        "maxfuel": 1.8,
        "optmass": 150
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 203165,
      "mass": 5,
      "power": 0.38,
      "integrity": 70,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.15,
        "maxfuel": 1.8,
        "optmass": 150
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 203165,
      "mass": 5,
      "power": 0.38,
      "integrity": 70,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.15,
        "maxfuel": 1.8,
        "optmass": 150
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 609494,
      "mass": 5,
      "power": 0.45,
      "integrity": 80,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2.15,
        "maxfuel": 1.9,
        "optmass": 167
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 214677,
      "mass": 10,
      "power": 0.3,
      "integrity": 80,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.3,
        "maxfuel": 2,
        "optmass": 350
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 644032,
      "mass": 4,
      "power": 0.38,
      "integrity": 90,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.3,
        "maxfuel": 3,
        "optmass": 525
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 644032,
      "mass": 10,
      "power": 0.38,
      "integrity": 90,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.3,
        "maxfuel": 3,
        "optmass": 525
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 644032,
      "mass": 10,
      "power": 0.38,
      "integrity": 90,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.3,
        "maxfuel": 3,
        "optmass": 525
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1932096,
      "mass": 10,
      "power": 0.45,
      "integrity": 100,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2.3,
        "maxfuel": 3.2,
        "optmass": 585
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 623816,
      "mass": 20,
      "power": 0.45,
      "integrity": 95,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.45,
        "maxfuel": 3.3,
        "optmass": 700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 2041581,
      "mass": 8,
      "power": 0.5,
      "integrity": 110,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5,
        "optmass": 1050
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 2041581,
      "mass": 20,
      "power": 0.5,
      "integrity": 110,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5,
        "optmass": 1050
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 2041581,
      "mass": 20,
      "power": 0.5,
      "integrity": 110,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5,
        "optmass": 1050
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6124743,
      "mass": 20,
      "power": 0.6,
      "integrity": 120,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2.45,
        "maxfuel": 5.2,
        "optmass": 1175
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 2157271,
      "mass": 40,
      "power": 0.5,
      "integrity": 113,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.6,
        "maxfuel": 5.3,
        "optmass": 1200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6471812,
      "mass": 16,
      "power": 0.63,
      "integrity": 130,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.6,
        "maxfuel": 8,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6471812,
      "mass": 40,
      "power": 0.63,
      "integrity": 130,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.6,
        "maxfuel": 8,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6471812,
      "mass": 40,
      "power": 0.63,
      "integrity": 130,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.6,
        "maxfuel": 8,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 19415437,
      "mass": 40,
      "power": 0.75,
      "integrity": 141,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2.6,
        "maxfuel": 8.3,
        "optmass": 2000
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6838548,
      "mass": 80,
      "power": 0.6,
      "integrity": 131,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.75,
        "maxfuel": 8.5,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515645,
      "mass": 32,
      "power": 0.75,
      "integrity": 2700,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.75,
        "maxfuel": 12.8,
        "optmass": 2700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515645,
      "mass": 80,
      "power": 0.75,
      "integrity": 150,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.75,
        "maxfuel": 12.8,
        "optmass": 2700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515645,
      "mass": 80,
      "power": 0.75,
      "integrity": 150,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.75,
        "maxfuel": 12.8,
        "optmass": 2700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 61546935,
      "mass": 80,
      "power": 0.9,
      "integrity": 164,
      "stats": {
        "fuelmul": 0.013,
        "fuelpower": 2.75,
        "maxfuel": 13.1,
        "optmass": 3000
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class1",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6838550,
      "mass": 160,
      "power": 0.7,
      "integrity": 150,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.9,
        "maxfuel": 13.6,
        "optmass": 2800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class2",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515650,
      "mass": 64,
      "power": 0.88,
      "integrity": 169,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.9,
        "maxfuel": 20.4,
        "optmass": 4200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class3",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515650,
      "mass": 160,
      "power": 0.88,
      "integrity": 169,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.9,
        "maxfuel": 20.4,
        "optmass": 4200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class4",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 20515650,
      "mass": 160,
      "power": 0.88,
      "integrity": 169,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.9,
        "maxfuel": 20.4,
        "optmass": 4200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class5",
      "category": "standard",
      "name": "Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 61546940,
      "mass": 160,
      "power": 1.05,
      "integrity": 188,
      "stats": {
        "boot": 10,
        "fuelmul": 0.013,
        "fuelpower": 2.9,
        "maxfuel": 20.7,
        "optmass": 4670
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size8_Class5_OverchargeBooster_MkII",
      "category": "standard",
      "name": "Mk II Supercharge Optimised Frame Shift Drive (SCO)",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 82042060,
      "mass": 160,
      "power": 1.05,
      "integrity": 188,
      "stats": {
        "boot": 10,
        "fuelmul": 0.011,
        "fuelpower": 2.5025,
        "maxfuel": 6.8,
        "optmass": 4670
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1978,
      "mass": 2.5,
      "power": 0.16,
      "integrity": 46,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2,
        "maxfuel": 0.6,
        "optmass": 48
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class1_free",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 5934,
      "mass": 1,
      "power": 0.18,
      "integrity": 41,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2,
        "maxfuel": 0.6,
        "optmass": 54
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 17803,
      "mass": 2.5,
      "power": 0.2,
      "integrity": 51,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2,
        "maxfuel": 0.6,
        "optmass": 60
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 53408,
      "mass": 4,
      "power": 0.25,
      "integrity": 77,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2,
        "maxfuel": 0.8,
        "optmass": 75
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size2_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 160224,
      "mass": 2.5,
      "power": 0.3,
      "integrity": 64,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2,
        "maxfuel": 0.9,
        "optmass": 90
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size3_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6271,
      "mass": 5,
      "power": 0.24,
      "integrity": 58,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2.15,
        "maxfuel": 1.2,
        "optmass": 80
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size3_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 18812,
      "mass": 2,
      "power": 0.27,
      "integrity": 51,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.15,
        "maxfuel": 1.2,
        "optmass": 90
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size3_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 56435,
      "mass": 5,
      "power": 0.3,
      "integrity": 64,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.15,
        "maxfuel": 1.2,
        "optmass": 100
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size3_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 169304,
      "mass": 8,
      "power": 0.38,
      "integrity": 96,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.15,
        "maxfuel": 1.5,
        "optmass": 125
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size3_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 507912,
      "mass": 5,
      "power": 0.45,
      "integrity": 80,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.15,
        "maxfuel": 1.8,
        "optmass": 150
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size4_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 19878,
      "mass": 10,
      "power": 0.24,
      "integrity": 72,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2.3,
        "maxfuel": 2,
        "optmass": 280
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size4_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 59633,
      "mass": 4,
      "power": 0.27,
      "integrity": 64,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.3,
        "maxfuel": 2,
        "optmass": 315
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size4_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 178898,
      "mass": 10,
      "power": 0.3,
      "integrity": 80,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.3,
        "maxfuel": 2,
        "optmass": 350
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size4_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 536693,
      "mass": 16,
      "power": 0.38,
      "integrity": 120,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.3,
        "maxfuel": 2.5,
        "optmass": 437.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size4_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1610080,
      "mass": 10,
      "power": 0.45,
      "integrity": 100,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.3,
        "maxfuel": 3,
        "optmass": 525
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 63012,
      "mass": 20,
      "power": 0.32,
      "integrity": 86,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2.45,
        "maxfuel": 3.3,
        "optmass": 560
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 189035,
      "mass": 8,
      "power": 0.36,
      "integrity": 77,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.45,
        "maxfuel": 3.3,
        "optmass": 630
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 567106,
      "mass": 20,
      "power": 0.4,
      "integrity": 96,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.45,
        "maxfuel": 3.3,
        "optmass": 700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1701318,
      "mass": 32,
      "power": 0.5,
      "integrity": 144,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.45,
        "maxfuel": 4.1,
        "optmass": 875
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 5103953,
      "mass": 20,
      "power": 0.6,
      "integrity": 120,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5,
        "optmass": 1050
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size6_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 199747,
      "mass": 40,
      "power": 0.4,
      "integrity": 102,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2.6,
        "maxfuel": 5.3,
        "optmass": 960
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size6_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 599242,
      "mass": 16,
      "power": 0.45,
      "integrity": 90,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.6,
        "maxfuel": 5.3,
        "optmass": 1080
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size6_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1797726,
      "mass": 40,
      "power": 0.5,
      "integrity": 113,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.6,
        "maxfuel": 5.3,
        "optmass": 1200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size6_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 5393177,
      "mass": 64,
      "power": 0.63,
      "integrity": 170,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.6,
        "maxfuel": 6.6,
        "optmass": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size6_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 16179531,
      "mass": 40,
      "power": 0.75,
      "integrity": 141,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.6,
        "maxfuel": 8,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size7_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 633199,
      "mass": 80,
      "power": 0.48,
      "integrity": 118,
      "stats": {
        "fuelmul": 0.011,
        "fuelpower": 2.75,
        "maxfuel": 8.5,
        "optmass": 1440
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size7_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1899597,
      "mass": 32,
      "power": 0.54,
      "integrity": 105,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.75,
        "maxfuel": 8.5,
        "optmass": 1620
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size7_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 5698790,
      "mass": 80,
      "power": 0.6,
      "integrity": 131,
      "stats": {
        "fuelmul": 0.008,
        "fuelpower": 2.75,
        "maxfuel": 8.5,
        "optmass": 1800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size7_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 17096371,
      "mass": 128,
      "power": 0.75,
      "integrity": 197,
      "stats": {
        "fuelmul": 0.01,
        "fuelpower": 2.75,
        "maxfuel": 10.6,
        "optmass": 2250
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size7_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 51289112,
      "mass": 80,
      "power": 0.9,
      "integrity": 164,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.75,
        "maxfuel": 12.8,
        "optmass": 2700
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size8_Class1",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size8_Class2",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size8_Class3",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size8_Class4",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Hyperdrive_Size8_Class5",
      "category": "standard",
      "name": "Frame Shift Drive",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size2_Class3",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size2_Class3_Free",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size4_Class3",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size4_Class3_Free",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size6_Class3",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeBuggyBay_Size6_Class3_Free",
      "category": "internal",
      "name": "Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeCargoRack_Size6_Class1",
      "category": "internal",
      "name": "Mk II Cargo Rack",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeCargoRack_Size7_Class1",
      "category": "internal",
      "name": "Mk II Cargo Rack",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "crl",
      "cost": 1958680,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 192
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LargeCargoRack_Size8_class1",
      "category": "internal",
      "name": "Mk II Cargo Rack",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "crl",
      "cost": 4929317,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 384
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 517,
      "mass": 1.3,
      "power": 0.32,
      "integrity": 32,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class1_free",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1293,
      "mass": 0.5,
      "power": 0.36,
      "integrity": 36,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 3231,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 40,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 8078,
      "mass": 2,
      "power": 0.44,
      "integrity": 44,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size1_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 20195,
      "mass": 1.3,
      "power": 0.48,
      "integrity": 48,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size2_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1448,
      "mass": 2.5,
      "power": 0.37,
      "integrity": 41,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size2_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 3619,
      "mass": 1,
      "power": 0.41,
      "integrity": 46,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size2_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 9048,
      "mass": 2.5,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size2_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 22619,
      "mass": 4,
      "power": 0.51,
      "integrity": 56,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size2_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 56547,
      "mass": 2.5,
      "power": 0.55,
      "integrity": 61,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size3_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 4053,
      "mass": 5,
      "power": 0.42,
      "integrity": 51,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size3_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 10133,
      "mass": 2,
      "power": 0.48,
      "integrity": 58,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size3_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 25333,
      "mass": 5,
      "power": 0.53,
      "integrity": 64,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size3_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 63333,
      "mass": 8,
      "power": 0.58,
      "integrity": 70,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size3_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 158331,
      "mass": 5,
      "power": 0.64,
      "integrity": 77,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size4_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 11349,
      "mass": 10,
      "power": 0.5,
      "integrity": 64,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size4_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 28373,
      "mass": 4,
      "power": 0.56,
      "integrity": 72,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size4_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 70932,
      "mass": 10,
      "power": 0.62,
      "integrity": 80,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size4_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 177331,
      "mass": 16,
      "power": 0.68,
      "integrity": 88,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size4_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 443328,
      "mass": 10,
      "power": 0.74,
      "integrity": 96,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size5_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 31778,
      "mass": 20,
      "power": 0.57,
      "integrity": 77,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size5_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 79444,
      "mass": 8,
      "power": 0.64,
      "integrity": 86,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size5_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 198611,
      "mass": 20,
      "power": 0.71,
      "integrity": 96,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size5_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 496527,
      "mass": 32,
      "power": 0.78,
      "integrity": 106,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size5_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1241317,
      "mass": 20,
      "power": 0.85,
      "integrity": 115,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size6_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 88978,
      "mass": 40,
      "power": 0.64,
      "integrity": 90,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size6_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 222444,
      "mass": 16,
      "power": 0.72,
      "integrity": 102,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size6_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 556110,
      "mass": 40,
      "power": 0.8,
      "integrity": 113,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size6_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1390275,
      "mass": 64,
      "power": 0.88,
      "integrity": 124,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size6_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 3475688,
      "mass": 40,
      "power": 0.96,
      "integrity": 136,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size7_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 249137,
      "mass": 80,
      "power": 0.72,
      "integrity": 105,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size7_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 622843,
      "mass": 32,
      "power": 0.81,
      "integrity": 118,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size7_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1557108,
      "mass": 80,
      "power": 0.9,
      "integrity": 131,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size7_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 3892770,
      "mass": 128,
      "power": 0.99,
      "integrity": 144,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size7_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 9731925,
      "mass": 80,
      "power": 1.08,
      "integrity": 157,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size8_Class1",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 697584,
      "mass": 160,
      "power": 0.8,
      "integrity": 120,
      "stats": {
        "boot": 1,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size8_Class2",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 1743961,
      "mass": 64,
      "power": 0.9,
      "integrity": 135,
      "stats": {
        "boot": 1,
        "time": 450
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size8_Class3",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 4359903,
      "mass": 160,
      "power": 1,
      "integrity": 150,
      "stats": {
        "boot": 1,
        "time": 600
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size8_Class4",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 10899756,
      "mass": 256,
      "power": 1.1,
      "integrity": 165,
      "stats": {
        "boot": 1,
        "time": 900
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_LifeSupport_Size8_Class5",
      "category": "standard",
      "name": "Life Support",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "ls",
      "cost": 27249391,
      "mass": 160,
      "power": 1.2,
      "integrity": 180,
      "stats": {
        "boot": 1,
        "time": 1500
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 7501,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 72,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 22501,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 99,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 18000,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 135,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 54000,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 171,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 42000,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 207,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 126000,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 234,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 97501,
      "mass": 16,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 270,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 292501,
      "mass": 8,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 297,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 225001,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 324,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MetaAlloyHullReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Meta Alloy Hull Reinforcement",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mahr",
      "cost": 675001,
      "mass": 16,
      "power": null,
      "integrity": null,
      "stats": {
        "hullreinforcement": 351,
        "explres": 0,
        "kinres": 0,
        "thermres": 0,
        "causres": 0.03
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size2_Class1",
      "category": "internal",
      "name": "MkII Economy Class Passenger Cabin",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size3_Class1",
      "category": "internal",
      "name": "MkII Economy Class Passenger Cabin",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size3_Class2",
      "category": "internal",
      "name": "MkII Business Class Passenger Cabin",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size4_Class1",
      "category": "internal",
      "name": "MkII Economy Class Passenger Cabin",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size4_Class2",
      "category": "internal",
      "name": "MkII Business Class Passenger Cabin",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size5_Class1",
      "category": "internal",
      "name": "MkII Economy Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size5_Class2",
      "category": "internal",
      "name": "MkII Business Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size6_Class1",
      "category": "internal",
      "name": "MkII Economy Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkII_PassengerCabin_Size6_Class2",
      "category": "internal",
      "name": "MkII Business Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIIAgileBoost_Engine_Size5_Class5",
      "category": "standard",
      "name": "Mk II Agile Boost Thrusters",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": "mount",
      "guidance": null,
      "group": "t",
      "cost": 6637629,
      "mass": 20,
      "power": 6.29,
      "integrity": 106,
      "stats": {
        "maxmass": 1260,
        "maxmul": 1.16,
        "minmass": 420,
        "minmul": 0.96,
        "optmass": 840,
        "optmul": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size2_Class3",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size2_Class3_Free",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 2,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size4_Class3",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size4_Class3_Free",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 4,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size6_Class3",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_MkIILargeBuggyBay_Size6_Class3_Free",
      "category": "internal",
      "name": "Mk II Large Planetary Vehicle Hangar",
      "ship": null,
      "class": 6,
      "rating": "F",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size1_Class1",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 5000,
      "mass": 2,
      "power": null,
      "integrity": 77,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size1_Class2",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 15000,
      "mass": 1,
      "power": null,
      "integrity": 70,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size2_Class1",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 12000,
      "mass": 4,
      "power": null,
      "integrity": 115,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size2_Class2",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 36000,
      "mass": 2,
      "power": null,
      "integrity": 105,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size3_Class1",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 28000,
      "mass": 8,
      "power": null,
      "integrity": 170,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size3_Class2",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 84000,
      "mass": 4,
      "power": null,
      "integrity": 155,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size4_Class1",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 65000,
      "mass": 16,
      "power": null,
      "integrity": 260,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size4_Class2",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 195000,
      "mass": 8,
      "power": null,
      "integrity": 235,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size5_Class1",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 150000,
      "mass": 32,
      "power": null,
      "integrity": 385,
      "stats": {
        "protection": 0.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size5_Class2",
      "category": "internal",
      "name": "Module Reinforcement Package",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 450000,
      "mass": 16,
      "power": null,
      "integrity": 350,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ModuleReinforcement_Size5_Class2",
      "category": "mercgear",
      "name": "Heavy Duty Module Reinforcement Package",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mrp",
      "cost": 450000,
      "mass": 16,
      "power": null,
      "integrity": 350,
      "stats": {
        "protection": 0.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Mining_Size3_Class1",
      "category": "internal",
      "name": "Mining Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 15000,
      "mass": 12,
      "power": 0.5,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 3.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Mining_Size3_Class3",
      "category": "internal",
      "name": "Mining Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 50000,
      "mass": 10,
      "power": 0.35,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_MiningV2_Size5_Class5",
      "category": "internal",
      "name": "Mk II Mining Multi-Limpet Controller",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 2332800,
      "mass": 64,
      "power": 1.4,
      "integrity": 105,
      "stats": {
        "maximum": 14,
        "range": 9.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Operations_Size3_Class3",
      "category": "internal",
      "name": "Operations Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 50000,
      "mass": 10,
      "power": 0.35,
      "integrity": null,
      "stats": {
        "hacktime": 16,
        "maximum": 4,
        "range": 2.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Operations_Size3_Class4",
      "category": "internal",
      "name": "Operations Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 80000,
      "mass": 15,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "hacktime": 22,
        "maximum": 4,
        "range": 3.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Rescue_Size3_Class2",
      "category": "internal",
      "name": "Rescue Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 30000,
      "mass": 8,
      "power": 0.4,
      "integrity": null,
      "stats": {
        "hacktime": 19,
        "maximum": 4,
        "range": 2.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Rescue_Size3_Class3",
      "category": "internal",
      "name": "Rescue Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 50000,
      "mass": 10,
      "power": 0.35,
      "integrity": null,
      "stats": {
        "hacktime": 16,
        "maximum": 4,
        "range": 2.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Universal_Size7_Class3",
      "category": "internal",
      "name": "Universal Multi Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 4000000,
      "mass": 125,
      "power": 0.8,
      "integrity": null,
      "stats": {
        "hacktime": 8,
        "maximum": 8,
        "range": 6.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Universal_Size7_Class5",
      "category": "internal",
      "name": "Universal Multi Limpet Controller",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 8000000,
      "mass": 140,
      "power": 1.1,
      "integrity": null,
      "stats": {
        "hacktime": 5,
        "maximum": 8,
        "range": 9.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Xeno_Size3_Class3",
      "category": "internal",
      "name": "Xeno Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 50000,
      "mass": 10,
      "power": 0.35,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 5,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_MultiDroneControl_Xeno_Size3_Class4",
      "category": "internal",
      "name": "Xeno Multi Limpet Controller",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "mlc",
      "cost": 80000,
      "mass": 15,
      "power": 0.3,
      "integrity": null,
      "stats": {
        "maximum": 4,
        "range": 5,
        "time": 300
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size2_Class1",
      "category": "internal",
      "name": "Economy Class Passenger Cabin",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pce",
      "cost": 4312,
      "mass": 2.5,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size3_Class1",
      "category": "internal",
      "name": "Economy Class Passenger Cabin",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pce",
      "cost": 8657,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size3_Class2",
      "category": "internal",
      "name": "Business Class Passenger Cabin",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pci",
      "cost": 26705,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size4_Class1",
      "category": "internal",
      "name": "Economy Class Passenger Cabin",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pce",
      "cost": 18954,
      "mass": 10,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size4_Class2",
      "category": "internal",
      "name": "Business Class Passenger Cabin",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pci",
      "cost": 56862,
      "mass": 10,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size4_Class3",
      "category": "internal",
      "name": "First Class Passenger Cabin",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pcm",
      "cost": 170586,
      "mass": 10,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size5_Class1",
      "category": "internal",
      "name": "Economy Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pce",
      "cost": 34954,
      "mass": 20,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size5_Class2",
      "category": "internal",
      "name": "Business Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pci",
      "cost": 92362,
      "mass": 20,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size5_Class3",
      "category": "internal",
      "name": "First Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pcm",
      "cost": 340526,
      "mass": 20,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size5_Class4",
      "category": "internal",
      "name": "Luxury Class Passenger Cabin",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pcq",
      "cost": 1658095,
      "mass": 20,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size6_Class1",
      "category": "internal",
      "name": "Economy Class Passenger Cabin",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pce",
      "cost": 61410,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size6_Class2",
      "category": "internal",
      "name": "Business Class Passenger Cabin",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pci",
      "cost": 184232,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size6_Class3",
      "category": "internal",
      "name": "First Class Passenger Cabin",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pcm",
      "cost": 552698,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PassengerCabin_Size6_Class4",
      "category": "internal",
      "name": "Luxury Class Passenger Cabin",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pcq",
      "cost": 4974287,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "passengers": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PlanetApproachSuite",
      "category": "internal",
      "name": "Planetary Approach Suite",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "pas",
      "cost": 500,
      "mass": 0,
      "power": 0,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_PlanetApproachSuite_Advanced",
      "category": "internal",
      "name": "Advanced Planetary Approach Suite",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "pas",
      "cost": 500,
      "mass": 0,
      "power": 0,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 517,
      "mass": 1.3,
      "power": 0.32,
      "integrity": 46,
      "stats": {
        "engcap": 8,
        "engrate": 0.4,
        "syscap": 8,
        "sysrate": 0.4,
        "wepcap": 10,
        "weprate": 1.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class1_free",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1293,
      "mass": 0.5,
      "power": 0.36,
      "integrity": 41,
      "stats": {
        "engcap": 9,
        "engrate": 0.5,
        "syscap": 9,
        "sysrate": 0.5,
        "wepcap": 11,
        "weprate": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 3231,
      "mass": 1.3,
      "power": 0.4,
      "integrity": 51,
      "stats": {
        "engcap": 10,
        "engrate": 0.5,
        "syscap": 10,
        "sysrate": 0.5,
        "wepcap": 12,
        "weprate": 1.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 8078,
      "mass": 2,
      "power": 0.44,
      "integrity": 61,
      "stats": {
        "engcap": 11,
        "engrate": 0.6,
        "syscap": 11,
        "sysrate": 0.6,
        "wepcap": 13,
        "weprate": 1.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size1_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 20195,
      "mass": 1.3,
      "power": 0.48,
      "integrity": 56,
      "stats": {
        "engcap": 12,
        "engrate": 0.6,
        "syscap": 12,
        "sysrate": 0.6,
        "wepcap": 14,
        "weprate": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size2_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1448,
      "mass": 2.5,
      "power": 0.36,
      "integrity": 46,
      "stats": {
        "engcap": 10,
        "engrate": 0.6,
        "syscap": 10,
        "sysrate": 0.6,
        "wepcap": 12,
        "weprate": 1.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size2_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 3619,
      "mass": 1,
      "power": 0.41,
      "integrity": 41,
      "stats": {
        "engcap": 11,
        "engrate": 0.6,
        "syscap": 11,
        "sysrate": 0.6,
        "wepcap": 14,
        "weprate": 1.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size2_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 9048,
      "mass": 2.5,
      "power": 0.45,
      "integrity": 51,
      "stats": {
        "engcap": 12,
        "engrate": 0.7,
        "syscap": 12,
        "sysrate": 0.7,
        "wepcap": 15,
        "weprate": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size2_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 22619,
      "mass": 4,
      "power": 0.5,
      "integrity": 61,
      "stats": {
        "engcap": 13,
        "engrate": 0.8,
        "syscap": 13,
        "sysrate": 0.8,
        "wepcap": 17,
        "weprate": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size2_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 56547,
      "mass": 2.5,
      "power": 0.54,
      "integrity": 56,
      "stats": {
        "engcap": 14,
        "engrate": 0.8,
        "syscap": 14,
        "sysrate": 0.8,
        "wepcap": 18,
        "weprate": 2.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 4053,
      "mass": 5,
      "power": 0.4,
      "integrity": 58,
      "stats": {
        "engcap": 12,
        "engrate": 0.9,
        "syscap": 12,
        "sysrate": 0.9,
        "wepcap": 16,
        "weprate": 1.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 10133,
      "mass": 2,
      "power": 0.45,
      "integrity": 51,
      "stats": {
        "engcap": 14,
        "engrate": 1,
        "syscap": 14,
        "sysrate": 1,
        "wepcap": 18,
        "weprate": 2.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class2",
      "category": "mercgear",
      "name": "Support Focused Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 10133,
      "mass": 2,
      "power": 0.45,
      "integrity": 51,
      "stats": {
        "engcap": 14,
        "engrate": 1,
        "syscap": 14,
        "sysrate": 1,
        "wepcap": 18,
        "weprate": 2.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 25333,
      "mass": 5,
      "power": 0.5,
      "integrity": 64,
      "stats": {
        "engcap": 15,
        "engrate": 1.1,
        "syscap": 15,
        "sysrate": 1.1,
        "wepcap": 20,
        "weprate": 2.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 63333,
      "mass": 8,
      "power": 0.55,
      "integrity": 77,
      "stats": {
        "engcap": 17,
        "engrate": 1.2,
        "syscap": 17,
        "sysrate": 1.2,
        "wepcap": 22,
        "weprate": 2.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 158331,
      "mass": 5,
      "power": 0.6,
      "integrity": 70,
      "stats": {
        "engcap": 18,
        "engrate": 1.3,
        "syscap": 18,
        "sysrate": 1.3,
        "wepcap": 24,
        "weprate": 2.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size3_Class5",
      "category": "mercgear",
      "name": "Support Focused Power Distributor",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 158331,
      "mass": 5,
      "power": 0.6,
      "integrity": 70,
      "stats": {
        "engcap": 18,
        "engrate": 1.3,
        "syscap": 18,
        "sysrate": 1.3,
        "wepcap": 24,
        "weprate": 2.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 11349,
      "mass": 10,
      "power": 0.45,
      "integrity": 72,
      "stats": {
        "engcap": 15,
        "engrate": 1.3,
        "syscap": 15,
        "sysrate": 1.3,
        "wepcap": 22,
        "weprate": 2.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 28373,
      "mass": 4,
      "power": 0.5,
      "integrity": 64,
      "stats": {
        "engcap": 17,
        "engrate": 1.4,
        "syscap": 17,
        "sysrate": 1.4,
        "wepcap": 24,
        "weprate": 2.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class2",
      "category": "mercgear",
      "name": "Support Focused Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 28373,
      "mass": 4,
      "power": 0.5,
      "integrity": 64,
      "stats": {
        "engcap": 17,
        "engrate": 1.4,
        "syscap": 17,
        "sysrate": 1.4,
        "wepcap": 24,
        "weprate": 2.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 70932,
      "mass": 10,
      "power": 0.56,
      "integrity": 80,
      "stats": {
        "engcap": 19,
        "engrate": 1.6,
        "syscap": 19,
        "sysrate": 1.6,
        "wepcap": 27,
        "weprate": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 177331,
      "mass": 16,
      "power": 0.62,
      "integrity": 96,
      "stats": {
        "engcap": 21,
        "engrate": 1.8,
        "syscap": 21,
        "sysrate": 1.8,
        "wepcap": 30,
        "weprate": 3.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 443328,
      "mass": 10,
      "power": 0.67,
      "integrity": 88,
      "stats": {
        "engcap": 23,
        "engrate": 1.9,
        "syscap": 23,
        "sysrate": 1.9,
        "wepcap": 32,
        "weprate": 3.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size4_Class5",
      "category": "mercgear",
      "name": "Support Focused Power Distributor",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 443328,
      "mass": 10,
      "power": 0.67,
      "integrity": 88,
      "stats": {
        "engcap": 23,
        "engrate": 1.9,
        "syscap": 23,
        "sysrate": 1.9,
        "wepcap": 32,
        "weprate": 3.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 31778,
      "mass": 20,
      "power": 0.5,
      "integrity": 86,
      "stats": {
        "engcap": 19,
        "engrate": 1.7,
        "syscap": 19,
        "sysrate": 1.7,
        "wepcap": 27,
        "weprate": 2.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 79444,
      "mass": 8,
      "power": 0.56,
      "integrity": 77,
      "stats": {
        "engcap": 22,
        "engrate": 1.9,
        "syscap": 22,
        "sysrate": 1.9,
        "wepcap": 31,
        "weprate": 3.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 198611,
      "mass": 20,
      "power": 0.62,
      "integrity": 96,
      "stats": {
        "engcap": 24,
        "engrate": 2.1,
        "syscap": 24,
        "sysrate": 2.1,
        "wepcap": 34,
        "weprate": 3.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 496527,
      "mass": 32,
      "power": 0.68,
      "integrity": 115,
      "stats": {
        "engcap": 26,
        "engrate": 2.3,
        "syscap": 26,
        "sysrate": 2.3,
        "wepcap": 37,
        "weprate": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1241317,
      "mass": 20,
      "power": 0.74,
      "integrity": 106,
      "stats": {
        "engcap": 29,
        "engrate": 2.5,
        "syscap": 29,
        "sysrate": 2.5,
        "wepcap": 41,
        "weprate": 4.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size5_Class5",
      "category": "mercgear",
      "name": "Balanced Power Distributor",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1241317,
      "mass": 20,
      "power": 0.74,
      "integrity": 106,
      "stats": {
        "engcap": 29,
        "engrate": 2.5,
        "syscap": 29,
        "sysrate": 2.5,
        "wepcap": 41,
        "weprate": 4.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 88978,
      "mass": 40,
      "power": 0.54,
      "integrity": 102,
      "stats": {
        "engcap": 23,
        "engrate": 2.2,
        "syscap": 23,
        "sysrate": 2.2,
        "wepcap": 34,
        "weprate": 3.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 222444,
      "mass": 16,
      "power": 0.61,
      "integrity": 90,
      "stats": {
        "engcap": 26,
        "engrate": 2.4,
        "syscap": 26,
        "sysrate": 2.4,
        "wepcap": 38,
        "weprate": 3.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 556110,
      "mass": 40,
      "power": 0.68,
      "integrity": 113,
      "stats": {
        "engcap": 29,
        "engrate": 2.7,
        "syscap": 29,
        "sysrate": 2.7,
        "wepcap": 42,
        "weprate": 4.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1390275,
      "mass": 64,
      "power": 0.75,
      "integrity": 136,
      "stats": {
        "engcap": 32,
        "engrate": 3,
        "syscap": 32,
        "sysrate": 3,
        "wepcap": 46,
        "weprate": 4.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 3475688,
      "mass": 40,
      "power": 0.82,
      "integrity": 124,
      "stats": {
        "engcap": 35,
        "engrate": 3.2,
        "syscap": 35,
        "sysrate": 3.2,
        "wepcap": 50,
        "weprate": 5.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size6_Class5",
      "category": "mercgear",
      "name": "Support Focused Power Distributor",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 3475688,
      "mass": 40,
      "power": 0.82,
      "integrity": 124,
      "stats": {
        "engcap": 35,
        "engrate": 3.2,
        "syscap": 35,
        "sysrate": 3.2,
        "wepcap": 50,
        "weprate": 5.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size7_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 249137,
      "mass": 80,
      "power": 0.59,
      "integrity": 118,
      "stats": {
        "engcap": 27,
        "engrate": 2.6,
        "syscap": 27,
        "sysrate": 2.6,
        "wepcap": 41,
        "weprate": 4.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size7_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 622843,
      "mass": 32,
      "power": 0.67,
      "integrity": 105,
      "stats": {
        "engcap": 31,
        "engrate": 3,
        "syscap": 31,
        "sysrate": 3,
        "wepcap": 46,
        "weprate": 4.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size7_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1557108,
      "mass": 80,
      "power": 0.74,
      "integrity": 131,
      "stats": {
        "engcap": 34,
        "engrate": 3.3,
        "syscap": 34,
        "sysrate": 3.3,
        "wepcap": 51,
        "weprate": 5.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size7_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 3892770,
      "mass": 128,
      "power": 0.81,
      "integrity": 157,
      "stats": {
        "engcap": 37,
        "engrate": 3.6,
        "syscap": 37,
        "sysrate": 3.6,
        "wepcap": 56,
        "weprate": 5.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size7_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 9731925,
      "mass": 80,
      "power": 0.89,
      "integrity": 144,
      "stats": {
        "engcap": 41,
        "engrate": 4,
        "syscap": 41,
        "sysrate": 4,
        "wepcap": 61,
        "weprate": 6.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size8_Class1",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 697584,
      "mass": 160,
      "power": 0.64,
      "integrity": 135,
      "stats": {
        "engcap": 32,
        "engrate": 3.2,
        "syscap": 32,
        "sysrate": 3.2,
        "wepcap": 48,
        "weprate": 4.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size8_Class2",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 1743961,
      "mass": 64,
      "power": 0.72,
      "integrity": 120,
      "stats": {
        "engcap": 36,
        "engrate": 3.6,
        "syscap": 36,
        "sysrate": 3.6,
        "wepcap": 54,
        "weprate": 5.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size8_Class3",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 4359903,
      "mass": 160,
      "power": 0.8,
      "integrity": 150,
      "stats": {
        "engcap": 40,
        "engrate": 4,
        "syscap": 40,
        "sysrate": 4,
        "wepcap": 60,
        "weprate": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size8_Class4",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 10899756,
      "mass": 256,
      "power": 0.88,
      "integrity": 180,
      "stats": {
        "engcap": 44,
        "engrate": 4.4,
        "syscap": 44,
        "sysrate": 4.4,
        "wepcap": 66,
        "weprate": 6.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerDistributor_Size8_Class5",
      "category": "standard",
      "name": "Power Distributor",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pd",
      "cost": 27249391,
      "mass": 160,
      "power": 0.96,
      "integrity": 165,
      "stats": {
        "engcap": 48,
        "engrate": 4.8,
        "syscap": 48,
        "sysrate": 4.8,
        "wepcap": 72,
        "weprate": 7.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size2_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1977,
      "mass": 2.5,
      "power": null,
      "integrity": 46,
      "stats": {
        "eff": 1,
        "pgen": 6.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_PowerPlant_Size2_Class1_free",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size2_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 5931,
      "mass": 1,
      "power": null,
      "integrity": 41,
      "stats": {
        "eff": 0.75,
        "pgen": 7.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size2_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 17793,
      "mass": 1.3,
      "power": null,
      "integrity": 51,
      "stats": {
        "eff": 0.5,
        "pgen": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size2_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 53379,
      "mass": 2,
      "power": null,
      "integrity": 61,
      "stats": {
        "eff": 0.45,
        "pgen": 8.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size2_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 160137,
      "mass": 1.3,
      "power": null,
      "integrity": 56,
      "stats": {
        "eff": 0.4,
        "pgen": 9.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size3_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 5931,
      "mass": 5,
      "power": null,
      "integrity": 58,
      "stats": {
        "eff": 1,
        "pgen": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size3_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 17793,
      "mass": 2,
      "power": null,
      "integrity": 51,
      "stats": {
        "eff": 0.75,
        "pgen": 9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size3_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 53379,
      "mass": 2.5,
      "power": null,
      "integrity": 64,
      "stats": {
        "eff": 0.5,
        "pgen": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size3_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 160137,
      "mass": 4,
      "power": null,
      "integrity": 77,
      "stats": {
        "eff": 0.45,
        "pgen": 11
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size3_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 480411,
      "mass": 2.5,
      "power": null,
      "integrity": 70,
      "stats": {
        "eff": 0.4,
        "pgen": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size4_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 17793,
      "mass": 10,
      "power": null,
      "integrity": 72,
      "stats": {
        "eff": 1,
        "pgen": 10.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size4_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 53379,
      "mass": 4,
      "power": null,
      "integrity": 64,
      "stats": {
        "eff": 0.75,
        "pgen": 11.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size4_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 160137,
      "mass": 5,
      "power": null,
      "integrity": 80,
      "stats": {
        "eff": 0.5,
        "pgen": 13
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size4_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 480411,
      "mass": 8,
      "power": null,
      "integrity": 96,
      "stats": {
        "eff": 0.45,
        "pgen": 14.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size4_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1441233,
      "mass": 5,
      "power": null,
      "integrity": 88,
      "stats": {
        "eff": 0.4,
        "pgen": 15.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size5_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 53379,
      "mass": 20,
      "power": null,
      "integrity": 86,
      "stats": {
        "eff": 1,
        "pgen": 13.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size5_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 160137,
      "mass": 8,
      "power": null,
      "integrity": 77,
      "stats": {
        "eff": 0.75,
        "pgen": 15.3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size5_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 480411,
      "mass": 10,
      "power": null,
      "integrity": 96,
      "stats": {
        "eff": 0.5,
        "pgen": 17
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size5_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1441233,
      "mass": 16,
      "power": null,
      "integrity": 114,
      "stats": {
        "eff": 0.45,
        "pgen": 18.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size5_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 4323699,
      "mass": 10,
      "power": null,
      "integrity": 106,
      "stats": {
        "eff": 0.4,
        "pgen": 20.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size6_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 160137,
      "mass": 40,
      "power": null,
      "integrity": 102,
      "stats": {
        "eff": 1,
        "pgen": 16.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size6_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 480411,
      "mass": 16,
      "power": null,
      "integrity": 90,
      "stats": {
        "eff": 0.75,
        "pgen": 18.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size6_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1441233,
      "mass": 20,
      "power": null,
      "integrity": 113,
      "stats": {
        "eff": 0.5,
        "pgen": 21
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size6_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 4323699,
      "mass": 32,
      "power": null,
      "integrity": 136,
      "stats": {
        "eff": 0.45,
        "pgen": 23.1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size6_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 12971097,
      "mass": 20,
      "power": null,
      "integrity": 124,
      "stats": {
        "eff": 0.4,
        "pgen": 25.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size7_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 480411,
      "mass": 80,
      "power": null,
      "integrity": 118,
      "stats": {
        "eff": 1,
        "pgen": 20
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size7_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1441233,
      "mass": 32,
      "power": null,
      "integrity": 105,
      "stats": {
        "eff": 0.75,
        "pgen": 22.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size7_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 4323699,
      "mass": 40,
      "power": null,
      "integrity": 131,
      "stats": {
        "eff": 0.5,
        "pgen": 25
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size7_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 12971097,
      "mass": 64,
      "power": null,
      "integrity": 157,
      "stats": {
        "eff": 0.45,
        "pgen": 27.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size7_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 38913291,
      "mass": 40,
      "power": null,
      "integrity": 144,
      "stats": {
        "eff": 0.4,
        "pgen": 30
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size8_Class1",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 1441233,
      "mass": 160,
      "power": null,
      "integrity": 135,
      "stats": {
        "eff": 1,
        "pgen": 24
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size8_Class2",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 4323699,
      "mass": 64,
      "power": null,
      "integrity": 120,
      "stats": {
        "eff": 0.75,
        "pgen": 27
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size8_Class3",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 12971097,
      "mass": 80,
      "power": null,
      "integrity": 150,
      "stats": {
        "eff": 0.5,
        "pgen": 30
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size8_Class4",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 38913291,
      "mass": 128,
      "power": null,
      "integrity": 180,
      "stats": {
        "eff": 0.45,
        "pgen": 33
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Powerplant_Size8_Class5",
      "category": "standard",
      "name": "Power Plant",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "pp",
      "cost": 116739873,
      "mass": 80,
      "power": null,
      "integrity": 165,
      "stats": {
        "eff": 0.4,
        "pgen": 36
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size1_Class1",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 6000,
      "mass": null,
      "power": 0.14,
      "integrity": null,
      "stats": {
        "bins": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size1_Class2",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 18000,
      "mass": null,
      "power": 0.18,
      "integrity": null,
      "stats": {
        "bins": 1
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size1_Class3",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 54000,
      "mass": null,
      "power": 0.23,
      "integrity": null,
      "stats": {
        "bins": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size1_Class4",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 162000,
      "mass": null,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "bins": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size1_Class5",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 486000,
      "mass": null,
      "power": 0.32,
      "integrity": null,
      "stats": {
        "bins": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size2_Class1",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 12600,
      "mass": null,
      "power": 0.17,
      "integrity": null,
      "stats": {
        "bins": 2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size2_Class2",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 37800,
      "mass": null,
      "power": 0.22,
      "integrity": null,
      "stats": {
        "bins": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size2_Class3",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 113400,
      "mass": null,
      "power": 0.28,
      "integrity": null,
      "stats": {
        "bins": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size2_Class4",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 340200,
      "mass": null,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "bins": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size2_Class5",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 1020600,
      "mass": null,
      "power": 0.39,
      "integrity": null,
      "stats": {
        "bins": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size3_Class1",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 26460,
      "mass": null,
      "power": 0.2,
      "integrity": null,
      "stats": {
        "bins": 3
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size3_Class2",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 79380,
      "mass": null,
      "power": 0.27,
      "integrity": null,
      "stats": {
        "bins": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size3_Class3",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 238140,
      "mass": null,
      "power": 0.34,
      "integrity": null,
      "stats": {
        "bins": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size3_Class4",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 714420,
      "mass": null,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "bins": 7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size3_Class5",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 2143260,
      "mass": null,
      "power": 0.48,
      "integrity": null,
      "stats": {
        "bins": 8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size4_Class1",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 55566,
      "mass": null,
      "power": 0.25,
      "integrity": null,
      "stats": {
        "bins": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size4_Class2",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 166698,
      "mass": null,
      "power": 0.33,
      "integrity": null,
      "stats": {
        "bins": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size4_Class3",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 500094,
      "mass": null,
      "power": 0.41,
      "integrity": null,
      "stats": {
        "bins": 7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size4_Class4",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 1500282,
      "mass": null,
      "power": 0.49,
      "integrity": null,
      "stats": {
        "bins": 9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Refinery_Size4_Class5",
      "category": "internal",
      "name": "Refinery",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "rf",
      "cost": 4500846,
      "mass": null,
      "power": 0.57,
      "integrity": null,
      "stats": {
        "bins": 10
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size1_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 10000,
      "mass": null,
      "power": 0.54,
      "integrity": null,
      "stats": {
        "ammo": 1000,
        "ammocost": 1,
        "repair": 12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size1_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 30000,
      "mass": null,
      "power": 0.72,
      "integrity": null,
      "stats": {
        "ammo": 900,
        "ammocost": 1,
        "repair": 14.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size1_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 90000,
      "mass": null,
      "power": 0.9,
      "integrity": null,
      "stats": {
        "ammo": 1000,
        "ammocost": 1,
        "repair": 20
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size1_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 270000,
      "mass": null,
      "power": 1.04,
      "integrity": null,
      "stats": {
        "ammo": 1200,
        "ammocost": 1,
        "repair": 27.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size1_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 810000,
      "mass": null,
      "power": 1.26,
      "integrity": null,
      "stats": {
        "ammo": 1100,
        "ammocost": 1,
        "repair": 30.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size2_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 18000,
      "mass": null,
      "power": 0.68,
      "integrity": null,
      "stats": {
        "ammo": 2300,
        "ammocost": 1,
        "repair": 27.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size2_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 54000,
      "mass": null,
      "power": 0.9,
      "integrity": null,
      "stats": {
        "ammo": 2100,
        "ammocost": 1,
        "repair": 33.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size2_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 162000,
      "mass": null,
      "power": 1.13,
      "integrity": null,
      "stats": {
        "ammo": 2300,
        "ammocost": 1,
        "repair": 46
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size2_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 486000,
      "mass": null,
      "power": 1.29,
      "integrity": null,
      "stats": {
        "ammo": 2800,
        "ammocost": 1,
        "repair": 64.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size2_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 1458000,
      "mass": null,
      "power": 1.58,
      "integrity": null,
      "stats": {
        "ammo": 2500,
        "ammocost": 1,
        "repair": 70
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size3_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 32400,
      "mass": null,
      "power": 0.81,
      "integrity": null,
      "stats": {
        "ammo": 3600,
        "ammocost": 1,
        "repair": 43.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size3_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 97200,
      "mass": null,
      "power": 1.08,
      "integrity": null,
      "stats": {
        "ammo": 3200,
        "ammocost": 1,
        "repair": 51.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size3_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 291600,
      "mass": null,
      "power": 1.35,
      "integrity": null,
      "stats": {
        "ammo": 3600,
        "ammocost": 1,
        "repair": 72
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size3_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 874800,
      "mass": null,
      "power": 1.55,
      "integrity": null,
      "stats": {
        "ammo": 4300,
        "ammocost": 1,
        "repair": 98.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size3_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 2624400,
      "mass": null,
      "power": 1.89,
      "integrity": null,
      "stats": {
        "ammo": 4000,
        "ammocost": 1,
        "repair": 112
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size4_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 58320,
      "mass": null,
      "power": 0.99,
      "integrity": null,
      "stats": {
        "ammo": 4900,
        "ammocost": 1,
        "repair": 58.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size4_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 174960,
      "mass": null,
      "power": 1.32,
      "integrity": null,
      "stats": {
        "ammo": 4400,
        "ammocost": 1,
        "repair": 70.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size4_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 524880,
      "mass": null,
      "power": 1.65,
      "integrity": null,
      "stats": {
        "ammo": 4900,
        "ammocost": 1,
        "repair": 98
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size4_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 1574640,
      "mass": null,
      "power": 1.9,
      "integrity": null,
      "stats": {
        "ammo": 5900,
        "ammocost": 1,
        "repair": 135.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size4_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 4723920,
      "mass": null,
      "power": 2.31,
      "integrity": null,
      "stats": {
        "ammo": 5400,
        "ammocost": 1,
        "repair": 151.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size5_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 104976,
      "mass": null,
      "power": 1.17,
      "integrity": null,
      "stats": {
        "ammo": 6100,
        "ammocost": 1,
        "repair": 73.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size5_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 314928,
      "mass": null,
      "power": 1.56,
      "integrity": null,
      "stats": {
        "ammo": 5500,
        "ammocost": 1,
        "repair": 88
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size5_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 944784,
      "mass": null,
      "power": 1.95,
      "integrity": null,
      "stats": {
        "ammo": 6100,
        "ammocost": 1,
        "repair": 122
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size5_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 2834352,
      "mass": null,
      "power": 2.24,
      "integrity": null,
      "stats": {
        "ammo": 7300,
        "ammocost": 1,
        "repair": 167.9
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size5_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 8503056,
      "mass": null,
      "power": 2.73,
      "integrity": null,
      "stats": {
        "ammo": 6700,
        "ammocost": 1,
        "repair": 187.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size6_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 188957,
      "mass": null,
      "power": 1.4,
      "integrity": null,
      "stats": {
        "ammo": 7400,
        "ammocost": 1,
        "repair": 88.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size6_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 566870,
      "mass": null,
      "power": 1.86,
      "integrity": null,
      "stats": {
        "ammo": 6700,
        "ammocost": 1,
        "repair": 107.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size6_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 1700611,
      "mass": null,
      "power": 2.33,
      "integrity": null,
      "stats": {
        "ammo": 7400,
        "ammocost": 1,
        "repair": 148
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size6_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 5101834,
      "mass": null,
      "power": 2.67,
      "integrity": null,
      "stats": {
        "ammo": 8900,
        "ammocost": 1,
        "repair": 204.7
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size6_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 15305501,
      "mass": null,
      "power": 3.26,
      "integrity": null,
      "stats": {
        "ammo": 8100,
        "ammocost": 1,
        "repair": 226.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size7_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 340122,
      "mass": null,
      "power": 1.58,
      "integrity": null,
      "stats": {
        "ammo": 8700,
        "ammocost": 1,
        "repair": 104.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size7_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 1020367,
      "mass": null,
      "power": 2.1,
      "integrity": null,
      "stats": {
        "ammo": 7800,
        "ammocost": 1,
        "repair": 124.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size7_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 3061100,
      "mass": null,
      "power": 2.63,
      "integrity": null,
      "stats": {
        "ammo": 8700,
        "ammocost": 1,
        "repair": 174
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size7_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 9183300,
      "mass": null,
      "power": 3.02,
      "integrity": null,
      "stats": {
        "ammo": 10400,
        "ammocost": 1,
        "repair": 239.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size7_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 27549901,
      "mass": null,
      "power": 3.68,
      "integrity": null,
      "stats": {
        "ammo": 9600,
        "ammocost": 1,
        "repair": 268.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size8_Class1",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 612220,
      "mass": null,
      "power": 1.8,
      "integrity": null,
      "stats": {
        "ammo": 10000,
        "ammocost": 1,
        "repair": 120
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size8_Class2",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 1836660,
      "mass": null,
      "power": 2.4,
      "integrity": null,
      "stats": {
        "ammo": 9000,
        "ammocost": 1,
        "repair": 144
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size8_Class3",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 5509980,
      "mass": null,
      "power": 3,
      "integrity": null,
      "stats": {
        "ammo": 10000,
        "ammocost": 1,
        "repair": 200
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size8_Class4",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 16529941,
      "mass": null,
      "power": 3.45,
      "integrity": null,
      "stats": {
        "ammo": 12000,
        "ammocost": 1,
        "repair": 276
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Repairer_Size8_Class5",
      "category": "internal",
      "name": "Auto Field-Maintenance Unit",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "am",
      "cost": 49589823,
      "mass": null,
      "power": 4.2,
      "integrity": null,
      "stats": {
        "ammo": 11000,
        "ammocost": 1,
        "repair": 308
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 517,
      "mass": 1.3,
      "power": 0.16,
      "integrity": 46,
      "stats": {
        "angle": 30,
        "range": 4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class1_free",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1293,
      "mass": 0.5,
      "power": 0.18,
      "integrity": 41,
      "stats": {
        "angle": 30,
        "range": 4.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 3231,
      "mass": 1.3,
      "power": 0.2,
      "integrity": 51,
      "stats": {
        "angle": 30,
        "range": 5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 8078,
      "mass": 2,
      "power": 0.33,
      "integrity": 61,
      "stats": {
        "angle": 30,
        "range": 5.5
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size1_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 20195,
      "mass": 1.3,
      "power": 0.6,
      "integrity": 56,
      "stats": {
        "angle": 30,
        "range": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size2_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1448,
      "mass": 2.5,
      "power": 0.18,
      "integrity": 46,
      "stats": {
        "angle": 30,
        "range": 4.16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size2_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 3619,
      "mass": 1,
      "power": 0.21,
      "integrity": 41,
      "stats": {
        "angle": 30,
        "range": 4.68
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size2_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 9048,
      "mass": 2.5,
      "power": 0.23,
      "integrity": 51,
      "stats": {
        "angle": 30,
        "range": 5.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size2_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 22619,
      "mass": 4,
      "power": 0.38,
      "integrity": 61,
      "stats": {
        "angle": 30,
        "range": 5.72
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size2_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 56547,
      "mass": 2.5,
      "power": 0.69,
      "integrity": 56,
      "stats": {
        "angle": 30,
        "range": 6.24
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size3_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 4053,
      "mass": 5,
      "power": 0.22,
      "integrity": 58,
      "stats": {
        "angle": 30,
        "range": 4.32
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size3_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 10133,
      "mass": 2,
      "power": 0.25,
      "integrity": 51,
      "stats": {
        "angle": 30,
        "range": 4.86
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size3_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 25333,
      "mass": 5,
      "power": 0.28,
      "integrity": 64,
      "stats": {
        "angle": 30,
        "range": 5.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size3_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 63333,
      "mass": 8,
      "power": 0.46,
      "integrity": 77,
      "stats": {
        "angle": 30,
        "range": 5.94
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size3_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 158331,
      "mass": 5,
      "power": 0.84,
      "integrity": 70,
      "stats": {
        "angle": 30,
        "range": 6.48
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size4_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 11349,
      "mass": 10,
      "power": 0.27,
      "integrity": 72,
      "stats": {
        "angle": 30,
        "range": 4.48
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size4_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 28373,
      "mass": 4,
      "power": 0.31,
      "integrity": 64,
      "stats": {
        "angle": 30,
        "range": 5.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size4_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 70932,
      "mass": 10,
      "power": 0.34,
      "integrity": 80,
      "stats": {
        "angle": 30,
        "range": 5.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size4_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 177331,
      "mass": 16,
      "power": 0.56,
      "integrity": 96,
      "stats": {
        "angle": 30,
        "range": 6.16
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size4_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 443328,
      "mass": 10,
      "power": 1.02,
      "integrity": 88,
      "stats": {
        "angle": 30,
        "range": 6.72
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size5_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 31778,
      "mass": 20,
      "power": 0.33,
      "integrity": 86,
      "stats": {
        "angle": 30,
        "range": 4.64
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size5_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 79444,
      "mass": 8,
      "power": 0.37,
      "integrity": 77,
      "stats": {
        "angle": 30,
        "range": 5.22
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size5_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 198611,
      "mass": 20,
      "power": 0.41,
      "integrity": 96,
      "stats": {
        "angle": 30,
        "range": 5.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size5_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 496527,
      "mass": 32,
      "power": 0.68,
      "integrity": 115,
      "stats": {
        "angle": 30,
        "range": 6.38
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size5_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1241317,
      "mass": 20,
      "power": 1.23,
      "integrity": 106,
      "stats": {
        "angle": 30,
        "range": 6.96
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size6_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 88978,
      "mass": 40,
      "power": 0.4,
      "integrity": 102,
      "stats": {
        "angle": 30,
        "range": 4.8
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size6_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 222444,
      "mass": 16,
      "power": 0.45,
      "integrity": 90,
      "stats": {
        "angle": 30,
        "range": 5.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size6_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 556110,
      "mass": 40,
      "power": 0.5,
      "integrity": 113,
      "stats": {
        "angle": 30,
        "range": 6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size6_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1390275,
      "mass": 64,
      "power": 0.83,
      "integrity": 136,
      "stats": {
        "angle": 30,
        "range": 6.6
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size6_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 3475688,
      "mass": 40,
      "power": 1.5,
      "integrity": 124,
      "stats": {
        "angle": 30,
        "range": 7.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size7_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 249137,
      "mass": 80,
      "power": 0.47,
      "integrity": 118,
      "stats": {
        "angle": 30,
        "range": 4.96
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size7_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 622843,
      "mass": 32,
      "power": 0.53,
      "integrity": 105,
      "stats": {
        "angle": 30,
        "range": 5.58
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size7_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1557108,
      "mass": 80,
      "power": 0.59,
      "integrity": 131,
      "stats": {
        "angle": 30,
        "range": 6.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size7_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 3892770,
      "mass": 128,
      "power": 0.97,
      "integrity": 157,
      "stats": {
        "angle": 30,
        "range": 6.82
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size7_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 9731925,
      "mass": 80,
      "power": 1.77,
      "integrity": 144,
      "stats": {
        "angle": 30,
        "range": 7.44
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size8_Class1",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 697584,
      "mass": 160,
      "power": 0.55,
      "integrity": 135,
      "stats": {
        "angle": 30,
        "range": 5.12
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size8_Class2",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 1743961,
      "mass": 64,
      "power": 0.62,
      "integrity": 120,
      "stats": {
        "angle": 30,
        "range": 5.76
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size8_Class3",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 4359903,
      "mass": 160,
      "power": 0.69,
      "integrity": 150,
      "stats": {
        "angle": 30,
        "range": 6.4
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size8_Class4",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 10899756,
      "mass": 256,
      "power": 1.14,
      "integrity": 180,
      "stats": {
        "angle": 30,
        "range": 7.04
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_Sensors_Size8_Class5",
      "category": "standard",
      "name": "Sensors",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "s",
      "cost": 27249391,
      "mass": 160,
      "power": 2.07,
      "integrity": 165,
      "stats": {
        "angle": 30,
        "range": 7.68
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size1_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 517,
      "mass": 1.3,
      "power": 0.41,
      "integrity": 32,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 1,
        "shieldreinforcement": 12,
        "spinup": 5,
        "thermload": 170
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size1_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1293,
      "mass": 0.5,
      "power": 0.55,
      "integrity": 24,
      "stats": {
        "ammo": 0,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 1,
        "shieldreinforcement": 12.5,
        "spinup": 5,
        "thermload": 170
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size1_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 3231,
      "mass": 1.3,
      "power": 0.69,
      "integrity": 40,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 1,
        "shieldreinforcement": 20,
        "spinup": 5,
        "thermload": 170
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size1_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 8078,
      "mass": 2,
      "power": 0.83,
      "integrity": 56,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 1,
        "shieldreinforcement": 24,
        "spinup": 5,
        "thermload": 170
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size1_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 20195,
      "mass": 1.3,
      "power": 0.97,
      "integrity": 48,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 1,
        "shieldreinforcement": 28,
        "spinup": 5,
        "thermload": 170
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size2_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1448,
      "mass": 2.5,
      "power": 0.5,
      "integrity": 41,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 14,
        "spinup": 5,
        "thermload": 240
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size2_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 3619,
      "mass": 1,
      "power": 0.67,
      "integrity": 31,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 18,
        "spinup": 5,
        "thermload": 240
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size2_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 9048,
      "mass": 2.5,
      "power": 0.84,
      "integrity": 51,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 23,
        "spinup": 5,
        "thermload": 240
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size2_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 22619,
      "mass": 4,
      "power": 1.01,
      "integrity": 71,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 28,
        "spinup": 5,
        "thermload": 240
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size2_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 56547,
      "mass": 2.5,
      "power": 1.18,
      "integrity": 61,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 32,
        "spinup": 5,
        "thermload": 240
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size3_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 4053,
      "mass": 5,
      "power": 0.61,
      "integrity": 51,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 17,
        "spinup": 5,
        "thermload": 340
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size3_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 10133,
      "mass": 2,
      "power": 0.82,
      "integrity": 38,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 23,
        "spinup": 5,
        "thermload": 340
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size3_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 25333,
      "mass": 5,
      "power": 1.02,
      "integrity": 64,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 29,
        "spinup": 5,
        "thermload": 340
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size3_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 63333,
      "mass": 8,
      "power": 1.22,
      "integrity": 90,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 35,
        "spinup": 5,
        "thermload": 340
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size3_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 158331,
      "mass": 5,
      "power": 1.43,
      "integrity": 77,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 2,
        "shieldreinforcement": 41,
        "spinup": 5,
        "thermload": 340
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size4_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 11349,
      "mass": 10,
      "power": 0.74,
      "integrity": 64,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 3,
        "shieldreinforcement": 20,
        "spinup": 5,
        "thermload": 410
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size4_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 28373,
      "mass": 4,
      "power": 0.98,
      "integrity": 48,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 3,
        "shieldreinforcement": 26,
        "spinup": 5,
        "thermload": 410
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size4_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 70932,
      "mass": 10,
      "power": 1.23,
      "integrity": 80,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 3,
        "shieldreinforcement": 33,
        "spinup": 5,
        "thermload": 410
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size4_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 177331,
      "mass": 16,
      "power": 1.48,
      "integrity": 112,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 3,
        "shieldreinforcement": 39,
        "spinup": 5,
        "thermload": 410
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size4_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 443328,
      "mass": 10,
      "power": 1.72,
      "integrity": 96,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 3,
        "shieldreinforcement": 46,
        "spinup": 5,
        "thermload": 410
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size5_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 31778,
      "mass": 20,
      "power": 0.9,
      "integrity": 77,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 5,
        "shieldreinforcement": 21,
        "spinup": 5,
        "thermload": 540
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size5_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 79444,
      "mass": 8,
      "power": 1.2,
      "integrity": 58,
      "stats": {
        "ammo": 2,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 5,
        "shieldreinforcement": 28,
        "spinup": 5,
        "thermload": 540
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size5_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 198611,
      "mass": 20,
      "power": 1.5,
      "integrity": 96,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 5,
        "shieldreinforcement": 35,
        "spinup": 5,
        "thermload": 540
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size5_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 496527,
      "mass": 32,
      "power": 1.8,
      "integrity": 134,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 5,
        "shieldreinforcement": 41,
        "spinup": 5,
        "thermload": 540
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size5_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1241317,
      "mass": 20,
      "power": 2.1,
      "integrity": 115,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 5,
        "shieldreinforcement": 48,
        "spinup": 5,
        "thermload": 540
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size6_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 88978,
      "mass": 40,
      "power": 1.06,
      "integrity": 90,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 8,
        "shieldreinforcement": 20,
        "spinup": 5,
        "thermload": 640
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size6_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 222444,
      "mass": 16,
      "power": 1.42,
      "integrity": 68,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 8,
        "shieldreinforcement": 26,
        "spinup": 5,
        "thermload": 640
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size6_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 556110,
      "mass": 40,
      "power": 1.77,
      "integrity": 113,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 8,
        "shieldreinforcement": 33,
        "spinup": 5,
        "thermload": 640
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size6_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1390275,
      "mass": 64,
      "power": 2.12,
      "integrity": 158,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 8,
        "shieldreinforcement": 39,
        "spinup": 5,
        "thermload": 640
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size6_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 3475688,
      "mass": 40,
      "power": 2.48,
      "integrity": 136,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 8,
        "shieldreinforcement": 46,
        "spinup": 5,
        "thermload": 640
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size7_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 249137,
      "mass": 80,
      "power": 1.24,
      "integrity": 105,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 11,
        "shieldreinforcement": 24,
        "spinup": 5,
        "thermload": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size7_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 622843,
      "mass": 32,
      "power": 1.66,
      "integrity": 79,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 11,
        "shieldreinforcement": 32,
        "spinup": 5,
        "thermload": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size7_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1557108,
      "mass": 80,
      "power": 2.07,
      "integrity": 131,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 11,
        "shieldreinforcement": 41,
        "spinup": 5,
        "thermload": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size7_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 3892770,
      "mass": 128,
      "power": 2.48,
      "integrity": 183,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 11,
        "shieldreinforcement": 49,
        "spinup": 5,
        "thermload": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size7_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 9731925,
      "mass": 80,
      "power": 2.9,
      "integrity": 157,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 11,
        "shieldreinforcement": 57,
        "spinup": 5,
        "thermload": 720
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size8_Class1",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 697584,
      "mass": 160,
      "power": 1.44,
      "integrity": 120,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 17,
        "shieldreinforcement": 28,
        "spinup": 5,
        "thermload": 800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size8_Class2",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 1743961,
      "mass": 64,
      "power": 1.92,
      "integrity": 90,
      "stats": {
        "ammo": 3,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 17,
        "shieldreinforcement": 37,
        "spinup": 5,
        "thermload": 800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size8_Class3",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 4359903,
      "mass": 160,
      "power": 2.4,
      "integrity": 150,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 17,
        "shieldreinforcement": 47,
        "spinup": 5,
        "thermload": 800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size8_Class4",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 10899756,
      "mass": 256,
      "power": 2.88,
      "integrity": 210,
      "stats": {
        "ammo": 5,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 17,
        "shieldreinforcement": 56,
        "spinup": 5,
        "thermload": 800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldCellBank_Size8_Class5",
      "category": "internal",
      "name": "Shield Cell Bank",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "scb",
      "cost": 27249391,
      "mass": 160,
      "power": 3.36,
      "integrity": 180,
      "stats": {
        "ammo": 4,
        "ammocost": 300,
        "boot": 25,
        "clip": 1,
        "duration": 17,
        "shieldreinforcement": 65,
        "spinup": 5,
        "thermload": 800
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 300,
      "mass": 1.3,
      "power": 0.72,
      "integrity": 32,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 1.3,
        "minmass": 13,
        "minmul": 0.3,
        "optmass": 25,
        "optmul": 0.8,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1240,
      "mass": 0.5,
      "power": 0.96,
      "integrity": 24,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 1.4,
        "minmass": 13,
        "minmul": 0.4,
        "optmass": 25,
        "optmul": 0.9,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 5140,
      "mass": 1.3,
      "power": 1.2,
      "integrity": 40,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 1.5,
        "minmass": 13,
        "minmul": 0.5,
        "optmass": 25,
        "optmul": 1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 7713,
      "mass": 1.3,
      "power": 1.2,
      "integrity": 40,
      "stats": {
        "brokenregen": 2.4,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 1.4,
        "minmass": 13,
        "minmul": 0.4,
        "optmass": 25,
        "optmul": 0.9,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 88075,
      "mass": 1.3,
      "power": 1.68,
      "integrity": 48,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 1.7,
        "minmass": 13,
        "minmul": 0.7,
        "optmass": 25,
        "optmul": 1.2,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size1_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 132200,
      "mass": 2.5,
      "power": 2.52,
      "integrity": 48,
      "stats": {
        "brokenregen": 1.2,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 63,
        "maxmul": 2,
        "minmass": 13,
        "minmul": 1,
        "optmass": 25,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1978,
      "mass": 2.5,
      "power": 0.9,
      "integrity": 41,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.3,
        "minmass": 28,
        "minmul": 0.3,
        "optmass": 55,
        "optmul": 0.8,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class1_free",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 5934,
      "mass": 1,
      "power": 1.2,
      "integrity": 31,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.4,
        "minmass": 28,
        "minmul": 0.4,
        "optmass": 55,
        "optmul": 0.9,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 17803,
      "mass": 2.5,
      "power": 1.5,
      "integrity": 51,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.5,
        "minmass": 28,
        "minmul": 0.5,
        "optmass": 55,
        "optmul": 1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 26705,
      "mass": 2.5,
      "power": 1.5,
      "integrity": 51,
      "stats": {
        "brokenregen": 2.4,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.4,
        "minmass": 28,
        "minmul": 0.4,
        "optmass": 55,
        "optmul": 0.9,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 53408,
      "mass": 4,
      "power": 1.8,
      "integrity": 71,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.6,
        "minmass": 28,
        "minmul": 0.6,
        "optmass": 55,
        "optmul": 1.1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 160224,
      "mass": 2.5,
      "power": 2.1,
      "integrity": 61,
      "stats": {
        "brokenregen": 1.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 1.7,
        "minmass": 28,
        "minmul": 0.7,
        "optmass": 55,
        "optmul": 1.2,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size2_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 240340,
      "mass": 5,
      "power": 3.15,
      "integrity": 61,
      "stats": {
        "brokenregen": 1.2,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 138,
        "maxmul": 2,
        "minmass": 23,
        "minmul": 1,
        "optmass": 55,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 6271,
      "mass": 5,
      "power": 1.08,
      "integrity": 51,
      "stats": {
        "brokenregen": 1.87,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.3,
        "minmass": 83,
        "minmul": 0.3,
        "optmass": 165,
        "optmul": 0.8,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 18812,
      "mass": 2,
      "power": 1.44,
      "integrity": 38,
      "stats": {
        "brokenregen": 1.87,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.4,
        "minmass": 83,
        "minmul": 0.4,
        "optmass": 165,
        "optmul": 0.9,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 56435,
      "mass": 5,
      "power": 1.8,
      "integrity": 64,
      "stats": {
        "brokenregen": 1.87,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.5,
        "minmass": 83,
        "minmul": 0.5,
        "optmass": 165,
        "optmul": 1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 84653,
      "mass": 5,
      "power": 1.8,
      "integrity": 64,
      "stats": {
        "brokenregen": 2.8,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.4,
        "minmass": 83,
        "minmul": 0.4,
        "optmass": 165,
        "optmul": 0.9,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 169304,
      "mass": 8,
      "power": 2.16,
      "integrity": 90,
      "stats": {
        "brokenregen": 1.87,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.6,
        "minmass": 83,
        "minmul": 0.6,
        "optmass": 165,
        "optmul": 1.1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 507912,
      "mass": 5,
      "power": 2.52,
      "integrity": 77,
      "stats": {
        "brokenregen": 1.87,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 1.7,
        "minmass": 83,
        "minmul": 0.7,
        "optmass": 165,
        "optmul": 1.2,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size3_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 761870,
      "mass": 10,
      "power": 3.78,
      "integrity": 77,
      "stats": {
        "brokenregen": 1.3,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 413,
        "maxmul": 2,
        "minmass": 83,
        "minmul": 1,
        "optmass": 165,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 19878,
      "mass": 10,
      "power": 1.32,
      "integrity": 64,
      "stats": {
        "brokenregen": 2.53,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.3,
        "minmass": 143,
        "minmul": 0.3,
        "optmass": 285,
        "optmul": 0.8,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 59633,
      "mass": 4,
      "power": 1.76,
      "integrity": 48,
      "stats": {
        "brokenregen": 2.53,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.4,
        "minmass": 143,
        "minmul": 0.4,
        "optmass": 285,
        "optmul": 0.9,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 178898,
      "mass": 10,
      "power": 2.2,
      "integrity": 80,
      "stats": {
        "brokenregen": 2.53,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.5,
        "minmass": 143,
        "minmul": 0.5,
        "optmass": 285,
        "optmul": 1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 268347,
      "mass": 10,
      "power": 2.2,
      "integrity": 80,
      "stats": {
        "brokenregen": 3.8,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.4,
        "minmass": 143,
        "minmul": 0.4,
        "optmass": 285,
        "optmul": 0.9,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 536693,
      "mass": 16,
      "power": 2.64,
      "integrity": 112,
      "stats": {
        "brokenregen": 2.53,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.6,
        "minmass": 143,
        "minmul": 0.6,
        "optmass": 285,
        "optmul": 1.1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1610080,
      "mass": 10,
      "power": 3.08,
      "integrity": 96,
      "stats": {
        "brokenregen": 2.53,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 1.7,
        "minmass": 143,
        "minmul": 0.7,
        "optmass": 285,
        "optmul": 1.2,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size4_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 2415120,
      "mass": 20,
      "power": 4.62,
      "integrity": 96,
      "stats": {
        "brokenregen": 1.7,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 713,
        "maxmul": 2,
        "minmass": 143,
        "minmul": 1,
        "optmass": 285,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 63012,
      "mass": 20,
      "power": 1.56,
      "integrity": 77,
      "stats": {
        "brokenregen": 3.75,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.3,
        "minmass": 203,
        "minmul": 0.3,
        "optmass": 405,
        "optmul": 0.8,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 189035,
      "mass": 8,
      "power": 2.08,
      "integrity": 58,
      "stats": {
        "brokenregen": 3.75,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.4,
        "minmass": 203,
        "minmul": 0.4,
        "optmass": 405,
        "optmul": 0.9,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 567106,
      "mass": 20,
      "power": 2.6,
      "integrity": 96,
      "stats": {
        "brokenregen": 3.75,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.5,
        "minmass": 203,
        "minmul": 0.5,
        "optmass": 405,
        "optmul": 1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 850659,
      "mass": 20,
      "power": 2.6,
      "integrity": 96,
      "stats": {
        "brokenregen": 5.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.4,
        "minmass": 203,
        "minmul": 0.4,
        "optmass": 405,
        "optmul": 0.9,
        "regen": 2.2,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1701318,
      "mass": 32,
      "power": 3.12,
      "integrity": 134,
      "stats": {
        "brokenregen": 3.75,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.6,
        "minmass": 203,
        "minmul": 0.6,
        "optmass": 405,
        "optmul": 1.1,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 5103953,
      "mass": 20,
      "power": 3.64,
      "integrity": 115,
      "stats": {
        "brokenregen": 3.75,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 1.7,
        "minmass": 203,
        "minmul": 0.7,
        "optmass": 405,
        "optmul": 1.2,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size5_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 7655930,
      "mass": 40,
      "power": 5.46,
      "integrity": 115,
      "stats": {
        "brokenregen": 2.3,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1013,
        "maxmul": 2,
        "minmass": 203,
        "minmul": 1,
        "optmass": 405,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 199747,
      "mass": 40,
      "power": 1.86,
      "integrity": 90,
      "stats": {
        "brokenregen": 5.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.3,
        "minmass": 270,
        "minmul": 0.3,
        "optmass": 540,
        "optmul": 0.8,
        "regen": 1.3,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 599242,
      "mass": 16,
      "power": 2.48,
      "integrity": 68,
      "stats": {
        "brokenregen": 5.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.4,
        "minmass": 270,
        "minmul": 0.4,
        "optmass": 540,
        "optmul": 0.9,
        "regen": 1.3,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1797726,
      "mass": 40,
      "power": 3.1,
      "integrity": 113,
      "stats": {
        "brokenregen": 5.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.5,
        "minmass": 270,
        "minmul": 0.5,
        "optmass": 540,
        "optmul": 1,
        "regen": 1.3,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 2696589,
      "mass": 40,
      "power": 3.1,
      "integrity": 113,
      "stats": {
        "brokenregen": 8,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.4,
        "minmass": 270,
        "minmul": 0.4,
        "optmass": 540,
        "optmul": 0.9,
        "regen": 3.2,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 5393177,
      "mass": 64,
      "power": 3.72,
      "integrity": 158,
      "stats": {
        "brokenregen": 5.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.6,
        "minmass": 270,
        "minmul": 0.6,
        "optmass": 540,
        "optmul": 1.1,
        "regen": 1.3,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 16179531,
      "mass": 40,
      "power": 4.34,
      "integrity": 136,
      "stats": {
        "brokenregen": 5.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 1.7,
        "minmass": 270,
        "minmul": 0.7,
        "optmass": 540,
        "optmul": 1.2,
        "regen": 1.3,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size6_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 24269300,
      "mass": 80,
      "power": 6.51,
      "integrity": 136,
      "stats": {
        "brokenregen": 3.2,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 1350,
        "maxmul": 2,
        "minmass": 270,
        "minmul": 1,
        "optmass": 540,
        "optmul": 1.5,
        "regen": 1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 633199,
      "mass": 80,
      "power": 2.1,
      "integrity": 105,
      "stats": {
        "brokenregen": 7.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.3,
        "minmass": 530,
        "minmul": 0.3,
        "optmass": 1060,
        "optmul": 0.8,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 1899597,
      "mass": 32,
      "power": 2.8,
      "integrity": 79,
      "stats": {
        "brokenregen": 7.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.4,
        "minmass": 530,
        "minmul": 0.4,
        "optmass": 1060,
        "optmul": 0.9,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 5698790,
      "mass": 80,
      "power": 3.5,
      "integrity": 131,
      "stats": {
        "brokenregen": 7.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.5,
        "minmass": 530,
        "minmul": 0.5,
        "optmass": 1060,
        "optmul": 1,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 8548185,
      "mass": 80,
      "power": 3.5,
      "integrity": 131,
      "stats": {
        "brokenregen": 11,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.4,
        "minmass": 530,
        "minmul": 0.4,
        "optmass": 1060,
        "optmul": 0.9,
        "regen": 4.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 17096371,
      "mass": 128,
      "power": 4.2,
      "integrity": 183,
      "stats": {
        "brokenregen": 7.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.6,
        "minmass": 530,
        "minmul": 0.6,
        "optmass": 1060,
        "optmul": 1.1,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 51289112,
      "mass": 80,
      "power": 4.9,
      "integrity": 157,
      "stats": {
        "brokenregen": 7.33,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 1.7,
        "minmass": 530,
        "minmul": 0.7,
        "optmass": 1060,
        "optmul": 1.2,
        "regen": 1.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size7_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 76933670,
      "mass": 160,
      "power": 7.35,
      "integrity": 157,
      "stats": {
        "brokenregen": 4.2,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 2650,
        "maxmul": 2,
        "minmass": 530,
        "minmul": 1,
        "optmass": 1060,
        "optmul": 1.5,
        "regen": 1.1,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class1",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 2007241,
      "mass": 160,
      "power": 2.4,
      "integrity": 120,
      "stats": {
        "brokenregen": 9.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.3,
        "minmass": 900,
        "minmul": 0.3,
        "optmass": 1800,
        "optmul": 0.8,
        "regen": 2.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class2",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 6021722,
      "mass": 64,
      "power": 3.2,
      "integrity": 90,
      "stats": {
        "brokenregen": 9.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.4,
        "minmass": 900,
        "minmul": 0.4,
        "optmass": 1800,
        "optmul": 0.9,
        "regen": 2.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class3",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 18065165,
      "mass": 160,
      "power": 4,
      "integrity": 150,
      "stats": {
        "brokenregen": 9.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.5,
        "minmass": 900,
        "minmul": 0.5,
        "optmass": 1800,
        "optmul": 1,
        "regen": 2.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class3_Fast",
      "category": "internal",
      "name": "Bi-Weave Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bsg",
      "cost": 27097748,
      "mass": 160,
      "power": 4,
      "integrity": 150,
      "stats": {
        "brokenregen": 14.4,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.4,
        "minmass": 900,
        "minmul": 0.4,
        "optmass": 1800,
        "optmul": 0.9,
        "regen": 5.8,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class4",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 54195495,
      "mass": 256,
      "power": 4.8,
      "integrity": 210,
      "stats": {
        "brokenregen": 9.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.6,
        "minmass": 900,
        "minmul": 0.6,
        "optmass": 1800,
        "optmul": 1.1,
        "regen": 2.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class5",
      "category": "internal",
      "name": "Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "sg",
      "cost": 162586486,
      "mass": 160,
      "power": 5.6,
      "integrity": 180,
      "stats": {
        "brokenregen": 9.6,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 1.7,
        "minmass": 900,
        "minmul": 0.7,
        "optmass": 1800,
        "optmul": 1.2,
        "regen": 2.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_ShieldGenerator_Size8_Class5_Strong",
      "category": "internal",
      "name": "Prismatic Shield Generator",
      "ship": null,
      "class": 8,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "psg",
      "cost": 243879730,
      "mass": 320,
      "power": 8.4,
      "integrity": 180,
      "stats": {
        "brokenregen": 5.4,
        "distdraw": 0.6,
        "explres": 0.5,
        "kinres": 0.4,
        "maxmass": 4500,
        "maxmul": 2,
        "minmass": 900,
        "minmul": 1,
        "optmass": 1800,
        "optmul": 1.5,
        "regen": 1.4,
        "thermres": -0.2
      },
      "preEngineered": null
    },
    {
      "symbol": "Int_StellarBodyDiscoveryScanner_Advanced",
      "category": "internal",
      "name": "Advanced Discovery Scanner",
      "ship": null,
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_StellarBodyDiscoveryScanner_Intermediate",
      "category": "internal",
      "name": "Intermediate Discovery Scanner",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_StellarBodyDiscoveryScanner_Standard",
      "category": "internal",
      "name": "Basic Discovery Scanner",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_StellarBodyDiscoveryScanner_Standard_free",
      "category": "internal",
      "name": "Basic Discovery Scanner",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Int_SupercruiseAssist",
      "category": "internal",
      "name": "Supercruise Assist",
      "ship": null,
      "class": 1,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "sua",
      "cost": 9121,
      "mass": 0,
      "power": 0.3,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Krait_Light_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Krait Phantom",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_Light_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Krait Phantom",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 14988900,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_Light_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Krait Phantom",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 33725026,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_Light_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Krait Phantom",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 79703480,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_Light_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Krait Phantom",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 88322097,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_MkII_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Krait MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_MkII_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Krait MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 18325682,
      "mass": 36,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_MkII_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Krait MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 41232784,
      "mass": 67,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_MkII_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Krait MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 97446814,
      "mass": 67,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Krait_MkII_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Krait MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 88322097,
      "mass": 67,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "LakonMiner_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-11 Prospector",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "LakonMiner_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-11 Prospector",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 27144740,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "LakonMiner_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-11 Prospector",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 61075670,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "LakonMiner_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-11 Prospector",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 144342150,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "LakonMiner_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-11 Prospector",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 159950380,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mamba_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Mamba",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mamba_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Mamba",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 22346816,
      "mass": 19,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mamba_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Mamba",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 50280336,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mamba_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Mamba",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 118829194,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mamba_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Mamba",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 131678613,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mandalay_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Mandalay",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mandalay_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Mandalay",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 6191367,
      "mass": 19,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mandalay_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Mandalay",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 13930575,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mandalay_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Mandalay",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 32922590,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Mandalay_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Mandalay",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 36482626,
      "mass": 38,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "MediumTransport01_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Lynx Highliner",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "MediumTransport01_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Lynx Highliner",
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "MediumTransport01_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Lynx Highliner",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "MediumTransport01_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Lynx Highliner",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "MediumTransport01_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Lynx Highliner",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Orca_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Orca",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Orca_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Orca",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 19415954,
      "mass": 21,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Orca_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Orca",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 43685898,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Orca_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Orca",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 103244339,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Orca_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Orca",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 114408513,
      "mass": 87,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "PantherMkII_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Panther Clipper MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "PantherMkII_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Panther Clipper MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 120839434,
      "mass": 75,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "PantherMkII_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Panther Clipper MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 271213728,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "PantherMkII_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Panther Clipper MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 632832030,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "PantherMkII_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Panther Clipper MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 710278615,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Python",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Python",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 22791271,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Python",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 51280361,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Python",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 121192586,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Python",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 134297567,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_NX_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Python MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_NX_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Python MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 23702103,
      "mass": 26,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_NX_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Python MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 53329732,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_NX_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Python MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 126035933,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Python_NX_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Python MkII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 139664643,
      "mass": 53,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SideWinder_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Sidewinder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SideWinder_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Sidewinder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 25600,
      "mass": 2,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SideWinder_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Sidewinder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 80320,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SideWinder_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Sidewinder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 132064,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SideWinder_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Sidewinder",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 139424,
      "mass": 4,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SmallCombat01_NX_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Kestrel Mk II",
      "class": 1,
      "rating": "C",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SmallCombat01_NX_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Kestrel Mk II",
      "class": 1,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1970246,
      "mass": 17,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SmallCombat01_NX_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Kestrel Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 4433053,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SmallCombat01_NX_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Kestrel Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 10476783,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "SmallCombat01_NX_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Kestrel Mk II",
      "class": 1,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 11609674,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type6_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-6 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type6_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-6 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 418378,
      "mass": 12,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type6_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-6 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 941350,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type6_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-6 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2224725,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type6_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-6 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 2465292,
      "mass": 23,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type7_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-7 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type7_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-7 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 6988900,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type7_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-7 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 15725026,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type7_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-7 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 37163480,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type7_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-7 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 41182097,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type8_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-8 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type8_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-8 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 15381590,
      "mass": 32,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type8_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-8 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 34608570,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type8_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-8 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 37163480,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type8_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-8 Transporter",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 90636000,
      "mass": 63,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-9 Heavy",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-9 Heavy",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 30622336,
      "mass": 75,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-9 Heavy",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 68900257,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-9 Heavy",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 162834275,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-9 Heavy",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 180442119,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Military_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Type-10 Defender",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Military_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Type-10 Defender",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 49902136,
      "mass": 75,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Military_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Type-10 Defender",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 112279807,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Military_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Type-10 Defender",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 265354612,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Type9_Military_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Type-10 Defender",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 294048341,
      "mass": 150,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_2_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Alliance Crusader",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_2_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Alliance Crusader",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 9146536,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_2_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Alliance Crusader",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 20579706,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_2_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Alliance Crusader",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 48636707,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_2_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Alliance Crusader",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 53895965,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_3_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Alliance Challenger",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_3_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Alliance Challenger",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 12188900,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_3_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Alliance Challenger",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 27425026,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_3_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Alliance Challenger",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 64814480,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_3_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Alliance Challenger",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 71823097,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Alliance Chieftain",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Alliance Chieftain",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 7752900,
      "mass": 40,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Alliance Chieftain",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 17444026,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Alliance Chieftain",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 41226050,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "TypeX_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Alliance Chieftain",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 45683967,
      "mass": 78,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Viper_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Viper MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Viper_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Viper MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Viper_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Viper MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Viper_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Viper MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Viper_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Viper MkIII",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": null,
      "mass": null,
      "power": null,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    },
    {
      "symbol": "Viper_MkIV_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Viper MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Viper_MkIV_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Viper MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 175172,
      "mass": 5,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Viper_MkIV_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Viper MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 394137,
      "mass": 9,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Viper_MkIV_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Viper MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 931479,
      "mass": 9,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Viper_MkIV_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Viper MkIV",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1032203,
      "mass": 9,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Vulture_Armour_Grade1",
      "category": "standard",
      "name": "Lightweight Alloy",
      "ship": "Vulture",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 0.8,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Vulture_Armour_Grade2",
      "category": "standard",
      "name": "Reinforced Alloy",
      "ship": "Vulture",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 1970246,
      "mass": 17,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 1.52,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Vulture_Armour_Grade3",
      "category": "standard",
      "name": "Military Grade Composite",
      "ship": "Vulture",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 4433053,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.2,
        "thermres": 0,
        "explres": -0.4,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Vulture_Armour_Mirrored",
      "category": "standard",
      "name": "Mirrored Surface Composite",
      "ship": "Vulture",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 10476783,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": -0.75,
        "thermres": 0.5,
        "explres": -0.5,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Vulture_Armour_Reactive",
      "category": "standard",
      "name": "Reactive Surface Composite",
      "ship": "Vulture",
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "bh",
      "cost": 11609674,
      "mass": 35,
      "power": null,
      "integrity": null,
      "stats": {
        "hullboost": 2.5,
        "kinres": 0.25,
        "thermres": -0.4,
        "explres": 0.2,
        "causres": 0
      },
      "preEngineered": null
    },
    {
      "symbol": "Hpt_Mining_AbrBlstr_Fixed_Small__pre_6a",
      "category": "hardpoint",
      "name": "Abr Blast (LR)",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "abl",
      "cost": 9700,
      "mass": 1.82,
      "power": 0.17,
      "integrity": 40,
      "stats": {
        "breachdmg": 0.6,
        "breachmax": 0.2,
        "shotspeed": 2779,
        "breachmin": 0.1,
        "damage": 4,
        "chargetime": 0,
        "distdraw": 2,
        "falloff": 4000,
        "fireint": 0.2,
        "clip": 1,
        "reload": 2,
        "piercing": 18,
        "range": 4180,
        "thermload": 1.8
      },
      "preEngineered": {
        "sourceId": "6A",
        "grade": 1,
        "blueprints": [
          "Weapon_LongRange"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 1 Long Range modifications."
      }
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Medium__pre_5w",
      "category": "hardpoint",
      "name": "AX MRack (HCap+RFire)",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 540900,
      "mass": 4.25,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 64,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 8,
        "damage": 71.5,
        "distdraw": 0.112,
        "falloff": 10000,
        "fireint": 3.045,
        "piercing": 60,
        "reload": 7.85,
        "shotspeed": 750,
        "thermload": 2.4
      },
      "preEngineered": {
        "sourceId": "5w",
        "grade": 5,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 High Capacity and Rapid Fire modifications."
      }
    },
    {
      "symbol": "Hpt_ATDumbfireMissile_Fixed_Large__pre_5x",
      "category": "hardpoint",
      "name": "AX MRack (HCap+RFire)",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "axmr",
      "cost": 0,
      "mass": 8.5,
      "power": 1.62,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 128,
        "breachdmg": 0.1,
        "breachmax": 0.8,
        "breachmin": 1,
        "clip": 12,
        "damage": 71.5,
        "distdraw": 0.192,
        "falloff": 10000,
        "fireint": 3.045,
        "piercing": 60,
        "reload": 7.85,
        "shotspeed": 750,
        "thermload": 3.6
      },
      "preEngineered": {
        "sourceId": "5x",
        "grade": 5,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 High Capacity and Rapid Fire modifications."
      }
    },
    {
      "symbol": "Hpt_ATMultiCannon_Gimbal_Medium__pre_5y",
      "category": "hardpoint",
      "name": "AX MC (OC, Auto-Load)",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Gimballed",
      "guidance": null,
      "group": "axmce",
      "cost": 1197644,
      "mass": 4,
      "power": 0.805,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 3.1,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 2.4,
        "distdraw": 0.11,
        "falloff": 2000,
        "fireint": 0.14,
        "piercing": 17,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.18
      },
      "preEngineered": {
        "sourceId": "5y",
        "grade": 5,
        "blueprints": [
          "Weapon_Overcharged"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Overcharged modifications and Auto-Loader experimental."
      }
    },
    {
      "symbol": "Hpt_ATMultiCannon_Gimbal_Large__pre_5z",
      "category": "hardpoint",
      "name": "AX MC (OC, Auto-Load)",
      "ship": null,
      "class": 3,
      "rating": "C",
      "mount": "Gimballed",
      "guidance": null,
      "group": "axmce",
      "cost": 2390460,
      "mass": 8,
      "power": 1.12,
      "integrity": 64,
      "stats": {
        "experimental": true,
        "ammo": 2100,
        "breachdmg": 5.2,
        "breachmax": 0.5,
        "breachmin": 0.8,
        "clip": 100,
        "damage": 4.065,
        "distdraw": 0.18,
        "falloff": 2000,
        "fireint": 0.17,
        "piercing": 33,
        "range": 4000,
        "reload": 4,
        "shotspeed": 4000,
        "thermload": 0.28
      },
      "preEngineered": {
        "sourceId": "5z",
        "grade": 5,
        "blueprints": [
          "Weapon_Overcharged"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Overcharged modifications and Auto-Loader experimental."
      }
    },
    {
      "symbol": "Hpt_CausticMissile_Fixed_Medium__pre_5z",
      "category": "hardpoint",
      "name": "Caust Enzyme (High Cap)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Dumbfire",
      "group": "tbem",
      "cost": 480501,
      "mass": 4,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "experimental": true,
        "fireint": 2,
        "damage": 5,
        "distdraw": 0.08,
        "thermload": 1.5,
        "piercing": 60,
        "shotspeed": 750,
        "clip": 7,
        "ammo": 40,
        "reload": 5,
        "breachdmg": 0,
        "breachmin": 0.8,
        "breachmax": 1
      },
      "preEngineered": {
        "sourceId": "5Z",
        "grade": 1,
        "blueprints": [
          "Weapon_HighCapacity"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 High Cap modifications."
      }
    },
    {
      "symbol": "Hpt_Guardian_GaussCannon_Fixed_Small__pre_6e",
      "category": "hardpoint",
      "name": "Gauss (HCap + RFire)",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ggc",
      "cost": 0,
      "mass": 2,
      "power": 1.91,
      "integrity": 40,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 11,
        "breachmax": 0.4,
        "breachmin": 0.2,
        "clip": 2,
        "damage": 9.6,
        "distdraw": 3.8,
        "falloff": 1200,
        "fireint": 1.15,
        "piercing": 140,
        "range": 3000,
        "reload": 2.87,
        "thermload": 15
      },
      "preEngineered": {
        "sourceId": "6E",
        "grade": 1,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 1 High Capacity and Rapid Fire modifications."
      }
    },
    {
      "symbol": "Hpt_Guardian_GaussCannon_Fixed_Medium__pre_6f",
      "category": "hardpoint",
      "name": "Gauss (HCap + RFire)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "ggc",
      "cost": 0,
      "mass": 4,
      "power": 2.61,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 35,
        "breachmax": 0.4,
        "breachmin": 0.2,
        "burst": 1,
        "clip": 2,
        "damage": 18.3,
        "distdraw": 7.2,
        "falloff": 1200,
        "fireint": 1.15,
        "piercing": 140,
        "range": 3000,
        "reload": 2.87,
        "thermload": 25
      },
      "preEngineered": {
        "sourceId": "6F",
        "grade": 1,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 1 High Capacity and Rapid Fire modifications."
      }
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Fixed_Small__pre_6g",
      "category": "hardpoint",
      "name": "Plasma Charger (OC+Foc)",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "gpc",
      "cost": 0,
      "mass": 2,
      "power": 1.4,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.4,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 3,
        "distdraw": 0.68,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 65,
        "range": 3000,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 4.2
      },
      "preEngineered": {
        "sourceId": "6G",
        "grade": 1,
        "blueprints": [
          "Weapon_Overcharged",
          "Weapon_Focused"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 1 Overcharged and Focused modifications."
      }
    },
    {
      "symbol": "Hpt_Guardian_PlasmaLauncher_Fixed_Medium__pre_6h",
      "category": "hardpoint",
      "name": "Plasma Charger (OC+Foc)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": null,
      "group": "gpc",
      "cost": 0,
      "mass": 4,
      "power": 2.13,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "ammo": 200,
        "breachdmg": 0.7,
        "breachmax": 0.8,
        "breachmin": 0.5,
        "clip": 15,
        "damage": 5,
        "distdraw": 1.25,
        "falloff": 1000,
        "fireint": 0.2,
        "piercing": 80,
        "range": 3500,
        "reload": 3,
        "shotspeed": 1200,
        "thermload": 5.2
      },
      "preEngineered": {
        "sourceId": "6H",
        "grade": 1,
        "blueprints": [
          "Weapon_Overcharged",
          "Weapon_Focused"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 1 Overcharged and Focused modifications."
      }
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Small__pre_6i",
      "category": "hardpoint",
      "name": "Shard (OC+Foc+SPen)",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 0,
      "mass": 2,
      "power": 0.87,
      "integrity": 34,
      "stats": {
        "experimental": true,
        "damage": 2,
        "distdraw": 0.42,
        "fireint": 0.6,
        "thermload": 0.7,
        "piercing": 30,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 1.6,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": {
        "sourceId": "6I",
        "grade": 1,
        "blueprints": [
          "Weapon_LongRange",
          "Weapon_Focused"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 1 LongRange and Focused modifications with Super Penetrator Experimental."
      }
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Medium__pre_6j",
      "category": "hardpoint",
      "name": "Shard (OC+Foc+SPen)",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 0,
      "mass": 4,
      "power": 1.21,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "damage": 3.7,
        "distdraw": 0.65,
        "fireint": 0.6,
        "thermload": 1.2,
        "piercing": 45,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 3,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": {
        "sourceId": "6J",
        "grade": 1,
        "blueprints": [
          "Weapon_LongRange",
          "Weapon_Focused"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 1 LongRange and Focused modifications with Super Penetrator Experimental."
      }
    },
    {
      "symbol": "Hpt_Guardian_ShardCannon_Fixed_Medium__pre_6k",
      "category": "hardpoint",
      "name": "Shard (Long Range)",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": "Fixed",
      "guidance": null,
      "group": "gsc",
      "cost": 0,
      "mass": 4,
      "power": 1.21,
      "integrity": 42,
      "stats": {
        "experimental": true,
        "damage": 3.7,
        "distdraw": 0.65,
        "fireint": 0.6,
        "thermload": 1.2,
        "piercing": 45,
        "range": 1700,
        "shotspeed": 1133,
        "roundspershot": 12,
        "clip": 5,
        "ammo": 180,
        "reload": 5,
        "breachdmg": 3,
        "breachmin": 0.6,
        "breachmax": 0.8,
        "jitter": 5,
        "falloff": 1700
      },
      "preEngineered": {
        "sourceId": "6K",
        "grade": 5,
        "blueprints": [
          "Weapon_LongRange"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 LongRange modifications."
      }
    },
    {
      "symbol": "Hpt_MiningLaser_Fixed_Small__pre_5y",
      "category": "hardpoint",
      "name": "Mining Laser V1",
      "ship": null,
      "class": 1,
      "rating": "D",
      "mount": "Fixed",
      "guidance": null,
      "group": "ml",
      "cost": 0,
      "mass": 2,
      "power": 0.25,
      "integrity": 20,
      "stats": {
        "breachdmg": 0.3,
        "breachmax": 0.2,
        "breachmin": 0.1,
        "damage": 2,
        "distdraw": 0.75,
        "falloff": 1250,
        "piercing": 18,
        "range": 1250,
        "thermload": 2
      },
      "preEngineered": {
        "sourceId": "5Y",
        "grade": 5,
        "blueprints": [
          "Weapon_LongRange"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Long Range modifications and Incendiary Rounds Experimental."
      }
    },
    {
      "symbol": "Hpt_HeatSinkLauncher_Turret_Tiny__pre_5w",
      "category": "utility",
      "name": "Heat Sink Launcher (Sirius)",
      "ship": null,
      "class": 0,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "hs",
      "cost": 0,
      "mass": 0.65,
      "power": 0.2,
      "integrity": 20,
      "stats": {
        "ammo": 3,
        "ammocost": 25,
        "clip": 1,
        "distdraw": 2,
        "drain": 100,
        "duration": 10,
        "eps": 0.4,
        "fireint": 5,
        "passive": 1,
        "reload": 10
      },
      "preEngineered": {
        "sourceId": "5W",
        "grade": 1,
        "blueprints": [
          "Misc_HeatSinkCapacity"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 1 Expanded Heat Sink Capacity modifications."
      }
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium__pre_5x",
      "category": "hardpoint",
      "name": "V1 Seek (HCap+LW+TC)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 0,
      "mass": 0.57,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 40,
        "distdraw": 0.24,
        "eps": 0.07,
        "fireint": 3,
        "hps": 1.08,
        "piercing": 60,
        "reload": 12,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": {
        "sourceId": "5X",
        "grade": 5,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_LightWeight"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 High Cap, Lightweight modifications and Thermal Cascade Experimental Effect."
      }
    },
    {
      "symbol": "Hpt_BasicMissileRack_Fixed_Medium__pre_6b",
      "category": "hardpoint",
      "name": "Seek (HCap+RF+Drag)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": "Fixed",
      "guidance": "Seeker",
      "group": "mr",
      "cost": 0,
      "mass": 6.25,
      "power": 1.2,
      "integrity": 51,
      "stats": {
        "ammo": 18,
        "breachdmg": 16,
        "breachmax": 0,
        "breachmin": 0,
        "clip": 6,
        "damage": 42.1,
        "distdraw": 0.34,
        "eps": 0.07,
        "fireint": 5.2,
        "hps": 1.08,
        "piercing": 60,
        "reload": 34.28,
        "shotspeed": 625,
        "thermload": 3.6
      },
      "preEngineered": {
        "sourceId": "6B",
        "grade": 1,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 High Cap, Rapid Fire modifications and Drag Munitions Experimental Effect."
      }
    },
    {
      "symbol": "Hpt_Railgun_Fixed_Medium__pre_6c",
      "category": "hardpoint",
      "name": "Railgun (HCap+LR+FCasc)",
      "ship": null,
      "class": 2,
      "rating": "B",
      "mount": null,
      "guidance": null,
      "group": "rg",
      "cost": 0,
      "mass": 4,
      "power": 2.6895,
      "integrity": 51,
      "stats": {
        "ammo": 80,
        "breachdmg": 39.5,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "charge": 1.2,
        "clip": 1,
        "damage": 41.5,
        "distdraw": 5.11,
        "falloff": 1000,
        "fireint": 0.36,
        "piercing": 100,
        "range": 3000,
        "reload": 1.25,
        "thermload": 20
      },
      "preEngineered": {
        "sourceId": "6C",
        "grade": 5,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_LongRange"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 High Cap & Long Range modifications, and Feedback Cascade Experimental Effect."
      }
    },
    {
      "symbol": "Hpt_MultiCannon_Fixed_Medium__pre_6d",
      "category": "hardpoint",
      "name": "MC (HCap+RFire+Phase)",
      "ship": null,
      "class": 2,
      "rating": "E",
      "mount": "Fixed",
      "guidance": null,
      "group": "mc",
      "cost": 0,
      "mass": 3.33,
      "power": 0.46,
      "integrity": 51,
      "stats": {
        "ammo": 4706,
        "breachdmg": 2,
        "breachmax": 0.8,
        "breachmin": 0.4,
        "clip": 294,
        "damage": 2.15,
        "distdraw": 0.11,
        "falloff": 1800,
        "fireint": 0.1115,
        "piercing": 37,
        "range": 2000,
        "reload": 5.33,
        "shotspeed": 1600,
        "thermload": 0.18
      },
      "preEngineered": {
        "sourceId": "6D",
        "grade": 1,
        "blueprints": [
          "Weapon_HighCapacity",
          "Weapon_RapidFire"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 High Cap & Rapid Fire modifications, and Phasing Sequence Experimental Effect."
      }
    },
    {
      "symbol": "Int_CargoRack_Size5_Class1__pre_7x",
      "category": "internal",
      "name": "Expanded Capacity Cargo Rack",
      "ship": null,
      "class": 5,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 32
      },
      "preEngineered": {
        "sourceId": "7X",
        "grade": 5,
        "blueprints": [
          "CargoRack_IncreasedCapacity"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 Expanded Capacity.",
        "availability": "CG"
      }
    },
    {
      "symbol": "Int_CargoRack_Size6_Class1__pre_7y",
      "category": "internal",
      "name": "Expanded Capacity Cargo Rack",
      "ship": null,
      "class": 6,
      "rating": "E",
      "mount": null,
      "guidance": null,
      "group": "cr",
      "cost": 0,
      "mass": 0,
      "power": null,
      "integrity": null,
      "stats": {
        "cargo": 64
      },
      "preEngineered": {
        "sourceId": "7Y",
        "grade": 5,
        "blueprints": [
          "CargoRack_IncreasedCapacity"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 Expanded Capacity.",
        "availability": "CG"
      }
    },
    {
      "symbol": "Int_Hyperdrive_Size5_Class5__pre_5o",
      "category": "standard",
      "name": "V1 Frame Shift Drive",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 0,
      "mass": 20,
      "power": 0.6,
      "integrity": 120,
      "stats": {
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5,
        "optmass": 1050
      },
      "preEngineered": {
        "sourceId": "5O",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size7_Class5__pre_5p",
      "category": "standard",
      "name": "V1 Frame Shift Drive (SCO)",
      "ship": null,
      "class": 7,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 61546935,
      "mass": 80,
      "power": 0.9,
      "integrity": 164,
      "stats": {
        "boot": 2,
        "fuelmul": 0.013,
        "fuelpower": 2.75,
        "maxfuel": 13.1,
        "optmass": 3000
      },
      "preEngineered": {
        "sourceId": "5P",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size6_Class5__pre_5q",
      "category": "standard",
      "name": "Frame Shift Drive (SCO) V1",
      "ship": null,
      "class": 6,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 19415437,
      "purchaseCurrency": "merc-coin",
      "mass": 40,
      "power": 0.75,
      "integrity": 141,
      "stats": {
        "boot": 2,
        "fuelmul": 0.013,
        "fuelpower": 2.6,
        "maxfuel": 8.3,
        "optmass": 2000
      },
      "preEngineered": {
        "sourceId": "5Q",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size5_Class5__pre_5r",
      "category": "standard",
      "name": "Frame Shift Drive (SCO) V1",
      "ship": null,
      "class": 5,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 6124743,
      "purchaseCurrency": "merc-coin",
      "mass": 20,
      "power": 0.6,
      "integrity": 120,
      "stats": {
        "boot": 2,
        "fuelmul": 0.012,
        "fuelpower": 2.45,
        "maxfuel": 5.2,
        "optmass": 1175
      },
      "preEngineered": {
        "sourceId": "5R",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size4_Class5__pre_5s",
      "category": "standard",
      "name": "Frame Shift Drive (SCO) V1",
      "ship": null,
      "class": 4,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 1932096,
      "purchaseCurrency": "merc-coin",
      "mass": 10,
      "power": 0.45,
      "integrity": 100,
      "stats": {
        "boot": 2,
        "fuelmul": 0.013,
        "fuelpower": 2.3,
        "maxfuel": 3.2,
        "optmass": 585
      },
      "preEngineered": {
        "sourceId": "5S",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size3_Class5__pre_5t",
      "category": "standard",
      "name": "Frame Shift Drive (SCO) V1",
      "ship": null,
      "class": 3,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 609494,
      "purchaseCurrency": "merc-coin",
      "mass": 5,
      "power": 0.45,
      "integrity": 80,
      "stats": {
        "boot": 2,
        "fuelmul": 0.013,
        "fuelpower": 2.15,
        "maxfuel": 1.9,
        "optmass": 167
      },
      "preEngineered": {
        "sourceId": "5T",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_Hyperdrive_Overcharge_Size2_Class5__pre_5u",
      "category": "standard",
      "name": "Frame Shift Drive (SCO) V1",
      "ship": null,
      "class": 2,
      "rating": "A",
      "mount": null,
      "guidance": null,
      "group": "fsd",
      "cost": 192269,
      "purchaseCurrency": "merc-coin",
      "mass": 2.5,
      "power": 0.3,
      "integrity": 64,
      "stats": {
        "boot": 2,
        "fuelmul": 0.013,
        "fuelpower": 2,
        "maxfuel": 1,
        "optmass": 100
      },
      "preEngineered": {
        "sourceId": "5U",
        "grade": 5,
        "blueprints": [
          "FSD_LongRange",
          "FSD_FastBoot"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": true,
        "description": "This module has been pre-engineered with Grade 5 Increased Range and Faster Boot Sequence modifications."
      }
    },
    {
      "symbol": "Int_DetailedSurfaceScanner_Tiny__pre_5v",
      "category": "internal",
      "name": "Detailed Surface Scanner V1",
      "ship": null,
      "class": 1,
      "rating": "I",
      "mount": null,
      "guidance": null,
      "group": "ss",
      "cost": 0,
      "mass": 0,
      "power": 0,
      "integrity": null,
      "stats": {
        "proberadius": 0.2
      },
      "preEngineered": {
        "sourceId": "5V",
        "grade": 1,
        "blueprints": [
          "Sensor_Expanded"
        ],
        "reengineerable": false,
        "gradeChangeable": false,
        "canApplyExperimental": false,
        "description": "This module has been pre-engineered with Grade 5 Expanded Probe Radius modifications."
      }
    },
    {
      "symbol": "ModularCargoBayDoor",
      "category": "fixed",
      "name": "Cargo Hatch",
      "ship": null,
      "class": 1,
      "rating": "H",
      "mount": null,
      "guidance": null,
      "group": null,
      "cost": 0,
      "mass": null,
      "power": 0.6,
      "integrity": null,
      "stats": {},
      "preEngineered": null
    }
  ]
}
